/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AOnboardingStatuses {
  ShareKnowledge = "share_knowledge",
  AddKeyDetails = "add_key_details",
  RequestSalesTalents = "request_sales_talents",
}

export enum AOwnershipLevels {
  CloseRocket = "close_rocket",
  Company = "company",
  SalesPerson = "sales_person",
}

export enum ASalesCycleIterationStatuses {
  Active = "active",
  Finished = "finished",
  Declined = "declined",
  Matching = "matching",
  Acceptance = "acceptance",
  ReadyToStart = "ready_to_start",
  Created = "created",
}

export enum AUserTypes {
  SalesPerson = "SalesPerson",
  CompanyUser = "CompanyUser",
  Admin = "Admin",
  SaasCompanyUser = "SaasCompanyUser",
  SaasSalesPerson = "SaasSalesPerson",
}

export enum ADashboardStages {
  FirstOutreach = "first_outreach",
  SecondOutreach = "second_outreach",
  PresentationDemo = "presentation_demo",
  Closing = "closing",
}

export enum ASalesStatisticPeriodValues {
  Day = "day",
  Month = "month",
}

export enum ASalesPlanQueryStatusValues {
  Starting = "starting",
  InProgress = "in_progress",
  Stopped = "stopped",
  Declined = "declined",
}

export enum ASalesPlanSortByValues {
  CreatedAt = "created_at",
  CurrentValue = "current_value",
}

export enum ASalesPlanSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ASalesCycleSalesFlows {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export enum ASalesCycleYearsOfMarkets {
  Zero = "zero",
  One = "one",
  Two = "two",
  ThreeAndMore = "three_and_more",
}

export enum ASalesCycleIdealCustomerProfiles {
  Small = "small",
  Middle = "middle",
  Corporation = "corporation",
}

export enum ASalesCycleStatuses {
  Draft = "draft",
  Created = "created",
  Ongoing = "ongoing",
  Paused = "paused",
  Finished = "finished",
}

export enum ASalesCycleSegment {
  Fmcg = "fmcg",
  Finance = "finance",
  Retail = "retail",
  FoodIndustry = "food_industry",
  Marketing = "marketing",
  ECommerce = "e_commerce",
  Corporate = "corporate",
}

export enum AKlaraDashboardDealSortByValues {
  Title = "title",
  Priority = "priority",
  StageDays = "stage_days",
  NextActivity = "next_activity",
}

export enum AKlaraDashboardDealChipValues {
  Missing = "missing",
  Overdue = "overdue",
  Planned = "planned",
  Rotten = "rotten",
  Won = "won",
  Lost = "lost",
}

export enum AKlaraDashboardDealViewValues {
  Attention = "attention",
  All = "all",
  High = "high",
  Rotten = "rotten",
  Closed = "closed",
}

export enum AKlaraDashboardLifecycleStatusValues {
  Open = "open",
  Won = "won",
  Lost = "lost",
}

export enum AKlaraDashboardGranularityValues {
  Day = "day",
  Week = "week",
  Month = "month",
}

export enum ASalesAssistantUpdateCenterStepTypeValues {
  Stage = "stage",
  ActivityDone = "activity_done",
  ActivityCreate = "activity_create",
  Note = "note",
  ActivityReschedule = "activity_reschedule",
  DealWon = "deal_won",
  DealLost = "deal_lost",
}

export enum ASalesAssistantUpdateCenterEntryTypeValues {
  Voice = "voice",
  Assistant = "assistant",
  CrmSystem = "crm_system",
}

export enum ASalesAssistantTaskStatuses {
  NotStarted = "not_started",
  Completed = "completed",
}

export enum ASalesAssistantDealStatuses {
  Open = "open",
  Won = "won",
  Lost = "lost",
  Deleted = "deleted",
}

export enum ASalesAssistantCreateTaskTypes {
  Email = "email",
  Call = "call",
  Meeting = "meeting",
}

export enum ASalesAssistantNextSteps {
  Call = "call",
  Email = "email",
  Meeting = "meeting",
  Won = "won",
  Lost = "lost",
  Nothing = "nothing",
}

export enum ASalesAssistantDealPlannedTaskTypes {
  Email = "email",
  Call = "call",
  Meeting = "meeting",
  WithoutTask = "without_task",
}

export enum ASalesAssistantDealSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ASalesAssistantDealSortByValues {
  PlannedTask = "planned_task",
  Priority = "priority",
  Title = "title",
  SellingTitle = "selling_title",
}

export enum ASalesAssistantTaskTypes {
  SalesAssistantTasksEmail = "SalesAssistant::Tasks::Email",
  SalesAssistantTasksCall = "SalesAssistant::Tasks::Call",
  SalesAssistantTasksMeeting = "SalesAssistant::Tasks::Meeting",
  SalesAssistantTasksOther = "SalesAssistant::Tasks::Other",
}

export enum ASalesAssistantDealPriorities {
  Low = "low",
  Medium = "medium",
  High = "high",
}

export enum ASaasSalesCycleSortByValues {
  CreatedAt = "created_at",
  Name = "name",
}

export enum ASaasSalesCycleSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ASaasCompanyUserListItemStatus {
  Active = "active",
  Deactivated = "deactivated",
  Invited = "invited",
}

export enum ASaasCompanyUserListItemRole {
  Owner = "owner",
  Admin = "admin",
  SalesPerson = "sales_person",
}

export enum AProspectLastChangeRanges {
  TwentyFourHours = "twenty_four_hours",
  ThreeDays = "three_days",
  SevenDays = "seven_days",
  FourteenDays = "fourteen_days",
  TwentyOneDays = "twenty_one_days",
}

export enum ASalesCycleProspectAutocompleteFields {
  Segment = "segment",
}

export enum ASalesCycleProspectStatuses {
  Won = "won",
  Lost = "lost",
  Opened = "opened",
  Migrated = "migrated",
}

export enum ASalesCycleFilterStages {
  FirstOutreach = "First outreach",
  SecondOutreach = "Second outreach",
  PresentationDemo = "Presentation / Demo",
  Followup1 = "Followup1",
  Followup2 = "Followup2",
  Followup3 = "Followup3",
  FutureContact = "Future contact",
  PriceOffer = "Price offer",
  EmailingStage = "Emailing stage",
  CallingStage = "Calling stage",
  MeetingStage = "Meeting stage",
  Future = "Future",
}

export enum ASalesCycleProspectStages {
  FirstOutreach = "First outreach",
  SecondOutreach = "Second outreach",
  PresentationDemo = "Presentation / Demo",
  Followup1 = "Followup1",
  Followup2 = "Followup2",
  Followup3 = "Followup3",
  FutureContact = "Future contact",
  PriceOffer = "Price offer",
}

export enum ASalesCyclesProspectValues {
  OrganizationName = "organization_name",
}

export enum ACompanyProspectSortByValues {
  OrganizationName = "organization_name",
  City = "city",
  Prioritized = "prioritized",
}

export enum AProspectQueryStatusValues {
  Rejected = "rejected",
  WithWarnings = "with_warnings",
}

export enum AProspectSortByValues {
  OrganizationName = "organization_name",
  Position = "position",
  City = "city",
  Email = "email",
}

export enum AProspectSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum AProspectAutoEnrichmentStatuses {
  Enriched = "enriched",
  InProgress = "in_progress",
  EnrichmentFailed = "enrichment_failed",
}

export enum AProspectProcessingStatuses {
  Waiting = "waiting",
  Assigned = "assigned",
  Used = "used",
}

export enum AProspectApprovalStatuses {
  NotApproved = "not_approved",
  Approved = "approved",
  Disapproved = "disapproved",
}

export enum AProspectStatuses {
  SalesPersonDraft = "sales_person_draft",
  Draft = "draft",
  ReadyToApprove = "ready_to_approve",
  Finished = "finished",
}

export enum AProspectDisapproveReasons {
  Cooperation = "cooperation",
  Competition = "competition",
  UnlikelyCooperate = "unlikely_cooperate",
  WrongSegment = "wrong_segment",
  UnfitSize = "unfit_size",
  NotContact = "not_contact",
  Other = "other",
}

export enum ACommissionValueTypes {
  Percentage = "percentage",
  FixedPrice = "fixed_price",
}

export enum ACommissionTypes {
  OneOff = "one_off",
  Recurring = "recurring",
}

export enum AGoals {
  SetupMeeting = "setup_meeting",
  Registration = "registration",
  ContractConclusion = "contract_conclusion",
  CloseDeal = "close_deal",
}

export enum AInvoiceProviders {
  Stripe = "stripe",
  Internal = "internal",
  Superfaktura = "superfaktura",
}

export enum ASubscriptionBillingTypes {
  Month = "month",
  Year = "year",
}

export enum APaymentMethods {
  Undefined = "undefined",
  Card = "card",
  BankTransfer = "bank_transfer",
}

export enum AOrderStatuses {
  Created = "created",
  Confirmed = "confirmed",
  InProgress = "in_progress",
  Paid = "paid",
  Failed = "failed",
  Canceled = "canceled",
}

export enum ALeadDeleteStrategies {
  Gdpr = "gdpr",
  BadLead = "bad_lead",
  InvalidDetails = "invalid_details",
}

export enum ALeadSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ALeadSortByValues {
  OrganizationName = "organization_name",
  Position = "position",
  City = "city",
  Email = "email",
}

export enum ALeadAutocompleteFields {
  Position = "position",
  Segment = "segment",
  Country = "country",
  City = "city",
}

export enum ALeadCompanySizes {
  NotSpecified = "not_specified",
  Small = "small",
  Medium = "medium",
  Big = "big",
  Corporation = "corporation",
}

export enum AImporterStatuses {
  Waiting = "waiting",
  InProgress = "in_progress",
  Failed = "failed",
  DoneWithWarnings = "done_with_warnings",
  Done = "done",
  RolledBack = "rolled_back",
}

export enum ACompanySizesFilters {
  Value110 = "1,10",
  Value1120 = "11,20",
  Value2150 = "21,50",
  Value51100 = "51,100",
  Value101200 = "101,200",
  Value201500 = "201,500",
  Value5011000 = "501,1000",
  Value10001000000 = "1000,1000000",
}

export enum ASegmentsFilters {
  Accounting = "accounting",
  Agriculture = "agriculture",
  AirlinesAviation = "airlines/aviation",
  AlternativeDisputeResolution = "alternative dispute resolution",
  AlternativeMedicine = "alternative medicine",
  Animation = "animation",
  ApparelFashion = "apparel & fashion",
  ArchitecturePlanning = "architecture & planning",
  ArtsCrafts = "arts & crafts",
  Automotive = "automotive",
  AviationAerospace = "aviation & aerospace",
  Banking = "banking",
  Biotechnology = "biotechnology",
  BroadcastMedia = "broadcast media",
  BuildingMaterials = "building materials",
  BusinessSuppliesEquipment = "business supplies & equipment",
  CapitalMarkets = "capital markets",
  Chemicals = "chemicals",
  CivicSocialOrganization = "civic & social organization",
  CivilEngineering = "civil engineering",
  CommercialRealEstate = "commercial real estate",
  ComputerNetworkSecurity = "computer & network security",
  ComputerGames = "computer games",
  ComputerHardware = "computer hardware",
  ComputerNetworking = "computer networking",
  ComputerSoftware = "computer software",
  Construction = "construction",
  ConsumerElectronics = "consumer electronics",
  ConsumerGoods = "consumer goods",
  ConsumerServices = "consumer services",
  Cosmetics = "cosmetics",
  Dairy = "dairy",
  DefenseSpace = "defense & space",
  Design = "design",
  ELearning = "e-learning",
  EducationManagement = "education management",
  ElectricalElectronicManufacturing = "electrical/electronic manufacturing",
  Entertainment = "entertainment",
  EnvironmentalServices = "environmental services",
  EventsServices = "events services",
  ExecutiveOffice = "executive office",
  FacilitiesServices = "facilities services",
  Farming = "farming",
  FinancialServices = "financial services",
  FineArt = "fine art",
  Fishery = "fishery",
  FoodBeverages = "food & beverages",
  FoodProduction = "food production",
  FundRaising = "fund-raising",
  Furniture = "furniture",
  GamblingCasinos = "gambling & casinos",
  Glass = "glass",
  CeramicsConcrete = "ceramics & concrete",
  GovernmentAdministration = "government administration",
  GovernmentRelations = "government relations",
  GraphicDesign = "graphic design",
  Health = "health",
  WellnessFitness = "wellness & fitness",
  HigherEducation = "higher education",
  HospitalHealthCare = "hospital & health care",
  Hospitality = "hospitality",
  HumanResources = "human resources",
  ImportExport = "import & export",
  IndividualFamilyServices = "individual & family services",
  IndustrialAutomation = "industrial automation",
  InformationServices = "information services",
  InformationTechnologyServices = "information technology & services",
  Insurance = "insurance",
  InternationalAffairs = "international affairs",
  InternationalTradeDevelopment = "international trade & development",
  Internet = "internet",
  InvestmentBanking = "investment banking",
  InvestmentManagement = "investment management",
  Judiciary = "judiciary",
  LawEnforcement = "law enforcement",
  LawPractice = "law practice",
  LegalServices = "legal services",
  LegislativeOffice = "legislative office",
  Leisure = "leisure",
  TravelTourism = "travel & tourism",
  Libraries = "libraries",
  LogisticsSupplyChain = "logistics & supply chain",
  LuxuryGoodsJewelry = "luxury goods & jewelry",
  Machinery = "machinery",
  ManagementConsulting = "management consulting",
  Maritime = "maritime",
  MarketResearch = "market research",
  MarketingAdvertising = "marketing & advertising",
  MechanicalOrIndustrialEngineering = "mechanical or industrial engineering",
  MediaProduction = "media production",
  MedicalDevices = "medical devices",
  MedicalPractice = "medical practice",
  MentalHealthCare = "mental health care",
  Military = "military",
  MiningMetals = "mining & metals",
  MotionPicturesFilm = "motion pictures & film",
  MuseumsInstitutions = "museums & institutions",
  Music = "music",
  Nanotechnology = "nanotechnology",
  Newspapers = "newspapers",
  NonprofitOrganizationManagement = "nonprofit organization management",
  OilEnergy = "oil & energy",
  OnlineMedia = "online media",
  OutsourcingOffshoring = "outsourcing/offshoring",
  PackageFreightDelivery = "package/freight delivery",
  PackagingContainers = "packaging & containers",
  PaperForestProducts = "paper & forest products",
  PerformingArts = "performing arts",
  Pharmaceuticals = "pharmaceuticals",
  Philanthropy = "philanthropy",
  Photography = "photography",
  Plastics = "plastics",
  PoliticalOrganization = "political organization",
  PrimarySecondaryEducation = "primary/secondary education",
  Printing = "printing",
  ProfessionalTrainingCoaching = "professional training & coaching",
  ProgramDevelopment = "program development",
  PublicPolicy = "public policy",
  PublicRelationsCommunications = "public relations & communications",
  PublicSafety = "public safety",
  Publishing = "publishing",
  RailroadManufacture = "railroad manufacture",
  Ranching = "ranching",
  RealEstate = "real estate",
  RecreationalFacilitiesServices = "recreational facilities & services",
  ReligiousInstitutions = "religious institutions",
  RenewablesEnvironment = "renewables & environment",
  Research = "research",
  Restaurants = "restaurants",
  Retail = "retail",
  SecurityInvestigations = "security & investigations",
  Semiconductors = "semiconductors",
  Shipbuilding = "shipbuilding",
  SportingGoods = "sporting goods",
  Sports = "sports",
  StaffingRecruiting = "staffing & recruiting",
  Supermarkets = "supermarkets",
  Telecommunications = "telecommunications",
  Textiles = "textiles",
  ThinkTanks = "think tanks",
  Tobacco = "tobacco",
  TranslationLocalization = "translation & localization",
  TransportationTruckingRailroad = "transportation/trucking/railroad",
  Utilities = "utilities",
  VentureCapitalPrivateEquity = "venture capital & private equity",
  Veterinary = "veterinary",
  Warehousing = "warehousing",
  Wholesale = "wholesale",
  WineSpirits = "wine & spirits",
  Wireless = "wireless",
  WritingEditing = "writing & editing",
}

export enum ADraftedProspectSources {
  Apollo = "apollo",
  OpenAi = "open_ai",
  Google = "google",
  User = "user",
  Local = "local",
}

export enum ADetailedDraftedProspectSortByValues {
  OrganizationName = "organization_name",
  FullName = "full_name",
}

export enum ADetailedDraftedProspectSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ADraftedProspectSortByValues {
  OrganizationName = "organization_name",
}

export enum ADraftedProspectSortDirectionValues {
  Asc = "asc",
  Desc = "desc",
}

export enum ACompanyIndustries {
  Fmcg = "fmcg",
  Finance = "finance",
  Retail = "retail",
  FoodIndustry = "food_industry",
  Marketing = "marketing",
  ECommerce = "e_commerce",
  Corporate = "corporate",
}

export enum AActivityEvents {
  EmailSent = "email_sent",
  CallingDone = "calling_done",
  MeetingHappened = "meeting_happened",
}

export enum AAssignmentStatuses {
  Pending = "pending",
  Active = "active",
  Canceled = "canceled",
  PreMatched = "pre_matched",
}

export enum AAdvancedSearchSessionStatuses {
  Created = "created",
  InProgress = "in_progress",
  SearchedLeads = "searched_leads",
  SearchedLeadContacts = "searched_lead_contacts",
  Finished = "finished",
  Canceled = "canceled",
  Failed = "failed",
}

export enum AActivityFeedUserType {
  Admin = "Admin",
  SalesPerson = "SalesPerson",
  SaasSalesPerson = "SaasSalesPerson",
}

export enum AActivityFeedNotificationType {
  WeeklyUpdate = "weekly_update",
  DatabaseStatus = "database_status",
  MatchingInProgress = "matching_in_progress",
  SalesTalentEducation = "sales_talent_education",
  StatusMeeting = "status_meeting",
  SalesOutreachPlanUpdate = "sales_outreach_plan_update",
  QualityCheck = "quality_check",
  AccountSetup = "account_setup",
  SalesAssistantUpdates = "sales_assistant_updates",
}

export enum AActivityFeedActivityType {
  StringNotification = "string_notification",
  Call = "call",
  Email = "email",
  Meeting = "meeting",
  MeetingScheduled = "meeting_scheduled",
  KpiEmail = "kpi_email",
  KpiCall = "kpi_call",
  Won = "won",
  PriceOfferSent = "price_offer_sent",
}

export interface AActivityFeed {
  id: number
  /**
   * @format date
   * @example "2024-05-09"
   */
  activity_date: string
  grouped: boolean
  grouped_count: number
  /** @format date-time */
  grouped_at: string | null
  /** @format date-time */
  changed_activity_at: string
  activity_type: AActivityFeedActivityType
  string_notification_type: AActivityFeedNotificationType
  body: string
  note?: string | null
  /** @format date-time */
  happens_at?: string | null
  /** @format date-time */
  updated_at: string
  /** @format date-time */
  created_at: string
  liked_by_company: boolean
  created_by: AActivityFeedUser | null
  permissions?: APermissions
  deal?: {
    name?: string
    prospect?: {
      organization_name?: string
    } | null
  } | null
}

export interface AActivityFeedUser {
  id: number
  first_name: string
  last_name: string
  type: AActivityFeedUserType
  profile_picture_url: string | null
  profile_picture_thumbnail_url: string | null
  position?: string | null
  permissions?: APermissions
}

export interface AAdvancedSearchSession {
  id: number
  status: AAdvancedSearchSessionStatuses
  ongoing_search: boolean
  assignment: {
    id?: number
    sales_person?: {
      id?: number
      first_name?: string
      last_name?: string
      type?: AUserTypes
    }
  }
  sales_cycle: {
    id?: number
    name?: string
  }
  created_by: {
    id?: number
    first_name?: string
    last_name?: string
    type?: AUserTypes
  }
  permissions?: APermissions
  total_result_count?: number | null
}

export interface AAdvancedSearchFilter {
  positions?: string[] | null
  segments?: string[] | null
  country_ids?: number[] | null
  cities?: string[] | null
  custom_elevator_pitch?: string | null
  /** Array of company size ranges in format "min,max" (e.g., ["10,50", "51,200"]). Maximum 15 ranges allowed. */
  company_sizes?: string[] | null
}

export interface AAssignment {
  id: number
  reaches: number
  status: string
  sales_person: ASalesPerson | null
  sales_cycle: ASalesCycle
  pending_assignment_offers: AMatchingAssignmentOffer[]
  permissions?: APermissions
}

export interface AAssignmentShort {
  id: number
  reaches: number
  status?: string
  sales_person: ASalesPerson | null
  sales_cycle: {
    id: number
    name: string
  }
  pending_assignment_offers: AMatchingAssignmentOffer[]
  permissions?: APermissions
}

export interface ACompanyUserAssignmentReporting {
  id: number
  group_id: string
  total_activities: number
  activities_trend: number | null
  sales_person?: {
    id: number
    first_name: string
    last_name: string
    profile_picture_url: string | null
    profile_picture_thumbnail_url: string | null
  } | null
}

export interface ACompanyUserSalesNewsAssignment {
  id: number
  reaches: number
  outreach: number
  statistics: ACompanyUsersScopedStatistics
  sales_person: ACompanyUserSalesPerson | null
  permissions: APermissions
}

export interface ACompanyUserSalesCycleIterationAssignmentReporting {
  id: number
  group_id?: string
  statistics?: ACompanyUsersTrendsStatistics | null
  permissions: APermissions
}

export interface ASaasSalesPersonDashboardAssignments {
  id: number
  reaches: number
  minimum_meetings_count: number
  prospects_in_crm?: number | null
  /** @format date */
  last_activity_date?: string | null
  statistics: {
    emails_sent_activities?: number | null
    emails_sent_activities_uniq?: number | null
    calls_made_activities?: number | null
    calls_made_activities_uniq?: number | null
    won?: number | null
    price_offers?: number | null
    meetings_done_activities?: number | null
    opportunities?: number | null
  }
  sales_person?: ACompanyUserSalesPerson | null
  permissions?: APermissions
}

export interface ASaasCompanyUsersDashboardAssignments {
  id: number
  reaches: number
  minimum_meetings_count: number
  prospects_in_crm?: number | null
  /** @format date */
  last_activity_date?: string | null
  statistics: {
    emails_sent_activities?: number | null
    emails_sent_activities_uniq?: number | null
    calls_made_activities?: number | null
    calls_made_activities_uniq?: number | null
    won?: number | null
    price_offers?: number | null
    meetings_done_activities?: number | null
    opportunities?: number | null
  }
  sales_person?: ACompanyUserSalesPerson | null
  permissions?: APermissions
}

export interface AAssignmentOffer {
  id: number
  reward_value: number
  reaches: number
  sales_strategy_url?: string | null
  status: string
  /**
   * @format date
   * @example "2023-05-31"
   */
  valid_until: string
  currency: ACurrency
  sales_person: ASalesPerson
  products?: AProducts
  permissions?: APermissions
}

export interface AMatchingAssignmentOffer {
  id: number
  status: string
  /**
   * @format date
   * @example "2023-05-31"
   */
  valid_until: string
  sales_person: ASalesPerson
  permissions?: APermissions
}

export type AAttachments = {
  id: number
  url: string
}[]

export interface ABusinessData {
  id?: number
  company_name?: string
  company_id?: string
  street_address?: string
  city?: string
  postal_code?: string
  state?: string
  version?: number
  country?: ACountry
  permissions?: APermissions
}

export interface AActivitiesValues {
  meetings: number
  calls: number
  emails: number
}

export type AActivitiesChartData = {
  /** @format date */
  start_date: string
  /** @format date */
  end_date: string
  values: AActivitiesValues
  assignments: {
    id: number
    sales_person: AAdminsProspectsAssignmentSalesPerson
    values: AActivitiesValues
  }[]
}[]

export type AActivityOccurrencesChartData = {
  /** Key visible on the X axis */
  key: string
  /** @format date-time */
  from: string
  /** @format date-time */
  to: string
  occurrences: number
}[]

export interface AOpportunitiesChartData {
  proposal_sent: number
  future_deals: number
  negotiating: number
}

export type AClientsReachChartData = AActivitiesValues

export interface ACompany {
  id: number
  name: string
  with_marketplace_use_case: boolean
  lead_agent_enabled: boolean
  sales_assistant_ui_enabled: boolean
  auto_enrichment_enabled: boolean
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
}

export interface ACompanyWithPermissions {
  id: number
  name: string
  with_marketplace_use_case: boolean
  lead_agent_enabled: boolean
  sales_assistant_ui_enabled: boolean
  auto_enrichment_enabled: boolean
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  permissions?: APermissions
}

export interface ACompanyProfile {
  id: number
  profile: {
    name: string
    website?: string | null
    additional_billing_email?: string | null
    headline?: string | null
    description?: string | null
    number_of_employees?: number | null
    industry?: ACompanyIndustries
    profile_picture_url?: string | null
    profile_picture_thumbnail_url?: string | null
    country?: ACountry | null
  }
  members: {
    id: number
    first_name?: string | null
    last_name?: string | null
    phone_number?: string | null
  }[]
  transactions: ATransaction[]
}

export interface ACompanyAttributes {
  profile?: {
    name?: string
    website?: string
    headline?: string
    description?: string
    additional_billing_email?: string
    number_of_employees?: number
    industry?: ACompanyIndustries
    /** @format binary */
    profile_picture?: File
    /** Country ID */
    country_id?: number
  }
  members?: {
    id: number
    first_name?: string
    last_name?: string
    phone_number?: string
  }[]
}

export interface ACompanyUserDashboard {
  id: number
  active_sales_cycles_count: number
  drafted_sales_cycles_count: number
  finished_sales_cycles_count: number
  paused_sales_cycles_count: number
  sales_people?: ACompanyUserSalesCycleSalesPerson[]
  permissions?: APermissions
}

export interface ACountry {
  id: number
  name: string
  sales_cycle_allowed?: boolean
  visible_vat_number?: boolean
  require_vat_number?: boolean
  states?: {
    value: string
    title: string
  }[]
  /** ISO two letters */
  code: string
  currency?: ACurrency
  permissions?: APermissions
}

export interface ACurrency {
  id: number
  name: string
  symbol: string
  code: string
  permissions?: APermissions
}

export interface ACustomElevatorPitchResponse {
  custom_elevator_pitch: string | null
  sales_cycle_elevator_pitch: string | null
}

export interface AProspectActivity {
  id: string
  event: AProspectActivityEventEnum
  note?: string | null
  finished: boolean
  /** @format date-time */
  changed_activity_at: string
  /** @format date */
  activity_date: string
  created_by?: AActivityFeedUser | null
  deal?: {
    name?: string
    prospect?: {
      organization_name?: string
    } | null
  } | null
  permissions?: APermissions
}

export interface AProspectNote {
  id: number
  body?: string | null
  /** @format date-time */
  created_at?: string
  /** @format date */
  create_date: string
  deal_id: number
  permissions?: APermissions
}

export interface AAdvancedSearchDraftedProspect {
  id: number
  organization_name: string
  website: string | null
  company_size?: string | null
  advanced_search_session_id: number
  viewed: boolean
  confidence_score?: number | null
  source?: ADraftedProspectSources
  permissions?: APermissions
}

export interface ADetailedAdvancedSearchDraftedProspect {
  id: number
  group_id?: number | null
  organization_name: string
  segment?: string[] | null
  full_name?: string | null
  position?: string | null
  website: string | null
  email?: string | null
  phone_number?: string | null
  loading_keys: string[]
  company_size?: string | null
  advanced_search_session_id: number
  viewed: boolean
  source?: ADraftedProspectSources
  permissions?: APermissions
}

export interface AAdvancedSearchDraftedProspectMeta {
  pagination: APagination
  ongoing_search: boolean
  search_status: AAdvancedSearchSessionStatuses
  total_result_count: number | null
}

export interface ADetailedAdvancedSearchDraftedProspectMeta {
  pagination: APagination
  ongoing_search: boolean
  total: number
  removed: number
  search_status: AAdvancedSearchSessionStatuses
  total_result_count: number | null
}

export type AErrors = Record<string, any>

export interface AErrorBaseMessages {
  base?: string[]
}

export interface AImporter {
  id: number
  /** @format date-time */
  created_at: string
  delete_permitted: boolean
  /** @format date-time */
  started_at?: string | null
  /** @format date-time */
  imported_at?: string | null
  /** @format date-time */
  delete_disabled_at?: string | null
  status: AImporterStatuses
  error_message?: string | null
  created_by?: AImportedByUser
  permissions?: APermissions
}

export interface AInvoiceDetail {
  id: number
  name: string
  email: string
  address: string
  city: string
  postal_code: string
  company: boolean
  company_name: string
  company_number: string
  company_vat_number?: string | null
  company_tax_number?: string | null
  default?: boolean
  owner: ACompany
  country: ACountry
}

export interface AInvoiceDetailAttributes {
  name: string
  email: string
  city: string
  address: string
  postal_code: string
  company: boolean
  /** Country ID */
  country_id: number
  company_name: string
  company_number: string
  company_tax_number?: string
  company_vat_number?: string
  default?: boolean
}

export interface ALanguage {
  id?: number
  name?: string
  code?: string
  permissions?: APermissions
}

export interface ALead {
  id: number
  name: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  notes?: string | null
  source?: string | null
  in_use: boolean
  company_size: ALeadCompanySizes
  country: ACountry
  permissions?: APermissions
  warnings?: string[] | null
  is_potential_duplicate?: boolean
  info_contact?: boolean
  anonymized?: boolean
}

export interface ALeadWithAssignmentProspect {
  id: number
  name: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  notes?: string | null
  source?: string | null
  in_use: boolean
  company_size: ALeadCompanySizes
  country: ACountry
  assignment_prospect?: AAdminProspect | null
  permissions?: APermissions
  warnings?: string[] | null
  is_potential_duplicate?: boolean
  info_contact?: boolean
  anonymized?: boolean
}

export interface ALeadDetail {
  id: number
  name: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  notes?: string | null
  source?: string | null
  in_use: boolean
  sources?: string[]
  ownership_levels?: {
    id: number
    owner_name: string
    access: string
  }[]
  sales_cycles?: {
    id: number
    name: string
  }[]
  company_size: ALeadCompanySizes
  country: ACountry
  permissions?: APermissions
  warnings?: string[] | null
  is_potential_duplicate?: boolean
  info_contact?: boolean
  anonymized?: boolean
}

export interface ALeadAttributes {
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: string | null
  organization_phone_number?: string | null
  additional_phone_number?: string | null
  website?: string | null
  organization_number?: string | null
  email?: string | null
  company_size?: ALeadCompanySizes
  notes?: string | null
  country_id: number
}

export interface APublicLead {
  organization_name: string
  contact_person_first_name: string | null
  contact_person_last_name: string | null
  phone_number: string | null
  organization_phone_number: string | null
  additional_phone_number: string | null
  email: string | null
  city: string | null
  position: string | null
  segment: string[] | null
  website: string | null
  country: {
    name?: string
  }
}

export interface AMasqueradeTarget {
  id: number
  email: string
  first_name: string
  last_name: string
}

export type AMeta = AMetaWithPagination | AEmptyMeta

export interface AMetaWithPagination {
  pagination?: APagination
  available_segments?: string[]
}

export type AEmptyMeta = any

export interface APagination {
  current_page?: number
  per_page?: number
  total_count?: number
}

export interface APreviewOrder {
  min_regular_setup_fee_price: number
  max_regular_setup_fee_price: number
  min_regular_sales_person_price: number
  max_regular_sales_person_price: number
  min_total_regular_price: number
  max_total_regular_price: number
  order: AOrder
}

export interface AOrder {
  id: number
  order_type: AOrderOrderTypeEnum
  status: AOrderStatuses
  subscription_billing_type: ASubscriptionBillingTypes
  invoice_provider?: AInvoiceProviders
  total_price: number
  total_price_without_vat: number
  total_price_before_discount: number
  total_vat_price: number
  total_price_before_discount_without_vat?: number
  total_discount_price?: number
  customer_name?: string | null
  customer_email?: string | null
  city?: string | null
  address?: string | null
  postal_code?: string | null
  state?: string | null
  company_name?: string | null
  company_number?: string | null
  company_tax_number?: string | null
  company_vat_number?: string | null
  external_invoice_url?: string | null
  external_receipt_url?: string | null
  invoice_number?: string | null
  /**
   * @format date
   * @example "2023-07-14"
   */
  next_payment_date?: string
  next_payment_total_price?: number
  payment_method: APaymentMethods
  verified_vat_payer?: boolean
  voucher_code_input?: string | null
  voucher_code_result?: AVoucherCodeResult
  sales_cycle: ASalesCycle
  country?: ACountry | null
  currency: ACurrency
  invoice_detail?: AInvoiceDetail | null
  order_items: AOrderItem[]
  service_items: AOrderItem[]
  permissions?: APermissions
}

export interface ACompanyUserDashboardOrder {
  id: number
  status: AOrderStatuses
  total_price: number
  external_invoice_url?: string | null
  payment_method: APaymentMethods
  /** @format date */
  due_date?: string | null
  currency: ACurrency
  permissions?: APermissions
}

export type AVoucherCodeResult = {
  status?: AVoucherCodeResultStatusEnum
  message?: string
} | null

export interface AOrderItem {
  id: number
  total_price: number
  total_price_without_vat: number
  total_price_before_discount: number
  name?: string | null
  description?: string | null
  unit_price: number
  unit_price_without_vat: number
  total_vat_price: number
  discount_percentage: number
  vat_rate_percentage: number
  quantity: number
  unit_price_before_discount_without_vat?: number
  unit_price_before_discount?: number
  total_price_before_discount_without_vat?: number
  unit_discount_price?: number
  unit_vat_price?: number
  total_discount_price?: number
  /** This attribute can be Package or SalesStrategy */
  purchased_product: object
  package?: APackage | null
  sales_strategy?: ASalesStrategy | null
  sales_person?: ACompanyUserSalesCycleSalesPerson | null
}

export interface APackage {
  id: number
  name: string
  short_name: string
  reaches: number
}

export interface APackageWithPrice {
  id: number
  name: string
  short_name: string
  reaches: number
  monthly_price: number
  yearly_price: number
  yearly_discount?: number
  title: string
  subtitle: string
  currency: ACurrency
  permissions?: APermissions
}

export interface APermissions {
  "update?": boolean
  "destroy?": boolean
}

export interface AResourceLevelPermissions {
  "index?": boolean
  "create?": boolean
}

export interface APublicPrivacyRequest {
  token: string
  resource: APublicLead
}

export type AProducts = AProduct[]

export interface AProduct {
  id: number
  name: string
  price: number | null
  goal: AGoals
  commission: number
  sales_person_commission: number
  commission_type: ACommissionTypes
  commission_value_type: ACommissionValueTypes
  commission_note?: string | null
  currency: ACurrency | null
  permissions?: APermissions
}

export type APhoneField = {
  number: string
  dncl_status?: APhoneFieldDnclStatusEnum | null
} | null

export interface AAdminProspect {
  id: number
  name: string
  /** @format date-time */
  created_at: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  approved: boolean
  prioritized: boolean
  crm_synced?: boolean
  retired: boolean
  is_potential_duplicate: boolean
  warnings?: string[] | null
  added_by: string
  /** @format date-time */
  approved_at?: string | null
  approval_status: AProspectApprovalStatuses
  processing_status: AProspectProcessingStatuses
  auto_enrichment_status: AProspectAutoEnrichmentStatuses
  status?: AProspectStatuses
  disapprove_reason?: AProspectDisapproveReasons | null
  disapprove_reason_text?: string | null
  notes?: string | null
  source?: string | null
  country: ACountry
  intended_for?: ASalesPerson | null
  assigned_to?: ASalesPerson | null
  permissions?: APermissions
}

export interface ASalesPersonProspect {
  id: number
  name: string
  /** @format date-time */
  created_at: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  approved: boolean
  prioritized: boolean
  crm_synced?: boolean
  retired: boolean
  is_potential_duplicate: boolean
  warnings?: string[] | null
  added_by: string
  /** @format date-time */
  approved_at?: string | null
  approval_status: AProspectApprovalStatuses
  processing_status: AProspectProcessingStatuses
  auto_enrichment_status: AProspectAutoEnrichmentStatuses
  status?: AProspectStatuses
  disapprove_reason?: AProspectDisapproveReasons | null
  disapprove_reason_text?: string | null
  notes?: string | null
  source?: string | null
  country: ACountry
  permissions?: APermissions
  info_contact?: boolean
  anonymized?: boolean
}

export interface ASaasCompanyUserProspect {
  id: number
  name: string
  /** @format date-time */
  created_at: string
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: APhoneField
  organization_phone_number?: APhoneField
  additional_phone_number?: APhoneField
  website?: string | null
  organization_number?: string | null
  email?: string | null
  approved: boolean
  prioritized: boolean
  crm_synced?: boolean
  retired: boolean
  /** @format date-time */
  approved_at?: string | null
  approval_status: AProspectApprovalStatuses
  processing_status: AProspectProcessingStatuses
  auto_enrichment_status: AProspectAutoEnrichmentStatuses
  status?: AProspectStatuses
  disapprove_reason?: AProspectDisapproveReasons | null
  disapprove_reason_text?: string | null
  notes?: string | null
  source?: string | null
  country: ACountry
  intended_for?: ASalesPerson | null
  assigned_to?: ASalesPerson | null
  permissions?: APermissions
  warnings?: string[] | null
  is_potential_duplicate: boolean
}

export interface ACompanyUserProspect {
  id: number
  organization_name: string
  city?: string | null
  position?: string | null
  segment?: string[] | null
  website?: string | null
  approved: boolean
  prioritized: boolean
  added_by: string
  /** @format date-time */
  approved_at?: string | null
  status?: AProspectStatuses
  approval_status: AProspectApprovalStatuses
  processing_status: AProspectProcessingStatuses
  auto_enrichment_status: AProspectAutoEnrichmentStatuses
  disapprove_reason?: AProspectDisapproveReasons | null
  disapprove_reason_text?: string | null
  country: ACountry
  intended_for?: ASalesPerson | null
  assigned_to?: ASalesPerson | null
  warnings?: string[] | null
  is_potential_duplicate: boolean
  permissions?: APermissions
}

export interface AProspectAttributes {
  organization_name: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: string | null
  organization_phone_number?: string | null
  additional_phone_number?: string | null
  website?: string | null
  organization_number?: string | null
  email?: string | null
  source?: string | null
  notes?: string | null
  country_id: number
  retired?: boolean | null
}

export interface ACompanyUserSalesCycleProspects {
  id: number
  organization_name: string
  position?: string | null
  status: ASalesCycleProspectStatuses | null
  stage: ASalesCycleFilterStages | null
  notes: string | null
  deal_details?: string | null
  meeting_at?: string | null
  lost_reason?: string | null
  segment: string[] | null
  crm_url?: string | null
  permissions?: APermissions
}

export interface ASaasCompanyUser {
  id: number
  email: string
  first_name: string
  last_name: string
  type: AUserTypes
  phone_number?: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  enabled_sales_assistant_screen?: boolean
  enabled_onboarding_screen?: boolean
  company_sync_organizations_as_deals?: boolean
  company: ACompany
  sales_assistant_sales_person?: ASaasCompanyUserSalesAssistantSalesPerson | null
  owned_company?: ACompany | null
}

export interface ASaasCompanyUserListItem {
  id: number
  email: string
  first_name: string | null
  last_name: string | null
  role: ASaasCompanyUserListItemRole
  status: ASaasCompanyUserListItemStatus
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  /** @format date-time */
  joined_at: string
  invited_by?: ASaasCompanyUserListItemInvitedBy
}

export type ASaasCompanyUserListItemInvitedBy = {
  id: number
  first_name: string | null
  last_name: string | null
  email: string
} | null

export interface ASaasCompanyUserOnboardingStatus {
  managed_prospects: boolean
  used_klara_ai: boolean
  visited_sales_intelligence: boolean
  first_ongoing_sales_cycle_id?: number | null
}

export interface ASaasCompanyUserSalesAssistantSalesPerson {
  id?: number
  external_id?: string
}

export interface ASaasCompanyUserSalesCycle {
  id: number
  name: string
  status?: ASalesCycleStatuses
  website?: string | null
  segment?: string | null
  /** @format date-time */
  created_at?: string
  duration_in_months?: number
  attachments?: AAttachments | null
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasCompanyProspectsSalesCycle {
  id: number
  name: string
  advanced_search_enabled: boolean
  company?: ACompanyWithPermissions
  sales_cycle_iterations: {
    id: number
    /**
     * @format date
     * @example "2024-02-01"
     */
    start_date: string
    prospects_mandatory_count: number
    prospects_approved_count: number
    prospects_finished_count: number
    assignments: {
      id: number
      prospects_mandatory_count: number
      prospects_approved_count: number
      prospects_finished_count: number
      sales_person: AAdminsProspectsAssignmentSalesPerson | null
      permissions?: APermissions
    }[]
  }[]
  permissions?: APermissions
}

export interface ASaasSalesPersonSalesCycle {
  id: number
  name: string
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasSalesPersonDashboardSalesCycle {
  id: number
  name: string
  statistics: {
    emails_sent_activities?: number | null
    calls_made_activities?: number | null
    meetings_done_activities?: number | null
    won?: number | null
  }
  assignments?: ASaasSalesPersonDashboardAssignments[]
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasSalesPersonSalesIntelligenceDashboardSalesCycle {
  id: number
  name: string
  sales_talent_prospects_enabled: boolean
  status?: ASalesCycleStatuses
  sales_flow: ASalesCycleSalesFlows
  /** @format date-time */
  created_at?: string
  statistics: ASalesIntelligenceSalesCycleIterationStatistics
  assignment_statistics?: ASalesIntelligenceAssignmentStatistics[]
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasCompanyUserDashboardSalesCycle {
  id: number
  name: string
  status?: ASalesCycleStatuses
  website?: string | null
  segment?: string | null
  /** @format date-time */
  created_at?: string
  duration_in_months?: number
  statistics: {
    emails_sent_activities?: number | null
    calls_made_activities?: number | null
    meetings_done_activities?: number | null
    won?: number | null
  }
  assignments?: ASaasCompanyUsersDashboardAssignments[]
  attachments?: AAttachments | null
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasCompanySalesIntelligenceDashboardSalesCycle {
  id: number
  name: string
  sales_talent_prospects_enabled: boolean
  status?: ASalesCycleStatuses
  sales_flow: ASalesCycleSalesFlows
  /** @format date-time */
  created_at?: string
  statistics: ASalesIntelligenceSalesCycleIterationStatistics
  assignment_statistics?: ASalesIntelligenceAssignmentStatistics[]
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ASaasSalesPerson {
  id: number
  email: string
  first_name: string
  last_name: string
  type: AUserTypes
  phone_number?: string | null
  company: ACompany
  country: ACountry
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  sales_assistant_connection?: boolean
  enabled_sales_assistant_screen?: boolean
  company_sync_organizations_as_deals?: boolean
  demo: boolean
}

export interface ASalesAssistantDeal {
  id: number
  external_id: string
  title: string
  selling_title?: string | null
  priority: ASalesAssistantDealPriorities
  planned_task?: ASalesAssistantTask | null
  contact?: ASalesAssistantContact | null
  sales_person?: ASalesAssistantSalesPersonSummary | null
}

export interface ASalesAssistantSalesPersonSummary {
  id: number
  first_name?: string | null
  last_name?: string | null
  profile_picture_thumbnail_url?: string | null
  external_id?: string | null
}

export interface ASalesAssistantTask {
  id: number
  external_id: string
  type: ASalesAssistantTaskTypes
  /**
   * @format date
   * @example "2025-09-05"
   */
  date: string
  time?: string | null
  next_step?: ASalesAssistantNextSteps | null
  status: ASalesAssistantTaskStatuses
}

export interface ASalesAssistantContact {
  id: number
  first_name?: string
  last_name?: string
}

export interface ASalesAssistantProspect {
  id?: number
  name?: string
  organization_name?: string
  city?: string | null
  contact_person_first_name?: string | null
  contact_person_last_name?: string | null
  position?: string | null
  segment?: string[] | null
  phone_number?: string | null
  organization_phone_number?: string | null
  additional_phone_number?: string | null
  website?: string | null
  organization_number?: string | null
  email?: string | null
  notes?: string | null
  source?: string | null
  deal_history?: string | null
  country?: ACountry
  permissions?: APermissions
}

export interface ASalesAssistantTaskParams {
  id: number
  next_step: ASalesAssistantNextSteps
  /** @format date */
  next_step_date: string
  notes?: string | null
}

export interface ASalesAssistantTaskCreateParams {
  deal_id?: number
  task_type?: ASalesAssistantCreateTaskTypes
  /** @format date */
  task_date?: string
}

export interface ASalesAssistantSalesPerson {
  id: number
  first_name?: string
  last_name?: string
  external_id: string
  profile_picture_thumbnail_url?: string | null
  sales_assistant_updates: number
  total_updates: number
}

export interface ASalesAssistantSalesPersonBasic {
  id: number
  first_name: string
  last_name: string
  external_id: string
  profile_picture_thumbnail_url?: string | null
}

export interface ASalesAssistantSalesPersonSettings {
  id: number
  end_of_day_call_enabled: boolean
  end_of_day_call_hour: number
  sms_notifications_enabled: boolean
  send_morning_email: boolean
  company_enabled_send_morning_email: boolean
  company_enabled_sms_notifications: boolean
  company_enabled_end_of_day_call: boolean
  phone_number: string
  additional_phone_numbers?: {
    id?: number
    phone_number?: string
  }[]
}

export interface ASalesAssistantSalesPersonSettingsAttributes {
  end_of_day_call_enabled?: boolean
  end_of_day_call_hour?: number
  sms_notifications_enabled?: boolean
  send_morning_email?: boolean
  phone_number: string
  additional_phone_numbers?: {
    id?: number
    phone_number?: string
    _destroy?: boolean
  }[]
}

export interface ASalesAssistantUpdateCenterEntry {
  id: number
  entry_type: ASalesAssistantUpdateCenterEntryTypeValues
  /** @format datetime */
  tracked_at: string
  /** @format date */
  tracked_date: string
  sales_person?: ASalesAssistantSalesPersonSummary | null
  voice_progress_tracker?: {
    id?: number
    call_duration?: number
    call_type?: ASalesAssistantUpdateCenterEntryCallTypeEnum
  }
  update_center_events?: ASalesAssistantUpdateCenterEvent[]
}

export interface ASalesAssistantUpdateCenterEvent {
  id: number
  deal: {
    id: number
    status?: ASalesAssistantDealStatuses
    title: string
    selling_title?: string | null
  }
  update_center_steps?: (
    | ASalesAssistantUpdateCenterNoteStep
    | ASalesAssistantUpdateCenterStageStep
    | ASalesAssistantUpdateCenterActivityDoneStep
    | ASalesAssistantUpdateCenterActivityCreateStep
    | ASalesAssistantUpdateCenterActivityRescheduleStep
    | ASalesAssistantUpdateCenterDealWonStep
    | ASalesAssistantUpdateCenterDealLostStep
  )[]
}

export interface ASalesAssistantUpdateCenterNoteStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  body?: string
}

export interface ASalesAssistantUpdateCenterStageStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  from_stage?: string | null
  to_stage?: string
}

export interface ASalesAssistantUpdateCenterActivityDoneStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  activity_type?: string
}

export interface ASalesAssistantUpdateCenterActivityCreateStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  /** @format datetime */
  created_at?: string
  activity_type?: string
}

export interface ASalesAssistantUpdateCenterActivityRescheduleStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  /** @format datetime */
  scheduled_at?: string
  activity_type?: string
}

export interface ASalesAssistantUpdateCenterDealWonStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  /** @format datetime */
  won_at?: string
}

export interface ASalesAssistantUpdateCenterDealLostStep {
  id: number
  step_type: ASalesAssistantUpdateCenterStepTypeValues
  /** @format datetime */
  lost_at?: string
}

export interface AKlaraDashboardSalesPerson {
  id: number
  external_id: string
  first_name: string
  last_name: string
  profile_picture_thumbnail_url: string | null
  active: boolean
}

export interface AKlaraDashboardPipeline {
  open: number
  planned: number
  overdue: number
  missing: number
  rotten: number
  won: number
  lost: number
}

export interface AKlaraDashboardSummary {
  /** @example "Europe/Bratislava" */
  time_zone: string
  /** @format date-time */
  as_of: string
  mode: AKlaraDashboardSummaryModeEnum
  open_deals: number
  sales_flows: number
  missing: number
  rotten: number
  updates_collected: number
  updates_collected_previous: number | null
  coverage: {
    updated: number
    open: number
    /** @format float */
    rate: number | null
    /** @format float */
    previous_rate: number | null
  }
  coverage_target: number
  rotten_days: number
  pipeline: AKlaraDashboardPipeline
}

export interface AKlaraDashboardBucket {
  /** @format date */
  start_date: string
  /** @format date */
  end_date: string
  voice: number
  manual: number
}

export interface AKlaraDashboardSalesPersonRow {
  sales_person: AKlaraDashboardSalesPerson
  open_deals: number
  won: number
  lost: number
  updated_open_deals: number
  /** @format float */
  coverage_rate: number | null
  voice_updates: number
  manual_updates: number
  klara_calls: number
  voice_updated_deals: number
  /** @format date-time */
  last_update_at: string | null
  pipeline: {
    open: number
    planned: number
    overdue: number
    missing: number
    rotten: number
  }
}

export interface AKlaraCompanySettings {
  /**
   * @min 10
   * @multipleOf 5
   * @max 100
   */
  coverage_target: number
}

export interface AKlaraValidationErrors {
  errors: Record<string, string[]>
}

export interface AKlaraRemindErrors {
  errors: {
    base: AKlaraRemindErrorsBaseEnum[]
  }
}

export interface AKlaraDashboardOrganization {
  id: number
  name: string | null
}

export interface AKlaraDashboardSelling {
  id: number
  title: string | null
}

export interface AKlaraDashboardSalesFlow {
  id: number
  name: string | null
  type: AKlaraDashboardSalesFlowTypeEnum | null
}

export interface AKlaraDashboardStage {
  name: string
  ordinal: number | null
  active_stages_count: number
}

export interface AKlaraDashboardFlags {
  missing: boolean
  overdue: boolean
  rotten: boolean
}

export interface AKlaraDashboardActivity {
  type: AKlaraDashboardActivityTypeEnum
  /** @format date */
  date: string
  time: string | null
}

export interface AKlaraDashboardLastUpdate {
  /** @format date-time */
  tracked_at: string
  entry_type: AKlaraDashboardLastUpdateEntryTypeEnum
}

export interface AKlaraDashboardDeal {
  id: number
  external_id: string
  title: string | null
  selling_title: string | null
  priority: ASalesAssistantDealPriorities
  planned_task: ASalesAssistantTask | null
  contact: {
    id: number
    first_name: string | null
    last_name: string | null
    position: string | null
  } | null
  sales_person: ASalesAssistantSalesPersonSummary | null
  organization: AKlaraDashboardOrganization | null
  selling: AKlaraDashboardSelling
  sales_flows: AKlaraDashboardSalesFlow[]
  stage: AKlaraDashboardStage | null
  /** @format date-time */
  stage_changed_at: string | null
  stage_days: number | null
  lifecycle_status: AKlaraDashboardLifecycleStatusValues
  /** @format date-time */
  closed_at: string | null
  flags: AKlaraDashboardFlags
  next_activity: AKlaraDashboardActivity | null
  overdue_activity: AKlaraDashboardActivity | null
  last_update: AKlaraDashboardLastUpdate | null
}

export interface AKlaraDashboardDealDetail {
  id: number
  title: string | null
  priority: ASalesAssistantDealPriorities
  lifecycle_status: AKlaraDashboardLifecycleStatusValues
  /** @format date-time */
  closed_at: string | null
  contact: {
    first_name: string | null
    last_name: string | null
    position: string | null
  } | null
  organization: AKlaraDashboardOrganization | null
  owner: AKlaraDashboardSalesPerson
  selling: AKlaraDashboardSelling
  sales_flows: AKlaraDashboardSalesFlow[]
  stage: AKlaraDashboardStage | null
  /** @format date-time */
  stage_changed_at: string | null
  stage_days: number | null
  flags: AKlaraDashboardFlags
  next_activity: AKlaraDashboardActivity | null
  overdue_activity: AKlaraDashboardActivity | null
  last_update: AKlaraDashboardLastUpdate | null
}

export interface AKlaraDashboardDealUpdate {
  deal: {
    priority: ASalesAssistantDealPriorities
  }
}

export interface AKlaraDashboardDealsMeta {
  pagination: APagination
  mode: AKlaraDashboardDealsMetaModeEnum
  counts: {
    views: {
      attention: number
      all: number
      high: number
      rotten: number
      closed: number
    }
    /** Deal count per sales person external_id */
    sales_people: Record<string, number>
    priorities: {
      low: number
      medium: number
      high: number
    }
  }
}

export interface AKlaraDashboardUpdateCenterEntry {
  id: number
  entry_type: ASalesAssistantUpdateCenterEntryTypeValues
  /** @format date-time */
  tracked_at: string
  /** @format date */
  tracked_date: string
  sales_person: ASalesAssistantSalesPersonSummary | null
  voice_progress_tracker: {
    id: number
    call_duration: number
    call_type: AKlaraDashboardUpdateCenterEntryCallTypeEnum
  } | null
  update_center_events: AKlaraDashboardUpdateCenterEvent[]
}

export interface AKlaraDashboardUpdateCenterEvent {
  id: number
  deal: {
    id: number
    status: ASalesAssistantDealStatuses
    title: string | null
    selling_title: string | null
    organization: AKlaraDashboardOrganization | null
  }
  update_center_steps: (
    | ASalesAssistantUpdateCenterNoteStep
    | ASalesAssistantUpdateCenterStageStep
    | ASalesAssistantUpdateCenterActivityDoneStep
    | ASalesAssistantUpdateCenterActivityCreateStep
    | ASalesAssistantUpdateCenterActivityRescheduleStep
    | ASalesAssistantUpdateCenterDealWonStep
    | ASalesAssistantUpdateCenterDealLostStep
  )[]
}

export interface AKlaraDashboardUpdateCenterMeta {
  pagination: APagination
  total_event_count: number
}

export interface ASalesCycleAttributes {
  country_id: number
  ideal_customer_profile?: ASalesCycleIdealCustomerProfiles
  decision_maker_persona?: string[]
  segment?: ASalesCycleSegment
  /** @format file */
  price_list?: File
  website?: string
  elevator_pitch?: string
  story_description?: string
  product_benefits?: string[]
  product_uniques?: string[]
  references?: string[]
  years_of_market?: ASalesCycleYearsOfMarkets
  successful_events?: string[]
  appendable_attachments?: File[]
  sales_person_offline_required?: boolean
  sales_person_online_required?: boolean
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  products_attributes?: {
    id?: number | null
    commission: number
    commission_type: ACommissionTypes
    commission_value_type: ACommissionValueTypes
    goal: AGoals
    commission_note?: string | null
  }[]
}

export interface ASalesCycle {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  strategy_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
  hide_meeting_activities: boolean
  key_details_finalized?: boolean
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  attachments?: AAttachments | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  permissions?: APermissions
}

export interface ASalesCycleSummary {
  id: number
  name: string
  status: string
}

export interface ACompanyUserSalesCycle {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  subscription?: ASubscription | null
  permissions?: APermissions
  attachments?: AAttachments | null
  /**
   * @format date
   * @example "2023-05-31"
   */
  first_start_date: string
  outreach: number
  activities: number
  closed_deals: number
  sales_person_closed_deals: number
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  key_details_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
  sales_strategy_url: string | null
  sales_cycle_iterations: {
    id: number
    /**
     * @format date
     * @example "2023-05-31"
     */
    start_date: string
    status: ACompanyUserSalesCycleStatusEnum
  }[]
  sales_person: ACompanyUserSalesPerson | null
}

export interface ACompanyUserSalesCycleDetails {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  attachments?: AAttachments | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  subscription?: ASubscription | null
  permissions?: APermissions
  /**
   * @format date
   * @example "2023-05-31"
   */
  first_start_date: string
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  sales_strategy_url: string | null
  this_month_iteration_id: number
  key_details_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
}

export interface AAdminSalesCycleDetails {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  attachments?: AAttachments | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required?: boolean
  sales_person_online_required?: boolean
  price_list_url?: string | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  subscription?: ASubscription | null
  permissions?: APermissions
  /**
   * @format date
   * @example "2023-05-31"
   */
  first_start_date: string
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  sales_strategy_url: string | null
  this_month_iteration_id: number
  key_details_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
}

export interface ACompanyUserSalesCycleSalesNews {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  key_details_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  attachments?: AAttachments | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  permissions?: APermissions
  statistics: ACompanyUsersScopedStatistics
  assignments?: ACompanyUserSalesNewsAssignment[]
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  iteration_id?: number | null
  /** @format date */
  iteration_start_date?: string | null
}

export interface AAdminSalesCycleSalesNews {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  attachments?: AAttachments | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required?: boolean
  sales_person_online_required?: boolean
  price_list_url?: string | null
  key_details_finalized?: boolean
  activity_feeds_administration_url: string
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  permissions?: APermissions
  statistics: ACompanyUsersScopedStatistics
  assignments?: ACompanyUserSalesNewsAssignment[]
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  iteration_id?: number | null
  /** @format date */
  iteration_start_date?: string | null
}

export interface ASalesPersonSalesCycleSalesNews {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  key_details_finalized?: boolean
  saas_selling: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  permissions?: APermissions
  statistics?: ACompanyUsersScopedStatistics | null
  attachments?: AAttachments | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  iteration_id?: number | null
  /** @format date */
  iteration_start_date?: string | null
}

export interface ASalesPersonSalesCycleDetails {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  attachments?: AAttachments | null
  segment_note?: string | null
  sales_scripts?: string | null
  articles_links?: string | null
  additional_strategy_description?: string | null
  sales_person_requirements_note?: string | null
  sales_person_offline_required?: boolean
  sales_person_online_required?: boolean
  price_list_url?: string | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  default_currency?: ACurrency | null
  subscription?: ASubscription | null
  permissions?: APermissions
  /**
   * @format date
   * @example "2023-05-31"
   */
  first_start_date: string
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  sales_strategy_url: string | null
  this_month_iteration_id: number
  key_details_finalized?: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
}

export interface AAdminsProspectsSalesCycle {
  id: number
  name: string
  advanced_search_enabled: boolean
  company?: ACompanyWithPermissions
  sales_cycle_iterations: {
    id: number
    /**
     * @format date
     * @example "2024-02-01"
     */
    start_date: string
    /**
     * @format date
     * @example "2024-01-28"
     */
    deadline_approval_date: string
    /**
     * @format date
     * @example "2024-01-25"
     */
    deadline_add_prospects_date?: string
    prospects_mandatory_count: number
    prospects_draft_count: number
    prospects_ready_to_approve_count: number
    prospects_approved_count: number
    prospects_finished_count: number
    prospects_with_warning_count: number
    assignments: {
      id: number
      prospects_mandatory_count: number
      prospects_draft_count: number
      prospects_ready_to_approve_count: number
      prospects_approved_count: number
      prospects_finished_count: number
      prospects_with_warning_count: number
      package_name: string | null
      /** @format date-time */
      prospects_sent_for_approval_at: string | null
      sales_person: AAdminsProspectsAssignmentSalesPerson | null
      permissions?: APermissions
    }[]
  }[]
  permissions?: APermissions
}

export interface ASalesPersonProspectsSalesCycle {
  id: number
  name: string
  advanced_search_enabled: boolean
  company?: ACompanyWithPermissions
  sales_cycle_iterations: {
    id: number
    /**
     * @format date
     * @example "2024-02-01"
     */
    start_date: string
    /**
     * @format date
     * @example "2024-01-28"
     */
    deadline_approval_date: string
    /**
     * @format date
     * @example "2024-01-25"
     */
    deadline_add_prospects_date?: string
    prospects_mandatory_count: number
    prospects_draft_count: number
    prospects_ready_to_approve_count: number
    prospects_approved_count: number
    prospects_finished_count: number
    assignments: {
      id: number
      prospects_mandatory_count: number
      prospects_draft_count: number
      prospects_ready_to_approve_count: number
      prospects_approved_count: number
      prospects_finished_count: number
      package_name: string | null
      /** @format date-time */
      prospects_sent_for_approval_at: string | null
      permissions?: APermissions
    }[]
  }[]
  permissions?: APermissions
}

export interface ACompanyProspectsSalesCycle {
  id: number
  name: string
  advanced_search_enabled: boolean
  sales_cycle_iterations: {
    id: number
    /**
     * @format date
     * @example "2024-02-01"
     */
    start_date: string
    /**
     * @format date
     * @example "2024-01-28"
     */
    deadline_approval_date: string
    prospects_mandatory_count: number
    prospects_ready_to_approve_count: number
    prospects_approved_count: number
    assignments: {
      id: number
      prospects_mandatory_count: number
      prospects_ready_to_approve_count: number
      prospects_approved_count: number
      maximum_rejections: number
      rejections_limit: number
      package_name: string | null
      sales_person: AAdminsProspectsAssignmentSalesPerson | null
      permissions?: APermissions
    }[]
  }[]
  permissions?: APermissions
}

export interface ACompanyUsersScopedStatistics {
  activities?: number | null
  clients_reached?: number | null
  emails_sent?: number | null
  calls_made?: number | null
  meetings_done?: number | null
  opportunities?: number | null
  won?: number | null
  lost?: number | null
}

export interface ACompanyUsersTrendsStatistics {
  counters: ACompanyUsersScopedStatistics
  trends?: ACompanyUsersScopedStatistics | null
}

export interface ACompanyUserSalesCycleReporting {
  id: number
  status: ASalesCycleStatuses
  hide_meeting_activities: boolean
  max_assignments_count_per_iteration: number
  name: string
  company_name: string
  sales_cycle_iterations: {
    id: number
    /** @format date */
    start_date: string
    /** @format date */
    end_date: string
    finished_report: boolean
    download_report_url?: string | null
    report_sent_by_super_admin: boolean
  }[]
  assignments: ACompanyUserAssignmentReporting[]
  statistics?: ACompanyUsersTrendsStatistics | null
  permissions: APermissions
}

export interface ASaasCompanyUserSalesCycleReporting {
  id: number
  status: ASalesCycleStatuses
  hide_meeting_activities: boolean
  max_assignments_count_per_iteration: number
  name: string
  company_name: string
  sales_cycle_iterations: {
    id: number
    /** @format date */
    start_date: string
    /** @format date */
    end_date: string
    finished_report: boolean
    download_report_url?: string | null
  }[]
  assignments: ACompanyUserAssignmentReporting[]
  statistics?: ACompanyUsersTrendsStatistics | null
  permissions: APermissions
}

export interface ACompanyUserDashboardActiveSalesCycle {
  id: number
  name: string
  /** @format date */
  first_selling_date: string
  /** @format date */
  current_selling_date: string
  opportunities?: number
  activities?: number
  assignments?: {
    id: number
    reaches: number
    status: AAssignmentStatuses
    sales_person?: ACompanyUserDashboardSalesPerson | null
  }[]
  status: ASalesCycleIterationStatuses
  country: ACountry
  company: ACompanyWithPermissions
  order?: ACompanyUserDashboardOrder | null
  permissions?: APermissions
}

export interface ACompanyUserDashboardDraftedSalesCycle {
  id: number
  name: string
  key_details_finalized: boolean
  strategy_finalized: boolean
  strategy_touched: boolean
  onboarding_status: AOnboardingStatuses
  country: ACountry
  company: ACompanyWithPermissions
  order?: ACompanyUserDashboardOrder | null
  permissions?: APermissions
}

export interface ACompanyUserDashboardFinishedSalesCycle {
  id: number
  name: string
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface ACompanyUserDashboardPausedSalesCycle {
  id: number
  name: string
  country: ACountry
  company: ACompanyWithPermissions
  permissions?: APermissions
}

export interface AWelcomeScreenSalesCycle {
  id: number
  name: string
  website?: string | null
  elevator_pitch: string
  story_description?: string
  product_benefits: string[]
  product_uniques?: string[]
  ideal_customer_profile: ASalesCycleIdealCustomerProfiles
  decision_maker_persona: string[]
  segment: ASalesCycleSegment
  references?: string[]
  years_of_market: ASalesCycleYearsOfMarkets
  successful_events?: string[] | null
  /**
   * @format date
   * @example "2023-04-28"
   */
  started_at: string | null
  price_list_url?: string | null
  strategy_finalized?: boolean
  hide_meeting_activities: boolean
  sales_talent_prospects_enabled: boolean
  advanced_search_enabled: boolean
  saas_selling: boolean
  key_details_finalized?: boolean
  strategy_touched?: boolean
  sales_scripts?: string | null
  additional_strategy_description?: string | null
  sales_person_offline_required: boolean
  sales_person_online_required: boolean
  segment_note?: string | null
  sales_person_requirements_note?: string | null
  articles_links?: string | null
  attachments?: AAttachments | null
  status?: ASalesCycleStatuses
  products: AProducts
  country: ACountry
  permissions?: APermissions
}

export interface ASalesCycleIteration {
  id: number
  /**
   * @format date
   * @example "2023-05-31"
   */
  start_date: string
  /**
   * @format date
   * @example "2023-05-31"
   */
  end_date: string
  company_name?: string
  sales_cycle: ASalesCycle
  assignments: AAssignmentShort[]
  permissions?: APermissions
}

export interface ACompanyUserSalesCycleIteration {
  id: number
  /**
   * @format date
   * @example "2023-05-31"
   */
  start_date: string
  /**
   * @format date
   * @example "2023-05-31"
   */
  end_date: string
  assignments: {
    id?: number
    reaches?: number
    outreach?: number
    statistics?: ACompanyUsersScopedStatistics
    sales_person?: ACompanyUserSalesPerson | null
    permissions?: APermissions
  }[]
  reaches: number
  outreach: number
  activities: number
  statistics: {
    emails?: number
    calls?: number
    meetings?: number
    closed_deals?: number
    rejections?: number
    clients?: number
    price_offers?: number
  }
  permissions?: APermissions
}

export interface ACompanyUserSalesCycleIterationReporting {
  id: number
  assignments: ACompanyUserAssignmentReporting[]
  statistics?: ACompanyUsersTrendsStatistics | null
  permissions: APermissions
}

export interface ASalesPlan {
  id: number
  name: string
  company_name: string
  current_value: number
  duration_in_months: number | null
  /** @format date-time */
  created_at?: string
  status: ASalesPlanStatusEnum
  current_assignments: AAssignmentShort[] | null
  country: ACountry
  currency: ACurrency
  permissions?: APermissions
}

export interface ASalesIntelligenceSalesCycleIterationStatistics {
  id: number
  activities?: number
  deals?: number
  active_deals?: number
  inactive_deals?: number
  activities_to_won?: number
  won_deals?: number
  won_deals_average?: number | null
  lost_deals?: number
  lost_deals_average?: number | null
  time_to_close?: number | null
  /**
   * @format date
   * @example "2025-06-01"
   */
  report_date: string
  period: ASalesStatisticPeriodValues
  deals_to_calls?: number
  deals_to_meetings?: number
  rotten_deals?: number
  rotten_deals_change?: number | null
  deals_to_calls_ratio?: number | null
  deals_to_calls_change?: number | null
  deals_to_meetings_ratio?: number | null
  deals_to_meetings_change?: number | null
  activities_to_won_average?: number | null
  permissions?: APermissions
}

export interface ASalesIntelligenceAssignmentStatistics {
  id: number
  activities?: number
  deals?: number
  active_deals?: number
  inactive_deals?: number
  activities_to_won?: number
  won_deals?: number
  lost_deals?: number
  time_to_close?: number | null
  /**
   * @format date
   * @example "2025-06-01"
   */
  report_date: string
  period: ASalesStatisticPeriodValues
  sales_person?: ACompanyUserSalesPerson | null
  permissions?: APermissions
}

export interface ASalesIntelligenceDashboardStatistics {
  id: number
  crm_utilization_ratio?: number | null
  crm_utilization_change?: number | null
  rotten_deals_ratio?: number | null
  rotten_deals_change?: number | null
  deals_without_plan_ratio?: number | null
  deals_without_plan_change?: number | null
  rotten_deals_one_month_ago_ratio?: number | null
  deals_without_plan_one_month_ago_ratio?: number | null
  rotten_deals_two_month_ago_ratio?: number | null
  deals_without_plan_two_month_ago_ratio?: number | null
  crm_utilization_one_month_ago_ratio?: number | null
  crm_utilization_two_month_ago_ratio?: number | null
  deals_with_plan_ratio?: number | null
  deals_with_plan_change?: number | null
  deals_with_plan_one_month_ago_ratio?: number | null
  deals_with_plan_two_month_ago_ratio?: number | null
  /**
   * @format date
   * @example "2025-06-01"
   */
  report_date: string
  period: ASalesStatisticPeriodValues
  permissions?: APermissions
}

export interface ASalesStrategy {
  id: number
  name: string
}

export interface ASalesStrategyWithPrice {
  id: number
  name: string
  price: number
  currency: ACurrency
  permissions?: APermissions
}

export interface ASettings {
  countries: ACountry[]
  currencies: ACurrency[]
  payments: {
    publishable_api_key: string
    vat_required_country_codes: string[]
  }
  permissions: {
    sales_cycle?: AResourceLevelPermissions
    country?: AResourceLevelPermissions
    currency?: AResourceLevelPermissions
    assignment_offer?: AResourceLevelPermissions
  }
  welcome_screen: boolean
  user: AUsersCompanyUser | AUsersSalesPerson | ASaasCompanyUser | ASaasSalesPerson
  masqueraded?: boolean
  reach_engine_enabled: boolean
}

export interface ASubscription {
  id: number
  status: ASubscriptionStatusEnum
  recurrence: ASubscriptionRecurrenceEnum
  /** @format date-time */
  cancel_requested_at: string | null
  /** @format date */
  scheduled_cancel_date: string | null
  /** @format date */
  nearest_cancel_date: string | null
  /** @format date */
  nearest_service_termination_date: string | null
  /** @format date */
  service_termination_date: string | null
  /** @format date-time */
  activated_at: string | null
}

export interface ATransaction {
  order_id: number
  payment_id: number
  invoice_number?: string | null
  /** @format date-time */
  paid_at?: string | null
  payment_status: ATransactionPaymentStatusEnum
  payment_method: APaymentMethods
  amount: number
  external_invoice_url: string
  sales_cycle: ASalesCycleSummary
  currency: ACurrency
}

export interface AImportedByUser {
  id?: number
  email?: string
  type?: AUserTypes
  first_name?: string | null
  last_name?: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  permissions?: APermissions
}

export interface ACompanyUserLogin {
  company_user?: {
    id?: number
    email?: string
    name?: string
    company_name?: string
    tac_agreement?: boolean
    company?: object
  }
}

export interface ASalesPersonLogin {
  sales_person?: {
    id?: number
    email?: string
    first_name?: string
    last_name?: string
    name?: string
    tac_agreement?: boolean
  }
}

export interface ASalesPerson {
  id?: number
  email?: string
  first_name?: string
  last_name?: string
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  video_introduction_viewed?: boolean
  synced_with_crm?: boolean
  permissions?: APermissions
}

export interface ACompanyUserSalesPerson {
  id: number
  first_name: string
  last_name: string
  profile_picture_url: string | null
  profile_picture_thumbnail_url: string | null
  permissions?: APermissions
}

export interface AMatchingSalesPerson {
  id: number
  email: string
  first_name: string
  last_name: string
  profile_picture_url: string | null
  profile_picture_thumbnail_url: string | null
  capacity: number
  remaining_capacity: number
  years_of_experience: number | null
  segment: ASalesPersonSegments
  accepted: boolean | null
  worked_on_previous_iteration: boolean
  worked_with_same_company: boolean
  synced_with_crm?: boolean
  country: ACountry
  permissions?: APermissions
}

export interface ASalesPersonProfile {
  id: number
  email: string
  first_name: string
  last_name: string
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  video_introduction_viewed?: boolean
  synced_with_crm?: boolean
  permissions?: APermissions
  profile: {
    email: string
    first_name: string
    last_name: string
    capacity: number
    phone_number?: string | null
    city?: string | null
    accepted: boolean
    linkedin_profile?: string | null
    about?: string | null
    years_of_experience?: number | null
    profile_picture_url?: string | null
    profile_picture_thumbnail_url?: string | null
    resume_url?: string | null
    /** @format date-time */
    accepted_at?: string | null
    segment?: ASalesPersonSegments
    country?: ACountry
    native_language?: ALanguage | null
    spoken_languages?: ALanguage[]
    permissions?: APermissions
  }
  learning_materials: {
    sales_person_education_finished: boolean
    closing_deals_education_finished: boolean
    onboarding_education_finished: boolean
    video_upload_finished: boolean
  }
}

export interface APublicSalesPerson {
  id: number
  first_name: string
  about?: string | null
  years_of_experience?: number | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  country: ACountry | null
  segment?: ASalesPersonSegments | null
  native_language?: ALanguage | null
  spoken_languages: ALanguage[]
  permissions?: APermissions
}

export interface AAcceptSalesPerson {
  accepted: boolean
}

export interface ASalesPersonAttributes {
  profile?: {
    email?: string
    first_name?: string
    last_name?: string
    linkedin_profile?: string
    segment?: ASalesPersonSegments
    about?: string
    years_of_experience?: number
    capacity?: number
    /** @format binary */
    profile_picture?: File
    /**
     * Upload CV file
     * @format binary
     */
    resume?: File
    phone_number?: string
    /** Country ID */
    country_id?: number
    /** Language ID */
    native_language_id?: number
    spoken_language_ids?: number[]
    video_introduction_viewed?: boolean
  }
  learning_materials?: {
    sales_person_education_finished?: boolean
    closing_deals_education_finished?: boolean
    onboarding_education_finished?: boolean
    video_upload_finished?: boolean
  }
}

export interface ASalesPersonDashboard {
  id: number
  assignment_offers: {
    id: number
    status: ASalesPersonDashboardStatusEnum
    /** @format date */
    valid_until: string
    /** @format date */
    starting_at: string
    reward_value: number
    reaches?: number
    minimum_meetings?: number
    currency: ACurrency
    products: AProduct[]
    sales_cycle: {
      id: number
      name: string
      segment: ASalesCycleSegment
      decision_maker_persona: string[]
      ideal_customer_profile: ASalesCycleIdealCustomerProfiles
      worked_with_same_company: boolean
      sales_strategy_url?: string | null
      price_list_url?: string | null
      elevator_pitch?: string | null
      company: AAssignmentOfferCompany
      country: ACountry
      permissions?: APermissions
    }
    permissions?: APermissions
  }[]
  sales_cycles: ASalesPersonDashboardSalesCyclesDetail
  permissions?: APermissions
  business_data_filled: boolean
}

export type ASalesPersonDashboardSalesCyclesDetail = {
  id: number
  name: string
  assigned_to_current_iteration: boolean
  segment: ASalesCycleSegment
  country: ACountry
  default_currency?: ACurrency | null
  status: ASalesCycleStatuses
  iteration_status: ASalesCycleIterationStatuses
  reward_value: number | null
  reaches: number | null
  minimum_meetings?: number | null
  month?: number
  year?: number
  sales_strategy_url: string | null
  price_list_url?: string | null
  products?: AProduct[]
  company_name: string
  statistics: {
    emails_sent: number
    emails_sent_activities: number
    emails_sent_total: number
    callings_done: number
    callings_done_activities: number
    callings_done_total: number
    meetings_happened: number
    meetings_happened_activities: number
    meetings_happened_total: number
    rejections: number
    deals: number
    price_offers: number
    outreach: number
    clients_in_pipeline: number
    current_stage: ADashboardStages
  } | null
  permissions?: APermissions
}[]

export interface AUser {
  id: number
  email: string
  type: AUserTypes
  first_name: string | null
  last_name: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
}

export interface AUsersCompanyUser {
  id: number
  email: string
  first_name: string
  last_name: string
  type: AUserTypes
  phone_number?: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  company: ACompany
  hero_section_visible: boolean
}

export interface AUsersSalesPerson {
  id: number
  email: string
  first_name: string
  last_name: string
  type: AUserTypes
  phone_number?: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  video_introduction_viewed: boolean
  leads_enabled?: boolean
  hero_section_visible: boolean
}

export type ASalesPersonSegments = ASalesPersonSegmentsEnum[]

export interface AAssignmentOfferCompany {
  name: string
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  permissions?: APermissions
}

export interface ACompanyUserCycleSalesPerson {
  id: number
  first_name: string
  last_name: string
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  permissions?: APermissions
}

export interface AAdminsProspectsAssignmentSalesPerson {
  id: number
  first_name: string
  last_name: string
  profile_picture_url: string | null
  profile_picture_thumbnail_url: string | null
}

export interface ACompanyUserSalesCycleSalesPerson {
  id: number
  first_name: string
  rating: number
  years_of_experience?: number | null
  native_language_id?: number | null
  spoken_language_ids?: number[] | null
  embed_video_id?: string | null
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  country?: ACountry
  packages?: APackageWithPrice[]
  permissions?: APermissions | null
}

export interface ACompanyUserDashboardSalesPerson {
  id: number
  first_name: string
  last_name: string
  profile_picture_url?: string | null
  profile_picture_thumbnail_url?: string | null
  permissions?: APermissions | null
}

export interface AWelcomeScreen {
  onboarding_status: AOnboardingStatuses
  sales_people: ACompanyUserSalesCycleSalesPerson[]
  sales_cycle?: AWelcomeScreenSalesCycle | null
  order?: AOrder | null
  requested_sales_person_assignments?: {
    id: number
    reaches: number
    status: string
    sales_person?: ACompanyUserSalesCycleSalesPerson | null
  }[]
  permissions?: APermissions
}

export enum AProspectActivityEventEnum {
  EmailSent = "email_sent",
  CallingDone = "calling_done",
  MeetingHappened = "meeting_happened",
  Won = "won",
  Lost = "lost",
  PriceOfferSent = "price_offer_sent",
}

export enum AOrderOrderTypeEnum {
  Subscription = "subscription",
  Commission = "commission",
}

export enum AVoucherCodeResultStatusEnum {
  Valid = "valid",
  Invalid = "invalid",
}

export enum APhoneFieldDnclStatusEnum {
  Clear = "clear",
  Listed = "listed",
  Failed = "failed",
}

export enum ASalesAssistantUpdateCenterEntryCallTypeEnum {
  SingleUpdate = "single_update",
  UpdateAll = "update_all",
}

export enum AKlaraDashboardSummaryModeEnum {
  Reach = "reach",
  SalesCycle = "sales_cycle",
}

export enum AKlaraRemindErrorsBaseEnum {
  NoChannel = "no_channel",
  RateLimited = "rate_limited",
  DealClosed = "deal_closed",
}

export enum AKlaraDashboardSalesFlowTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export enum AKlaraDashboardActivityTypeEnum {
  Email = "email",
  Call = "call",
  Meeting = "meeting",
  Other = "other",
}

export enum AKlaraDashboardLastUpdateEntryTypeEnum {
  Voice = "voice",
  Assistant = "assistant",
}

export enum AKlaraDashboardDealsMetaModeEnum {
  Reach = "reach",
  SalesCycle = "sales_cycle",
}

export enum AKlaraDashboardUpdateCenterEntryCallTypeEnum {
  SingleUpdate = "single_update",
  UpdateAll = "update_all",
}

export enum ACompanyUserSalesCycleStatusEnum {
  Finished = "finished",
  Active = "active",
  Incoming = "incoming",
}

export enum ASalesPlanStatusEnum {
  Starting = "starting",
  InProgress = "in_progress",
  Stopped = "stopped",
  Declined = "declined",
}

export enum ASubscriptionStatusEnum {
  Incomplete = "incomplete",
  Active = "active",
  Paused = "paused",
  Canceled = "canceled",
  PastDue = "past_due",
  Failed = "failed",
}

export enum ASubscriptionRecurrenceEnum {
  Month = "month",
  Year = "year",
}

export enum ATransactionPaymentStatusEnum {
  Awaiting = "awaiting",
  AuthorizationRequired = "authorization_required",
  Paid = "paid",
  Failed = "failed",
}

export enum ASalesPersonDashboardStatusEnum {
  Pending = "pending",
  Accepted = "accepted",
  Rejected = "rejected",
  Expired = "expired",
  Canceled = "canceled",
  PreMatched = "pre_matched",
}

export enum ASalesPersonSegmentsEnum {
  Fmcg = "fmcg",
  Finance = "finance",
  Retail = "retail",
  FoodIndustry = "food_industry",
  Marketing = "marketing",
  ECommerce = "e_commerce",
  Corporate = "corporate",
}

export interface ALeadsAssignmentsLeadsForAssignmentListData {
  leads: ALeadWithAssignmentProspect[]
  meta?: {
    pagination?: APagination
    total_leads_for_assignment: number
    added_prospects_count: number
  }
}

export interface ALeadsAssignmentsAddProspectFromLeadCreateData {
  lead?: ALeadWithAssignmentProspect
  meta?: AMeta
}

export interface AAdminLeadsAssignmentsAddProspectFromLeadCreateData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export interface AAdminLeadsAssignmentsDeleteProspectFromLeadDeleteData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export enum AProspectImportOwnershipLevelEnum {
  CloseRocket = "close_rocket",
  Company = "company",
  SalesPerson = "sales_person",
}

export type AProspectsAssignmentsUploadProspectsCreateData = any

export interface AProspectsAssignmentsProspectsPrepareToApproveListData {
  prospects?: AAdminProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsWaitingToApproveListData {
  prospects?: AAdminProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsFinishedListData {
  prospects?: AAdminProspect[]
  meta?: {
    pagination?: APagination
    sync_crm_button?: boolean
    available_segments?: string[]
  }
}

export type AProspectsAssignmentsSendForApprovalCreateData = any

export type AProspectsAssignmentsFinishApprovalCreateData = any

export type AProspectsAssignmentsSyncWithCrmCreateData = any

export type AProspectsAssignmentsApproveProspectsCreateData = any

export type AProspectsAssignmentsAcceptWarningsCreateData = any

export interface AProspectsSalesCyclesDetailData {
  sales_cycle: AAdminsProspectsSalesCycle
  meta?: AMeta
}

export interface AProspectsSalesCyclesLifetimeListData {
  prospects: AAdminProspect[]
  meta?: {
    pagination?: APagination
    lifetime_sales_people?: AUsersSalesPerson[]
  }
}

export interface AProspectsListData {
  prospects: AAdminProspect[]
  meta?: AMeta
}

export interface AProspectsExtendedIndexListData {
  sales_cycle_prospects: {
    /** Prospects assigned to the assignment (with sales person) */
    assigned_count: number
    /** Count of approved prospects */
    approved_count: number
    /** Prioritized prospects */
    prioritized_count: number
    /** Sales cycle prospects count */
    prospects_count: number
    /** Disapproved prospects */
    disapproved_count: number
    /** Prospects waiting for any approval change */
    not_approved_count: number
    /** Approved prospects waiting for the assignment or already assigned */
    approved_to_be_used_count: number
    /** Assigned or already used prospects during the selling with any approval status */
    assigned_or_used_count: number
    company: ACompanyWithPermissions
    prospects: AAdminProspect[]
    permissions?: APermissions
  }
  meta?: AMeta
}

export interface ASalesCyclesActivityFeedsListData {
  activity_feeds: AActivityFeed[]
  meta?: {
    pagination?: APagination
  }
}

export interface ASalesCyclesAssignmentsReportingListData {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsAssignmentsReportingListData {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export type ASalesCyclesSalesCycleIterationsFinalizeReportCreateData = any

export interface ASalesCyclesSalesCycleIterationsReportingListData {
  sales_cycle_iteration?: ACompanyUserSalesCycleIterationReporting
  meta?: AMeta
}

export interface ASalesCyclesReportingListData {
  sales_cycle?: ACompanyUserSalesCycleReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesNewsListData {
  sales_cycle?: AAdminSalesCycleSalesNews
  meta?: AMeta
}

export interface ASalesCyclesDetailsListData {
  sales_cycle?: AAdminSalesCycleDetails
  meta?: AMeta
}

export interface ASalesCyclesNewsAndInsightsListData {
  sales_cycle_iteration?: {
    id?: number | null
    month?: string | null
    news?: string | null
    insights?: string | null
  }
  meta?: AMeta
}

export interface ASalesCyclesActivitiesChartListData {
  chart_data?: AActivitiesChartData | null
}

export interface ASalesCyclesClientsReachedChartListData {
  chart_data?: AClientsReachChartData | null
}

export interface ASalesCyclesActivityOccurrencesChartListData {
  chart_data?: AActivityOccurrencesChartData | null
}

export interface ASalesCyclesOpportunitiesChartListData {
  chart_data?: AOpportunitiesChartData | null
}

export interface ASalesCyclesProspectsListData {
  prospects: ACompanyUserSalesCycleProspects[]
  meta?: {
    pagination?: APagination
    total_prospects_in_db: number
    stages_used: ASalesCycleFilterStages[]
  }
}

export interface ASalesCyclesProspectsAutocompleteValuesListData {
  values: {
    name: string
    value: string
  }[]
}

export interface AAssignmentOffersListData {
  assignment_offers: AAssignmentOffer[]
  meta?: AMeta
}

export interface AAssignmentOffersCreateData {
  assignment_offer: AAssignmentOffer
  meta?: AMeta
}

export interface AAssignmentOffersDetailData {
  assignment_offer: AAssignmentOffer
  meta?: AMeta
}

export interface AAssignmentOffersDeleteData {
  assignment_offer: AAssignmentOffer
  meta?: AMeta
}

export interface AAcceptPartialUpdateData {
  assignment_offer: AAssignmentOffer
  meta?: AMeta
}

export interface ARejectPartialUpdateData {
  assignment_offer: AAssignmentOffer
  meta?: AMeta
}

export interface AAssignmentsListData {
  assignments: AAssignmentShort[]
  meta?: AMeta
}

export interface AAssignmentsDetailData {
  assignment: AAssignment
  meta?: AMeta
}

export interface ARevokePartialUpdateData {
  assignment?: AAssignment
  meta?: AMeta
}

export interface ACompaniesDetailData {
  company: ACompanyProfile
}

/** To specify sections returned in response */
export enum ACompaniesDetailParamsSectionEnum {
  All = "all",
  Profile = "profile",
  Members = "members",
  Transactions = "transactions",
}

export type ACompaniesPartialUpdateData = any

/** To specify sections returned in response */
export enum ACompaniesPartialUpdateParamsSectionEnum {
  All = "all",
  Profile = "profile",
  Members = "members",
  Transactions = "transactions",
}

export type AActivityFeedsLikePartialUpdateData = any

export type AActivityFeedsDislikePartialUpdateData = any

export interface ADashboardDetailData {
  dashboard: ACompanyUserDashboard
  meta?: AMeta
}

export interface ADashboardActiveSalesCyclesListData {
  sales_cycles: ACompanyUserDashboardActiveSalesCycle[]
  meta?: AMeta
}

export interface ADashboardDraftedSalesCyclesListData {
  sales_cycles: ACompanyUserDashboardDraftedSalesCycle[]
  meta?: AMeta
}

export interface ADashboardFinishedSalesCyclesListData {
  sales_cycles: ACompanyUserDashboardFinishedSalesCycle[]
  meta?: AMeta
}

export interface ADashboardPausedSalesCyclesListData {
  sales_cycles: ACompanyUserDashboardPausedSalesCycle[]
  meta?: AMeta
}

export type AProspectsAssignmentsProspectDisapprovePartialUpdateData = any

export interface AProspectsAssignmentsProspectsWaitingToApproveListResult {
  prospects?: ACompanyUserProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsFinishedListResult {
  prospects?: ACompanyUserProspect[]
  meta?: AMeta
}

export type AProspectsAssignmentsApproveProspectsCreateResult = any

export interface AProspectsSalesCyclesDetailResult {
  sales_cycle: ACompanyProspectsSalesCycle
  meta?: AMeta
}

export interface AProspectsListResult {
  prospects: ACompanyUserProspect[]
  meta?: AMeta
}

export interface AProspectsExtendedIndexListResult {
  sales_cycle_prospects: {
    /** Prospects assigned to the assignment (with sales person) */
    assigned_count: number
    /** Count of approved prospects */
    approved_count: number
    /** Prioritized prospects */
    prioritized_count: number
    /** Sales cycle prospects count */
    prospects_count: number
    /** Disapproved prospects */
    disapproved_count: number
    /** Prospects waiting for any approval change */
    not_approved_count: number
    /** Approved prospects waiting for the assignment or already assigned */
    approved_to_be_used_count: number
    /** Assigned or already used prospects during the selling with any approval status */
    assigned_or_used_count: number
    company: ACompanyWithPermissions
    prospects: ACompanyUserProspect[]
    permissions?: APermissions
  }
  meta?: AMeta
}

export interface ASalesCycleIterationsDetailData {
  sales_cycle_iteration?: ACompanyUserSalesCycleIteration
  meta?: AMeta
}

export interface ASalesCyclesActivityFeedsListResult {
  activity_feeds: AActivityFeed[]
  meta?: {
    pagination?: APagination
  }
}

export interface ASalesCyclesAssignmentsReportingListResult {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsAssignmentsReportingListResult {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsReportingListResult {
  sales_cycle_iteration?: ACompanyUserSalesCycleIterationReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesPeopleListData {
  sales_people?: ACompanyUserSalesCycleSalesPerson[]
  meta?: {
    pagination: APagination
    sales_person_placeholder: {
      id?: number | null
      first_name?: string | null
      rating?: number
      years_of_experience?: number | null
      native_language_id?: number | null
      spoken_language_ids?: number[] | null
      embed_video_id?: string | null
      profile_picture_url?: string | null
      profile_picture_thumbnail_url?: string | null
      country: ACountry
      packages: APackageWithPrice[]
      permissions?: APermissions
    }
  }
}

export interface ASalesCyclesDetailData {
  sales_cycle?: ACompanyUserSalesCycle
  meta?: AMeta
}

export interface ASalesCyclesSalesNewsListResult {
  sales_cycle?: ACompanyUserSalesCycleSalesNews
  meta?: AMeta
}

export interface ASalesCyclesDetailsListResult {
  sales_cycle?: ACompanyUserSalesCycleDetails
  meta?: AMeta
}

export interface ASalesCyclesReportingListResult {
  sales_cycle?: ACompanyUserSalesCycleReporting
  meta?: AMeta
}

export interface ASalesCyclesNewsAndInsightsListResult {
  sales_cycle_iteration?: {
    id?: number | null
    month?: string | null
    news?: string | null
    insights?: string | null
  }
  meta?: AMeta
}

export interface ASalesCyclesActivitiesChartListResult {
  chart_data?: AActivitiesChartData | null
}

export interface ASalesCyclesClientsReachedChartListResult {
  chart_data?: AClientsReachChartData | null
}

export interface ASalesCyclesActivityOccurrencesChartListResult {
  chart_data?: AActivityOccurrencesChartData | null
}

export interface ASalesCyclesOpportunitiesChartListResult {
  chart_data?: AOpportunitiesChartData | null
}

export interface ASalesCyclesProspectsListResult {
  prospects: ACompanyUserSalesCycleProspects[]
  meta?: {
    pagination?: APagination
    total_prospects_in_db: number
    stages_used: ASalesCycleFilterStages[]
  }
}

export interface ASalesCyclesProspectsAutocompleteValuesListResult {
  values: {
    name: string
    value: string
  }[]
}

export type ACompanyUsersCreateData = any

export type AConfirmationCreateData = any

export interface AConfirmationPartialUpdateData {
  company_user?: AUsersCompanyUser
  meta?: AMeta
}

export interface AWelcomeScreenDetailData {
  welcome_screen: AWelcomeScreen
  meta?: AMeta
}

export interface ACountriesListData {
  countries: ACountry[]
}

export interface ACurrenciesListData {
  currencies?: ACurrency[]
}

export type ASignInCreateData = any

export type ASignOutDeleteData = any

export interface ARollbackDeleteData {
  importer?: AImporter
}

export interface AInvitationAcceptancesCreateData {
  message: string
}

export enum AUsersTypeEnum {
  CompanyUser = "company_user",
  SalesPerson = "sales_person",
}

export interface AInvitationsCreateData {
  processed_count: number
  skipped_count: number
  failures: {
    email: string
    errors: string[]
  }[]
}

export type AResendCreateData = any

export type ACancelCreateData = any

export interface AInvoiceDetailsListData {
  invoice_details: AInvoiceDetail[]
}

export interface AInvoiceDetailsCreateData {
  invoice_detail: AInvoiceDetail
}

export interface AInvoiceDetailsUpdateData {
  invoice_detail: AInvoiceDetail
}

export interface ALanguagesListData {
  languages?: ALanguage[]
  meta?: AMeta
}

export type ACustomElevatorPitchesDetailData = ACustomElevatorPitchResponse

export interface ALeadsListData {
  leads: ALead[]
  meta?: {
    pagination?: APagination
  }
}

export interface AAutocompleteValuesListData {
  values: {
    name: string
    value: string
  }[]
}

export type AImportCreateData = any

export type ASalesPersonImportCreateData = any

export type ALeadsDeleteData = any

export interface ALeadsDetailData {
  lead: ALeadDetail
  meta?: AMeta
}

export type ALeadsPartialUpdateData = any

export interface ALeadsDeleteResult {
  warnings: string[]
}

export interface AImportersListData {
  importers: AImporter[]
  meta: AMeta
}

export interface AIndexMetadataListData {
  leads_metadata: {
    import_in_progress: boolean
    total_leads_in_db: number
    removal_requested: number
  }
  meta?: AMeta
}

export interface ARemovalRequestsIndexListData {
  leads: ALead[]
  meta?: {
    pagination?: APagination
  }
}

export type AAcceptWarningsCreateData = any

export type AMasqueradeTargetsListData = AMasqueradeTarget[]

export interface AMatchableSalesPeopleListData {
  sales_people?: AMatchingSalesPerson[]
  meta?: AMeta
}

export interface APackagesListData {
  packages: APackageWithPrice[]
  setup_fee_strategy: ASalesStrategyWithPrice
}

export interface APendingConfirmationsDetailData {
  pending_confirmation?: {
    email?: string
    first_name?: string
    last_name?: string
    phone_number?: string
    company?: ACompany
  }
  meta?: AMeta
}

export type AImportCreateResult = any

export type ASalesPersonImportCreateResult = any

export type AApprovePartialUpdateData = any

export type ARemoveApproveStatusPartialUpdateData = any

export type ADisapprovePartialUpdateData = any

export type APrioritizePartialUpdateData = any

export type ADeprioritizePartialUpdateData = any

export interface AProspectsDisapprovePartialUpdateData {
  warnings: string[]
}

export interface AProspectsPrioritizePartialUpdateData {
  warnings: string[]
}

export interface AProspectsDeprioritizePartialUpdateData {
  warnings: string[]
}

export interface AProspectsDeleteData {
  warnings: string[]
}

export type ASaasCreateCreateData = any

export type AProspectsCreateData = any

export interface AProspectsPartialUpdateData {
  prospect?: AAdminProspect
  meta?: AMeta
}

export type AProspectsDeleteResult = any

export type ASaasUpdatePartialUpdateData = any

export type ARemoveDisapprovePartialUpdateData = any

export interface AActivitiesListData {
  activities?: AProspectActivity[]
  meta?: AMeta
}

export interface ANotesListData {
  deal_notes?: AProspectNote[]
  meta?: AMeta
}

export interface APrivacyRequestListData {
  privacy_request?: APublicPrivacyRequest
  meta?: AMeta
}

export type ARequestRemoveCreateData = any

export enum AChannelsChannelEnum {
  Email = "email",
  Call = "call",
  Whatsapp = "whatsapp",
  Linkedin = "linkedin",
  Sms = "sms",
}

export enum AChannelsStatusEnum {
  Active = "active",
  ActiveNoActivity = "active_no_activity",
  NotInFlows = "not_in_flows",
}

export interface AActivitiesListResult {
  /** @format date */
  from: string | null
  /** @format date */
  to: string | null
  channels: {
    channel: AChannelsChannelEnum
    status: AChannelsStatusEnum
    activities: number
    responses: number
  }[]
}

/** Restrict statistics to a single campaign type */
export enum AActivitiesListParams1CampaignTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export enum ACampaignsStatusEnum {
  Upcoming = "upcoming",
  Active = "active",
  Paused = "paused",
  Completed = "completed",
}

export enum ACampaignsCampaignTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export interface ACampaignsListData {
  campaigns?: {
    id?: number
    name?: string
    status?: ACampaignsStatusEnum
    campaign_type?: ACampaignsCampaignTypeEnum
    expected_conversion_min?: string | null
    expected_conversion_max?: string | null
    industry_conversion_min?: string | null
    industry_conversion_max?: string | null
    total_prospects?: number
    in_flows?: number
    waiting?: number
    activated?: number
    engaged?: number
    mql?: number
    sql?: number
    won?: number
    opportunities?: number
    lost?: number
    activated_companies?: number
    converted_companies?: number
    /** @format float */
    actual_conversion?: number
  }[]
  meta?: {
    lead_pool?: {
      total?: number
      in_flows?: number
      dormant?: number
    }
    sales_flows?: {
      total?: number
      active?: number
      finished?: number
      planned?: number
    }
    flow_types?: {
      flows?: {
        new_biz?: number
        upsell?: number
        cross_sell?: number
      }
      leads?: {
        new_biz?: number
        upsell?: number
        cross_sell?: number
      }
    }
    results?: {
      mql?: number
      sql?: number
      won?: number
      /** @format float */
      sales_team_conversion?: number
    }
    funnel?: {
      leads_in_flows?: number
      responses?: number
      mql?: number
      sql?: number
      back_in_pool?: number
    }
  }
}

export enum ACampaignsListParamsStatusEnum {
  Upcoming = "upcoming",
  Active = "active",
  Paused = "paused",
  Completed = "completed",
}

/** Campaign type to filter by */
export enum ACampaignsListParamsCampaignTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export interface AOutreachDepthListData {
  /** @format date */
  from: string | null
  /** @format date */
  to: string | null
  buckets: {
    label: string
    min: number
    max: number | null
    mql: number
    sql: number
  }[]
}

/** Restrict results to a single campaign type */
export enum AOutreachDepthListParamsCampaignTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export interface AResultsOverTimeListData {
  /** @format date */
  from: string | null
  /** @format date */
  to: string | null
  buckets: {
    /** @format date */
    week_starting: string
    mql: number
    sql: number
    cumulative_mql: number
    cumulative_sql: number
  }[]
}

/** Restrict results to a single campaign type */
export enum AResultsOverTimeListParamsCampaignTypeEnum {
  NewBiz = "new_biz",
  Upsell = "upsell",
  CrossSell = "cross_sell",
}

export interface AConfirmationCreateResult {
  message?: string
}

export interface ADashboardListData {
  dashboard?: {
    dates?: string[]
  }
  meta?: AMeta
}

export interface ADashboardSalesIntelligenceListData {
  sales_intelligence?: ASalesIntelligenceDashboardStatistics
  meta?: AMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsListData {
  drafted_prospects?: AAdvancedSearchDraftedProspect[]
  meta?: AAdvancedSearchDraftedProspectMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListData {
  drafted_prospects?: ADetailedAdvancedSearchDraftedProspect[]
  meta?: ADetailedAdvancedSearchDraftedProspectMeta
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateData = any

export interface ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateData {
  transferred_count: number
  note?: string | null
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateData {
  url: string
  note?: string | null
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateData = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateData = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsDeleteData = any

export interface ALeadsAdvancedSearchSessionsCreateData {
  advanced_search_session?: AAdvancedSearchSession
  meta?: AMeta
}

export interface ALeadsAssignmentsLeadsForAssignmentListResult {
  leads: ALeadWithAssignmentProspect[]
  meta?: {
    pagination?: APagination
    total_leads_for_assignment: number
    added_prospects_count: number
  }
}

export interface ALeadsAssignmentsAddProspectFromLeadCreateResult {
  lead?: ALeadWithAssignmentProspect
  meta?: AMeta
}

export interface ASaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreateData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export interface ASaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDeleteData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export type AOnboardingStatusListData = ASaasCompanyUserOnboardingStatus

export type AProspectsAssignmentsUploadProspectsCreateResult = any

export interface AProspectsAssignmentsProspectsFinishedListOutput {
  prospects?: ASaasCompanyUserProspect[]
  meta?: {
    pagination?: APagination
    sync_crm_button?: boolean
    available_segments?: string[]
  }
}

export type AProspectsAssignmentsSyncWithCrmCreateResult = any

export interface AProspectsAssignmentsDownloadProspectsListData {
  prospect_export_url?: string
}

export type AProspectsAssignmentsApproveProspectsCreateOutput = any

export interface AProspectsSalesCyclesDetailOutput {
  sales_cycle: ASaasCompanyProspectsSalesCycle
  meta?: AMeta
}

export interface ASaasCompanyUsersCreateData {
  saas_company_user?: ASaasCompanyUser
  meta?: object
}

export interface ASalesAssistantCompanySettingsListData {
  company_settings: AKlaraCompanySettings
}

export interface ASalesAssistantCompanySettingsPartialUpdateData {
  company_settings: AKlaraCompanySettings
}

export interface ASalesAssistantDashboardDealsDetailData {
  deal: AKlaraDashboardDealDetail
}

export type ASalesAssistantDashboardDealsPartialUpdateData = any

export type ASalesAssistantDashboardDealsRemindCreateData = any

export interface ASalesAssistantDashboardSalesPeopleListData {
  time_zone: string
  /** @format date-time */
  as_of: string
  /** @format float */
  team_coverage_rate: number | null
  sales_people: AKlaraDashboardSalesPersonRow[]
}

export type ASalesAssistantDashboardSummaryListData = AKlaraDashboardSummary

export interface ASalesAssistantDashboardUpdatesOverTimeListData {
  time_zone: string
  /** @format date-time */
  as_of: string
  granularity: AKlaraDashboardGranularityValues
  buckets: AKlaraDashboardBucket[]
}

export type ASalesAssistantDealsListData =
  | {
      deals?: ASalesAssistantDeal[]
      meta?: AMeta
    }
  | {
      deals: AKlaraDashboardDeal[]
      meta: AKlaraDashboardDealsMeta
    }

/** Klara dashboard mode; the from/to/view/chip params apply only with dashboard=true */
export enum ASalesAssistantDealsListParamsDashboardEnum {
  True = "true",
}

export interface ASalesAssistantDealsDetailData {
  prospect?: ASalesAssistantProspect
  meta?: AMeta
}

export interface ASalesAssistantSalesPeopleListData {
  sales_people?: ASalesAssistantSalesPerson[]
  meta?: AMeta
}

export interface ASalesAssistantSalesPeopleSelectBoxIndexListData {
  sales_people?: ASalesAssistantSalesPersonBasic[]
}

export type ASalesAssistantCreateCallCreateData = any

export interface ASalesAssistantSettingsListData {
  sales_person?: ASalesAssistantSalesPersonSettings
}

export type ASalesAssistantSettingsPartialUpdateData = any

export type ASalesAssistantTasksPartialUpdateData = any

export type ASalesAssistantTasksCreateData = any

export type ASalesAssistantUpdateCenterListData =
  | {
      update_center_entries?: ASalesAssistantUpdateCenterEntry[]
      meta?: AMeta
    }
  | {
      update_center_entries: AKlaraDashboardUpdateCenterEntry[]
      meta: AKlaraDashboardUpdateCenterMeta
    }

/** Klara dashboard mode; the from/to/deal_id params apply only with dashboard=true */
export enum ASalesAssistantUpdateCenterListParamsDashboardEnum {
  True = "true",
}

export interface ASalesCyclesActivityFeedsListOutput {
  activity_feeds: AActivityFeed[]
  meta?: {
    pagination?: APagination
  }
}

export interface ASalesCyclesAssignmentsReportingListOutput {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsAssignmentsReportingListOutput {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsReportingListOutput {
  sales_cycle_iteration?: ACompanyUserSalesCycleIterationReporting
  meta?: AMeta
}

export interface ASalesCyclesListData {
  sales_cycles?: ASaasCompanyUserDashboardSalesCycle[]
  meta?: AMeta
}

export interface ASalesCyclesSalesIntelligenceIndexListData {
  sales_cycles?: ASaasCompanySalesIntelligenceDashboardSalesCycle[]
  meta?: AMeta
}

export interface ASalesCyclesDetailResult {
  sales_cycle?: ASaasCompanyUserSalesCycle
  meta?: AMeta
}

export interface ASalesCyclesReportingListOutput {
  sales_cycle?: ASaasCompanyUserSalesCycleReporting
  meta?: AMeta
}

export interface ASalesCyclesNewsAndInsightsListOutput {
  sales_cycle_iteration?: {
    id?: number | null
    month?: string | null
    news?: string | null
    insights?: string | null
  }
  meta?: AMeta
}

export interface ASalesCyclesActivitiesChartListOutput {
  chart_data?: AActivitiesChartData | null
}

export interface ASalesCyclesClientsReachedChartListOutput {
  chart_data?: AClientsReachChartData | null
}

export interface ASalesCyclesActivityOccurrencesChartListOutput {
  chart_data?: AActivityOccurrencesChartData | null
}

export interface ASalesCyclesOpportunitiesChartListOutput {
  chart_data?: AOpportunitiesChartData | null
}

export interface ASalesCyclesProspectsListOutput {
  prospects: ACompanyUserSalesCycleProspects[]
  meta?: {
    pagination?: APagination
    total_prospects_in_db: number
    stages_used: ASalesCycleFilterStages[]
  }
}

export interface ASalesCyclesProspectsAutocompleteValuesListOutput {
  values: {
    name: string
    value: string
  }[]
}

export interface ASalesCyclesSalesNewsListOutput {
  sales_cycle?: ACompanyUserSalesCycleSalesNews
  meta?: AMeta
}

export interface AUsersListData {
  users?: ASaasCompanyUserListItem[]
  meta?: AMeta
}

/** Sort by values */
export enum AUsersListParamsSortByEnum {
  Name = "name",
  Role = "role",
  Joined = "joined",
  Status = "status",
}

/** Sort by direction */
export enum AUsersListParamsSortDirectionEnum {
  Asc = "asc",
  Desc = "desc",
}

export enum AUsersListParamsStatusEnum {
  Active = "active",
  Deactivated = "deactivated",
  Invited = "invited",
}

export enum AUsersListParamsRoleEnum {
  Owner = "owner",
  Admin = "admin",
  SalesPerson = "sales_person",
}

export type AUsersDeactivateCreateData = any

export type AUsersActivateCreateData = any

export interface AUsersStatsListData {
  counts: {
    owner: number
    admin: number
    sales_person: number
  }
}

export interface ADashboardListResult {
  dashboard?: {
    dates?: string[]
  }
  meta?: AMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsListResult {
  drafted_prospects?: AAdvancedSearchDraftedProspect[]
  meta?: AAdvancedSearchDraftedProspectMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListResult {
  drafted_prospects?: ADetailedAdvancedSearchDraftedProspect[]
  meta?: ADetailedAdvancedSearchDraftedProspectMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateResult {
  url: string
  note?: string | null
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateResult = any

export interface ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateResult {
  transferred_count: number
  note?: string | null
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateResult = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateResult = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsDeleteResult = any

export interface ALeadsAdvancedSearchSessionsCreateResult {
  advanced_search_session?: AAdvancedSearchSession
  meta?: AMeta
}

export interface ALeadsAssignmentsLeadsForAssignmentListOutput {
  leads: ALeadWithAssignmentProspect[]
  meta?: {
    pagination?: APagination
    total_leads_for_assignment: number
    added_prospects_count: number
  }
}

export interface ALeadsAssignmentsAddProspectFromLeadCreateOutput {
  lead?: ALeadWithAssignmentProspect
  meta?: AMeta
}

export interface ASaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export interface ASaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export type AProspectsAssignmentsUploadProspectsCreateOutput = any

export interface AProspectsAssignmentsProspectsPrepareToApproveListResult {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsWaitingToApproveListOutput {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsFinishedListResponse {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsDownloadProspectsListResult {
  prospect_export_url?: string
}

export type AProspectsAssignmentsSendForApprovalCreateResult = any

export interface AProspectsSalesCyclesDetailResponse {
  sales_cycle: ASalesPersonProspectsSalesCycle
  meta?: AMeta
}

export interface ASalesAssistantDealsListResult {
  deals?: ASalesAssistantDeal[]
  meta?: AMeta
}

export interface ASalesAssistantDealsDetailResult {
  prospect?: ASalesAssistantProspect
  meta?: AMeta
}

export interface ASalesAssistantSalesPeopleListResult {
  sales_people?: ASalesAssistantSalesPerson[]
  meta?: AMeta
}

export type ASalesAssistantCreateCallCreateResult = any

export interface ASalesAssistantSettingsListResult {
  sales_person?: ASalesAssistantSalesPersonSettings
}

export type ASalesAssistantSettingsPartialUpdateResult = any

export type ASalesAssistantTasksPartialUpdateResult = any

export type ASalesAssistantTasksCreateResult = any

export interface ASalesAssistantUpdateCenterListResult {
  update_center_entries?: ASalesAssistantUpdateCenterEntry[]
  meta?: AMeta
}

export interface ASalesCyclesActivityFeedsListResponse {
  activity_feeds: AActivityFeed[]
  meta?: {
    pagination?: APagination
  }
}

export interface ASalesCyclesAssignmentsReportingListResponse {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsAssignmentsReportingListResponse {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsReportingListResponse {
  sales_cycle_iteration?: ACompanyUserSalesCycleIterationReporting
  meta?: AMeta
}

export interface ASalesCyclesDetailOutput {
  sales_cycle?: ASaasSalesPersonSalesCycle
  meta?: AMeta
}

export interface ASalesCyclesSalesNewsListResponse {
  sales_cycle?: ASalesPersonSalesCycleSalesNews
  meta?: AMeta
}

export interface ASalesCyclesSalesIntelligenceIndexListResult {
  sales_cycles?: ASaasSalesPersonSalesIntelligenceDashboardSalesCycle[]
  meta?: AMeta
}

export interface ASalesCyclesReportingListResponse {
  sales_cycle?: ACompanyUserSalesCycleReporting
  meta?: AMeta
}

export interface ASalesCyclesActivitiesChartListResponse {
  chart_data?: AActivitiesChartData | null
}

export interface ASalesCyclesClientsReachedChartListResponse {
  chart_data?: AClientsReachChartData | null
}

export interface ASalesCyclesActivityOccurrencesChartListResponse {
  chart_data?: AActivityOccurrencesChartData | null
}

export interface ASalesCyclesOpportunitiesChartListResponse {
  chart_data?: AOpportunitiesChartData | null
}

export interface ASalesCyclesProspectsListResponse {
  prospects: ACompanyUserSalesCycleProspects[]
  meta?: {
    pagination?: APagination
    total_prospects_in_db: number
    stages_used: ASalesCycleFilterStages[]
  }
}

export interface ASalesCyclesProspectsAutocompleteValuesListResponse {
  values: {
    name: string
    value: string
  }[]
}

export interface ASalesCycleIterationsListData {
  sales_cycle_iterations: ASalesCycleIteration[]
  meta?: {
    pagination?: APagination
    tabs?: {
      waiting_for_acceptance?: number
      waiting_for_matching?: number
      ready_to_start?: number
      active?: number
      declined?: number
      finished?: number
    }
  }
}

/** Status filter */
export enum ASalesCycleIterationsListParamsStatusEnum {
  WaitingForMatching = "waiting_for_matching",
  Finished = "finished",
  ReadyToStart = "ready_to_start",
  Active = "active",
  WaitingForAcceptance = "waiting_for_acceptance",
  Declined = "declined",
}

export interface ASalesCycleIterationsDetailResult {
  sales_cycle_iteration?: ASalesCycleIteration
  meta?: AMeta
}

export interface ASalesCyclesListResult {
  sales_cycles?: ASalesCycle[]
  meta?: AMeta
}

export type ASalesCyclesCreateData = any

export interface ASalesCyclesDetailResponse {
  sales_cycle?: ASalesCycle
  meta?: AMeta
}

export type ASalesCyclesPartialUpdateData = any

export type AFinalizeCreateData = any

export type AFinalizeKeyDetailsCreateData = any

export interface APackagesListResult {
  packages: APackageWithPrice[]
  setup_fee_strategy: ASalesStrategyWithPrice
}

export type ARemoveAttachmentDeleteData = any

export interface ALeadsAdvancedSearchSessionsDraftedProspectsListOutput {
  drafted_prospects?: AAdvancedSearchDraftedProspect[]
  meta?: AAdvancedSearchDraftedProspectMeta
}

export interface ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListOutput {
  drafted_prospects?: ADetailedAdvancedSearchDraftedProspect[]
  meta?: ADetailedAdvancedSearchDraftedProspectMeta
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateOutput = any

export interface ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateOutput {
  transferred_count: number
  note?: string | null
}

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateOutput = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateOutput = any

export type ALeadsAdvancedSearchSessionsDraftedProspectsDeleteOutput = any

export interface ALeadsAdvancedSearchSessionsCreateOutput {
  advanced_search_session?: AAdvancedSearchSession
  meta?: AMeta
}

export interface ALeadsAssignmentsLeadsForAssignmentListResponse {
  leads: ALeadWithAssignmentProspect[]
  meta?: {
    pagination?: APagination
    total_leads_for_assignment: number
    added_prospects_count: number
  }
}

export interface ALeadsAssignmentsAddProspectFromLeadCreateResponse {
  lead?: ALeadWithAssignmentProspect
  meta?: AMeta
}

export interface ASalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export interface ASalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData {
  leads: ALeadWithAssignmentProspect[]
  warnings: string[]
  processed_count: number
  skipped_count: number
}

export interface AProspectsAssignmentsProspectsPrepareToApproveListOutput {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsWaitingToApproveListResponse {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export interface AProspectsAssignmentsProspectsFinishedListPayload {
  prospects?: ASalesPersonProspect[]
  meta?: AMeta
}

export type AProspectsAssignmentsSendForApprovalCreateOutput = any

export interface AProspectsSalesCyclesDetailPayload {
  sales_cycle: ASalesPersonProspectsSalesCycle
  meta?: AMeta
}

export interface ASalesCyclesActivityFeedsListPayload {
  activity_feeds: AActivityFeed[]
  meta?: {
    pagination?: APagination
  }
}

export interface ASalesCyclesAssignmentsReportingListPayload {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsAssignmentsReportingListPayload {
  assignment?: ACompanyUserSalesCycleIterationAssignmentReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesCycleIterationsReportingListPayload {
  sales_cycle_iteration?: ACompanyUserSalesCycleIterationReporting
  meta?: AMeta
}

export interface ASalesCyclesSalesNewsListPayload {
  sales_cycle?: ASalesPersonSalesCycleSalesNews
  meta?: AMeta
}

export interface ASalesCyclesDetailsListOutput {
  sales_cycle?: AAdminSalesCycleDetails
  meta?: AMeta
}

export interface ASalesCyclesReportingListPayload {
  sales_cycle?: ACompanyUserSalesCycleReporting
  meta?: AMeta
}

export interface ASalesCyclesActivitiesChartListPayload {
  chart_data?: AActivitiesChartData | null
}

export interface ASalesCyclesClientsReachedChartListPayload {
  chart_data?: AClientsReachChartData | null
}

export interface ASalesCyclesActivityOccurrencesChartListPayload {
  chart_data?: AActivityOccurrencesChartData | null
}

export interface ASalesCyclesOpportunitiesChartListPayload {
  chart_data?: AOpportunitiesChartData | null
}

export interface ASalesCyclesProspectsListPayload {
  prospects: ACompanyUserSalesCycleProspects[]
  meta?: {
    pagination?: APagination
    total_prospects_in_db: number
    stages_used: ASalesCycleFilterStages[]
  }
}

export interface ASalesCyclesProspectsAutocompleteValuesListPayload {
  values: {
    name: string
    value: string
  }[]
}

export type ASalesPeopleCreateData = any

export type AConfirmationCreateOutput = any

export interface AConfirmationPartialUpdateResult {
  sales_person: AUsersSalesPerson
  meta?: AMeta
}

export interface ASalesPeopleDetailData {
  sales_person: ASalesPersonProfile
  meta?: AMeta
}

/** To specify sections returned in response */
export enum ASalesPeopleDetailParamsSectionEnum {
  All = "all",
  Profile = "profile",
  LearningMaterials = "learning_materials",
}

export type ASalesPeoplePartialUpdateData = any

/** To specify sections returned in response */
export enum ASalesPeoplePartialUpdateParamsSectionEnum {
  All = "all",
  Profile = "profile",
  LearningMaterials = "learning_materials",
}

export interface APublicListData {
  sales_person: APublicSalesPerson
  meta: AMeta
}

export type AAcceptPartialUpdateResult = any

/** To specify sections returned in response */
export enum AAcceptPartialUpdateParams1SectionEnum {
  All = "all",
  Profile = "profile",
  LearningMaterials = "learning_materials",
}

export interface ABusinessDataListData {
  business_data?: ABusinessData | null
  meta?: AMeta | null
}

export type ASubmitBusinessDataCreateData = any

export interface ADashboardDetailResult {
  dashboard: ASalesPersonDashboard
  meta?: AMeta
}

export interface ASalesPlansListData {
  sales_plans?: ASalesPlan[]
  meta?: {
    pagination?: APagination
    tabs?: {
      all?: number
      starting?: number
      in_progress?: number
      declined?: number
      stopped?: number
    }
  }
}

export interface ASettingsListData {
  settings: ASettings
  meta?: AMeta
}

export interface ACheckoutDetailData {
  order?: AOrder
}

export interface ACheckoutCreateData {
  order?: AOrder
  clientSecret?: string
}

export interface ACheckoutUpdateData {
  order: AOrder
}

export interface ACheckoutPreviewListData {
  preview_order?: APreviewOrder
}

export interface ACheckoutCreate2Data {
  order: AOrder
}

export interface ACancelCreateResult {
  subscription: ASubscription
  meta?: AMeta
}

export type APasswordCreateData = any

export type APasswordUpdateData = any

export namespace Admins {
  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsLeadsForAssignmentList
   * @summary List of all assignment leads
   * @request GET:/admins/leads/assignments/{id}/leads_for_assignment
   */
  export namespace LeadsAssignmentsLeadsForAssignmentList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Contact person name search query */
      contact_person_search?: string
      /** Organization name search query */
      organization_name_search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "cities[]"?: string[]
      phone_number_present?: boolean
      email_present?: boolean
      contacted_already?: boolean
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsLeadsForAssignmentListData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add prospect to sales cycle from the leads database
   * @request POST:/admins/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace LeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      lead_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsAddProspectFromLeadCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsUploadProspectsCreate
   * @summary Assignment upload prospects for Admin Prospects
   * @request POST:/admins/prospects/assignments/{id}/upload_prospects
   */
  export namespace ProspectsAssignmentsUploadProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      "prospect_import[ownership_level]"?: AProspectImportOwnershipLevelEnum | null
      "prospect_import[ownership_id]"?: number | null
      "prospect_import[source]": string
      /** Attach prospect import file */
      "prospect_import[prospects_file]": File
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsUploadProspectsCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsPrepareToApproveList
   * @summary List of all prospects for assignment waiting to send for approve
   * @request GET:/admins/prospects/assignments/{id}/prospects_prepare_to_approve
   */
  export namespace ProspectsAssignmentsProspectsPrepareToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      sales_person_id?: number
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsPrepareToApproveListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsWaitingToApproveList
   * @summary List of all prospects for assignment waiting to approve by company
   * @request GET:/admins/prospects/assignments/{id}/prospects_waiting_to_approve
   */
  export namespace ProspectsAssignmentsProspectsWaitingToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      sales_person_id?: number
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsWaitingToApproveListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsFinishedList
   * @summary List of all prospects for assignment already finished
   * @request GET:/admins/prospects/assignments/{id}/prospects_finished
   */
  export namespace ProspectsAssignmentsProspectsFinishedList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      sales_person_id?: number
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsFinishedListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsSendForApprovalCreate
   * @summary Send assignment prospects in the draft status for approval
   * @request POST:/admins/prospects/assignments/{id}/send_for_approval
   */
  export namespace ProspectsAssignmentsSendForApprovalCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsSendForApprovalCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsFinishApprovalCreate
   * @summary Finish approval process of ready-to-approve prospects
   * @request POST:/admins/prospects/assignments/{id}/finish_approval
   */
  export namespace ProspectsAssignmentsFinishApprovalCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsFinishApprovalCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsSyncWithCrmCreate
   * @summary Sync approved finished assigned prospects with the CRM
   * @request POST:/admins/prospects/assignments/{id}/sync_with_crm
   */
  export namespace ProspectsAssignmentsSyncWithCrmCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsSyncWithCrmCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsApproveProspectsCreate
   * @summary Approve and finished prospects without notifications
   * @request POST:/admins/prospects/assignments/{id}/approve_prospects
   */
  export namespace ProspectsAssignmentsApproveProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsApproveProspectsCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsAcceptWarningsCreate
   * @summary Approve prospect normalization warnings
   * @request POST:/admins/prospects/assignments/{id}/accept_warnings/{prospect_id}
   */
  export namespace ProspectsAssignmentsAcceptWarningsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
      /** Prospect ID */
      prospectId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsAcceptWarningsCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesDetail
   * @summary Sales Cycle detail for Prospects
   * @request GET:/admins/prospects/sales_cycles/{id}
   */
  export namespace ProspectsSalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesDetailData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesLifetimeList
   * @summary Sales Cycle detail for Prospects
   * @request GET:/admins/prospects/sales_cycles/{id}/lifetime
   */
  export namespace ProspectsSalesCyclesLifetimeList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      sales_person_id?: number
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesLifetimeListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsList
   * @summary List of all prospects with admin-visible data
   * @request GET:/admins/prospects
   */
  export namespace ProspectsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Prospects sales cycle ID */
      sales_cycle_id: number
      /** Search in phone numbers, email and organization name */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsExtendedIndexList
   * @summary List of all prospects with admin-visible data and prospects statistics
   * @request GET:/admins/prospects/extended_index
   */
  export namespace ProspectsExtendedIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Prospects sales cycle ID */
      sales_cycle_id: number
      /** Search in phone numbers, email and organization name */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsExtendedIndexListData
  }

  /**
   * No description
   * @tags Admins/ActivityFeeds
   * @name SalesCyclesActivityFeedsList
   * @summary Admin activity feed for the current sales cycle
   * @request GET:/admins/sales_cycles/{sales_cycle_id}/activity_feeds
   */
  export namespace SalesCyclesActivityFeedsList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityFeedsListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/admins/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesAssignmentsReportingListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      salesCycleIterationId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsAssignmentsReportingListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesSalesCycleIterationsFinalizeReportCreate
   * @summary Admin finalize report for sales cycle iteration reporting data
   * @request POST:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/finalize_report
   */
  export namespace SalesCyclesSalesCycleIterationsFinalizeReportCreate {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsFinalizeReportCreateData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesSalesCycleIterationsReportingList
   * @summary Sales cycle iteration reporting data
   * @request GET:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsReportingListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesReportingList
   * @summary Sales cycle reporting data
   * @request GET:/admins/sales_cycles/{id}/reporting
   */
  export namespace SalesCyclesReportingList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesReportingListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesSalesNewsList
   * @summary Sales cycle - current iteration sales news
   * @request GET:/admins/sales_cycles/{id}/sales_news
   */
  export namespace SalesCyclesSalesNewsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesNewsListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesDetailsList
   * @summary Sales cycle detail
   * @request GET:/admins/sales_cycles/{id}/details
   */
  export namespace SalesCyclesDetailsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailsListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesNewsAndInsightsList
   * @summary Sales cycle / sales cycle iteration news and insights
   * @request GET:/admins/sales_cycles/{id}/news_and_insights
   */
  export namespace SalesCyclesNewsAndInsightsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesNewsAndInsightsListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesActivitiesChartList
   * @summary Sales cycle activities chart data
   * @request GET:/admins/sales_cycles/{id}/activities_chart
   */
  export namespace SalesCyclesActivitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivitiesChartListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesClientsReachedChartList
   * @summary Sales cycle clients reached chart data
   * @request GET:/admins/sales_cycles/{id}/clients_reached_chart
   */
  export namespace SalesCyclesClientsReachedChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesClientsReachedChartListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesActivityOccurrencesChartList
   * @summary Activity occurrences chart data
   * @request GET:/admins/sales_cycles/{id}/activity_occurrences_chart
   */
  export namespace SalesCyclesActivityOccurrencesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      activity_event: AActivityEvents
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityOccurrencesChartListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesOpportunitiesChartList
   * @summary Opportunities chart data
   * @request GET:/admins/sales_cycles/{id}/opportunities_chart
   */
  export namespace SalesCyclesOpportunitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesOpportunitiesChartListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesProspectsList
   * @summary Admins list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
   * @request GET:/admins/sales_cycles/{id}/prospects
   */
  export namespace SalesCyclesProspectsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      /** Search query */
      search?: string
      /** Last changed within */
      last_change?: string
      "statuses[]"?: string[]
      "stages[]"?: string[]
      "segments[]"?: string[]
      /** Sort by values */
      sort_by?: ASalesCyclesProspectValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsListData
  }

  /**
   * No description
   * @tags Admins/SalesCycles
   * @name SalesCyclesProspectsAutocompleteValuesList
   * @summary Admins the 10 most similar autocomplete values for specified field and value
   * @request GET:/admins/sales_cycles/{id}/prospects_autocomplete_values
   */
  export namespace SalesCyclesProspectsAutocompleteValuesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Autocomplete field */
      field: ASalesCycleProspectAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsAutocompleteValuesListData
  }
}

export namespace BulkActions {
  /**
   * No description
   * @tags Leads
   * @name AdminLeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add many prospects to assignment from the leads database
   * @request POST:/bulk_actions/admin/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace AdminLeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AAdminLeadsAssignmentsAddProspectFromLeadCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name AdminLeadsAssignmentsDeleteProspectFromLeadDelete
   * @summary Delete assigment prospects created from provided leads
   * @request DELETE:/bulk_actions/admin/leads/assignments/{id}/delete_prospect_from_lead
   */
  export namespace AdminLeadsAssignmentsDeleteProspectFromLeadDelete {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AAdminLeadsAssignmentsDeleteProspectFromLeadDeleteData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsDelete
   * @summary Remove a list of leads
   * @request DELETE:/bulk_actions/leads
   */
  export namespace LeadsDelete {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
      delete_strategy?: ALeadDeleteStrategies
    }
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsDeleteResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsDisapprovePartialUpdate
   * @summary Disapprove a list of prospects
   * @request PATCH:/bulk_actions/prospects/disapprove
   */
  export namespace ProspectsDisapprovePartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
      disapprove_reason: AProspectDisapproveReasons
      disapprove_reason_text?: string | null
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsDisapprovePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsPrioritizePartialUpdate
   * @summary Prioritize a list of prospects
   * @request PATCH:/bulk_actions/prospects/prioritize
   */
  export namespace ProspectsPrioritizePartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsPrioritizePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsDeprioritizePartialUpdate
   * @summary Deprioritize a list of prospects
   * @request PATCH:/bulk_actions/prospects/deprioritize
   */
  export namespace ProspectsDeprioritizePartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsDeprioritizePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsDelete
   * @summary Remove a list of prospects
   * @request DELETE:/bulk_actions/prospects
   */
  export namespace ProspectsDelete {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsDeleteData
  }

  /**
   * No description
   * @tags Leads
   * @name SaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add many prospects to assignment from the leads database
   * @request POST:/bulk_actions/saas_company_users/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace SaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name SaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDelete
   * @summary Delete assigment prospects created from provided leads
   * @request DELETE:/bulk_actions/saas_company_users/leads/assignments/{id}/delete_prospect_from_lead
   */
  export namespace SaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDelete {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDeleteData
  }

  /**
   * No description
   * @tags Leads
   * @name SaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add many prospects to assignment from the leads database
   * @request POST:/bulk_actions/saas_sales_people/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace SaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name SaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete
   * @summary Delete assigment prospects created from provided leads
   * @request DELETE:/bulk_actions/saas_sales_people/leads/assignments/{id}/delete_prospect_from_lead
   */
  export namespace SaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData
  }

  /**
   * No description
   * @tags Leads
   * @name SalesPeopleLeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add many prospects to assignment from the leads database
   * @request POST:/bulk_actions/sales_people/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace SalesPeopleLeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name SalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete
   * @summary Delete assigment prospects created from provided leads
   * @request DELETE:/bulk_actions/sales_people/leads/assignments/{id}/delete_prospect_from_lead
   */
  export namespace SalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      ids: number[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData
  }
}

export namespace AssignmentOffers {
  /**
   * No description
   * @tags Assignment Offers
   * @name AssignmentOffersList
   * @summary List of all assignment_offers
   * @request GET:/assignment_offers
   */
  export namespace AssignmentOffersList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentOffersListData
  }

  /**
   * No description
   * @tags Assignment Offers
   * @name AssignmentOffersCreate
   * @summary Create a new assignment_offer
   * @request POST:/assignment_offers
   */
  export namespace AssignmentOffersCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      assignment_offer: {
        assignment_id: number
        sales_person_id: number
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentOffersCreateData
  }

  /**
   * No description
   * @tags Assignment Offers
   * @name AssignmentOffersDetail
   * @summary Get one assignment offer
   * @request GET:/assignment_offers/{id}
   */
  export namespace AssignmentOffersDetail {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentOffersDetailData
  }

  /**
   * No description
   * @tags Assignment Offers
   * @name AssignmentOffersDelete
   * @summary Cancel an assignment offer
   * @request DELETE:/assignment_offers/{id}
   */
  export namespace AssignmentOffersDelete {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentOffersDeleteData
  }

  /**
   * No description
   * @tags Assignment Offers
   * @name AcceptPartialUpdate
   * @summary Accept an assignment offer
   * @request PATCH:/assignment_offers/{id}/accept
   */
  export namespace AcceptPartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAcceptPartialUpdateData
  }

  /**
   * No description
   * @tags Assignment Offers
   * @name RejectPartialUpdate
   * @summary Accept an assignment offer
   * @request PATCH:/assignment_offers/{id}/reject
   */
  export namespace RejectPartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARejectPartialUpdateData
  }
}

export namespace Assignments {
  /**
   * No description
   * @tags Assignments
   * @name AssignmentsList
   * @summary List of all assignments
   * @request GET:/assignments
   */
  export namespace AssignmentsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentsListData
  }

  /**
   * No description
   * @tags Assignments
   * @name AssignmentsDetail
   * @summary Get one assignment
   * @request GET:/assignments/{id}
   */
  export namespace AssignmentsDetail {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAssignmentsDetailData
  }

  /**
   * No description
   * @tags Assignments
   * @name RevokePartialUpdate
   * @summary Clear assignment from current sales person
   * @request PATCH:/assignments/{id}/revoke
   */
  export namespace RevokePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARevokePartialUpdateData
  }
}

export namespace Companies {
  /**
   * No description
   * @tags Companies
   * @name CompaniesDetail
   * @summary Get company profile data
   * @request GET:/companies/{id}
   */
  export namespace CompaniesDetail {
    export type RequestParams = {
      /** Company ID */
      id: number
    }
    export type RequestQuery = {
      /** To specify sections returned in response */
      section?: ACompaniesDetailParamsSectionEnum
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACompaniesDetailData
  }

  /**
   * No description
   * @tags Companies
   * @name CompaniesPartialUpdate
   * @summary Update company
   * @request PATCH:/companies/{id}
   */
  export namespace CompaniesPartialUpdate {
    export type RequestParams = {
      /** Company ID */
      id: number
    }
    export type RequestQuery = {
      /** To specify sections returned in response */
      section?: ACompaniesPartialUpdateParamsSectionEnum
    }
    export type RequestBody = {
      company?: ACompanyAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACompaniesPartialUpdateData
  }
}

export namespace CompanyUsers {
  /**
   * No description
   * @tags ActivityFeeds
   * @name ActivityFeedsLikePartialUpdate
   * @summary Activity feed company like
   * @request PATCH:/company_users/activity_feeds/{id}/like
   */
  export namespace ActivityFeedsLikePartialUpdate {
    export type RequestParams = {
      /** Activity Feed ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AActivityFeedsLikePartialUpdateData
  }

  /**
   * No description
   * @tags ActivityFeeds
   * @name ActivityFeedsDislikePartialUpdate
   * @summary Activity feed company dislike
   * @request PATCH:/company_users/activity_feeds/{id}/dislike
   */
  export namespace ActivityFeedsDislikePartialUpdate {
    export type RequestParams = {
      /** Activity Feed ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AActivityFeedsDislikePartialUpdateData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name DashboardDetail
   * @summary Get company user dashboard data
   * @request GET:/company_users/dashboard/{id}
   */
  export namespace DashboardDetail {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardDetailData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name DashboardActiveSalesCyclesList
   * @summary Get active sales cycles for company dashboard
   * @request GET:/company_users/dashboard/{id}/active_sales_cycles
   */
  export namespace DashboardActiveSalesCyclesList {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardActiveSalesCyclesListData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name DashboardDraftedSalesCyclesList
   * @summary Get drafted sales cycles for company dashboard
   * @request GET:/company_users/dashboard/{id}/drafted_sales_cycles
   */
  export namespace DashboardDraftedSalesCyclesList {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardDraftedSalesCyclesListData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name DashboardFinishedSalesCyclesList
   * @summary Get finished sales cycles for company dashboard
   * @request GET:/company_users/dashboard/{id}/finished_sales_cycles
   */
  export namespace DashboardFinishedSalesCyclesList {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardFinishedSalesCyclesListData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name DashboardPausedSalesCyclesList
   * @summary Get paused sales cycles for company dashboard
   * @request GET:/company_users/dashboard/{id}/paused_sales_cycles
   */
  export namespace DashboardPausedSalesCyclesList {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardPausedSalesCyclesListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectDisapprovePartialUpdate
   * @summary Disapprove a prospect of assignment
   * @request PATCH:/company_users/prospects/assignments/{id}/prospect_disapprove
   */
  export namespace ProspectsAssignmentsProspectDisapprovePartialUpdate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      prospect: {
        /** Prospect ID */
        id: number
        disapprove_reason: AProspectDisapproveReasons
        disapprove_reason_text?: string | null
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectDisapprovePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsWaitingToApproveList
   * @summary Prospects Company list of all prospects for assignment waiting to approve
   * @request GET:/company_users/prospects/assignments/{id}/prospects_waiting_to_approve
   */
  export namespace ProspectsAssignmentsProspectsWaitingToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: ACompanyProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsWaitingToApproveListResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsFinishedList
   * @summary Prospects Company list of all prospects for assignment already finished
   * @request GET:/company_users/prospects/assignments/{id}/prospects_finished
   */
  export namespace ProspectsAssignmentsProspectsFinishedList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: ACompanyProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsFinishedListResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsApproveProspectsCreate
   * @summary Company approve ready-to-approved prospects
   * @request POST:/company_users/prospects/assignments/{id}/approve_prospects
   */
  export namespace ProspectsAssignmentsApproveProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsApproveProspectsCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesDetail
   * @summary Sales Cycle detail for Company Prospects
   * @request GET:/company_users/prospects/sales_cycles/{id}
   */
  export namespace ProspectsSalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesDetailResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsList
   * @summary List of all prospects with company-user-visible data
   * @request GET:/company_users/prospects
   */
  export namespace ProspectsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Prospects sales cycle ID */
      sales_cycle_id: number
      /** Search organization name */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsListResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsExtendedIndexList
   * @summary List of all prospects with company-user-visible data and prospects statistics
   * @request GET:/company_users/prospects/extended_index
   */
  export namespace ProspectsExtendedIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Prospects sales cycle ID */
      sales_cycle_id: number
      /** Search organization name */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsExtendedIndexListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCycleIterationsDetail
   * @summary Sales cycle iteration detail
   * @request GET:/company_users/sales_cycle_iterations/{id}
   * @deprecated
   */
  export namespace SalesCycleIterationsDetail {
    export type RequestParams = {
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCycleIterationsDetailData
  }

  /**
   * No description
   * @tags ActivityFeeds
   * @name SalesCyclesActivityFeedsList
   * @summary Company activity feed for the current sales cycle
   * @request GET:/company_users/sales_cycles/{sales_cycle_id}/activity_feeds
   */
  export namespace SalesCyclesActivityFeedsList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityFeedsListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/company_users/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesAssignmentsReportingListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      salesCycleIterationId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsAssignmentsReportingListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesSalesCycleIterationsReportingList
   * @summary Sales cycle iteration reporting data
   * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsReportingListResult
  }

  /**
   * No description
   * @tags CompanyUsers/SalesCycles/SalesPeople
   * @name SalesCyclesSalesPeopleList
   * @summary Sales cycle iteration reporting data
   * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_people
   */
  export namespace SalesCyclesSalesPeopleList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesPeopleListData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesDetail
   * @summary Sales cycle detail
   * @request GET:/company_users/sales_cycles/{id}
   * @deprecated
   */
  export namespace SalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesSalesNewsList
   * @summary Sales cycle - current iteration sales news
   * @request GET:/company_users/sales_cycles/{id}/sales_news
   */
  export namespace SalesCyclesSalesNewsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesNewsListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesDetailsList
   * @summary Sales cycle detail
   * @request GET:/company_users/sales_cycles/{id}/details
   */
  export namespace SalesCyclesDetailsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailsListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesReportingList
   * @summary Sales cycle reporting data
   * @request GET:/company_users/sales_cycles/{id}/reporting
   */
  export namespace SalesCyclesReportingList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesReportingListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesNewsAndInsightsList
   * @summary Sales cycle / sales cycle iteration news and insights
   * @request GET:/company_users/sales_cycles/{id}/news_and_insights
   */
  export namespace SalesCyclesNewsAndInsightsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesNewsAndInsightsListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesActivitiesChartList
   * @summary Sales cycle activities chart data
   * @request GET:/company_users/sales_cycles/{id}/activities_chart
   */
  export namespace SalesCyclesActivitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivitiesChartListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesClientsReachedChartList
   * @summary Sales cycle clients reached chart data
   * @request GET:/company_users/sales_cycles/{id}/clients_reached_chart
   */
  export namespace SalesCyclesClientsReachedChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesClientsReachedChartListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesActivityOccurrencesChartList
   * @summary Activity occurrences chart data
   * @request GET:/company_users/sales_cycles/{id}/activity_occurrences_chart
   */
  export namespace SalesCyclesActivityOccurrencesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      activity_event: AActivityEvents
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityOccurrencesChartListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesOpportunitiesChartList
   * @summary Opportunities chart data
   * @request GET:/company_users/sales_cycles/{id}/opportunities_chart
   */
  export namespace SalesCyclesOpportunitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesOpportunitiesChartListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesProspectsList
   * @summary List of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
   * @request GET:/company_users/sales_cycles/{id}/prospects
   */
  export namespace SalesCyclesProspectsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      /** Search query */
      search?: string
      /** Last changed within */
      last_change?: string
      "statuses[]"?: ASalesCycleProspectStatuses[]
      "stages[]"?: ASalesCycleFilterStages[]
      "segments[]"?: string[]
      /** Sort by values */
      sort_by?: ASalesCyclesProspectValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name SalesCyclesProspectsAutocompleteValuesList
   * @summary The 10 most similar autocomplete values for specified field and value
   * @request GET:/company_users/sales_cycles/{id}/prospects_autocomplete_values
   */
  export namespace SalesCyclesProspectsAutocompleteValuesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Autocomplete field */
      field: ASalesCycleProspectAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsAutocompleteValuesListResult
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name CompanyUsersCreate
   * @summary Registers in company user
   * @request POST:/company_users
   */
  export namespace CompanyUsersCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      lang?: string
    }
    export type RequestBody = {
      company_user: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACompanyUsersCreateData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name ConfirmationCreate
   * @summary Resend confirmation email
   * @request POST:/company_users/confirmation
   */
  export namespace ConfirmationCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      company_user: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = AConfirmationCreateData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name ConfirmationPartialUpdate
   * @summary Confirms email address and saves user details
   * @request PATCH:/company_users/confirmation
   */
  export namespace ConfirmationPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      company: {
        name: string
      }
      company_user: {
        phone_number: string
        password: string
        password_confirmation: string
        tac_agreement: boolean
      }
      confirmation_token: string
    }
    export type RequestHeaders = {}
    export type ResponseBody = AConfirmationPartialUpdateData
  }

  /**
   * No description
   * @tags CompanyUsers
   * @name WelcomeScreenDetail
   * @summary Get company user welcome screen data
   * @request GET:/company_users/welcome_screen/{id}
   */
  export namespace WelcomeScreenDetail {
    export type RequestParams = {
      /** Company User ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AWelcomeScreenDetailData
  }
}

export namespace Countries {
  /**
   * No description
   * @tags Countries
   * @name CountriesList
   * @summary List of all countries
   * @request GET:/countries
   */
  export namespace CountriesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACountriesListData
  }
}

export namespace Currencies {
  /**
   * No description
   * @tags Currencies
   * @name CurrenciesList
   * @summary List of all currencies
   * @request GET:/currencies
   */
  export namespace CurrenciesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACurrenciesListData
  }
}

export namespace Users {
  /**
   * No description
   * @tags Users
   * @name SignInCreate
   * @summary Creates a session / logs in user
   * @request POST:/users/sign_in
   */
  export namespace SignInCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      user?: {
        email: string
        password: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASignInCreateData
  }

  /**
   * No description
   * @tags Users
   * @name SignOutDelete
   * @summary Deletes a session / logs out user
   * @request DELETE:/users/sign_out
   */
  export namespace SignOutDelete {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASignOutDeleteData
  }

  /**
   * No description
   * @tags Users
   * @name PasswordCreate
   * @summary Requests password reset (forgot password flow)
   * @request POST:/users/password
   */
  export namespace PasswordCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      user?: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = APasswordCreateData
  }

  /**
   * No description
   * @tags Users
   * @name PasswordUpdate
   * @summary Reset password
   * @request PUT:/users/password
   */
  export namespace PasswordUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      user?: {
        password: string
        password_confirmation: string
        reset_password_token: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = APasswordUpdateData
  }
}

export namespace Importers {
  /**
   * No description
   * @tags Importers
   * @name RollbackDelete
   * @summary Rollback importer and its imported resources
   * @request DELETE:/importers/{id}/rollback
   */
  export namespace RollbackDelete {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARollbackDeleteData
  }
}

export namespace InvitationAcceptances {
  /**
   * No description
   * @tags Invitations
   * @name InvitationAcceptancesCreate
   * @summary Accept invitation
   * @request POST:/invitation_acceptances
   */
  export namespace InvitationAcceptancesCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody =
      | {
          /** @example "John" */
          first_name: string
          /** @example "Doe" */
          last_name: string
          /** @example "Password123" */
          password: string
          /** @example "token123" */
          invitation_token: string
        }
      | {
          /** @example "John" */
          first_name: string
          /** @example "Doe" */
          last_name: string
          /** @example "Password123" */
          password: string
          /** @example "token123" */
          invitation_token: string
          /** @example 1 */
          country_id: number
        }
      | {
          /** @example "John" */
          first_name: string
          /** @example "Doe" */
          last_name: string
          /** @example "Password123" */
          password: string
          /** @example "token123" */
          invitation_token: string
          /** @example 1 */
          country_id: number
          /** @example "+1234567890" */
          phone_number: string
        }
    export type RequestHeaders = {}
    export type ResponseBody = AInvitationAcceptancesCreateData
  }
}

export namespace Invitations {
  /**
   * No description
   * @tags Invitations
   * @name InvitationsCreate
   * @summary Create bulk invitations
   * @request POST:/invitations
   */
  export namespace InvitationsCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      users: {
        /** @example "user@example.com" */
        email: string
        type: AUsersTypeEnum
      }[]
    }
    export type RequestHeaders = {}
    export type ResponseBody = AInvitationsCreateData
  }

  /**
   * No description
   * @tags Invitations
   * @name ResendCreate
   * @summary Resend invitation
   * @request POST:/invitations/{id}/resend
   */
  export namespace ResendCreate {
    export type RequestParams = {
      /** The id of the invited user */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AResendCreateData
  }

  /**
   * No description
   * @tags Invitations
   * @name CancelCreate
   * @summary Cancel invitation
   * @request POST:/invitations/{id}/cancel
   */
  export namespace CancelCreate {
    export type RequestParams = {
      /** The id of the invited user */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACancelCreateData
  }
}

export namespace InvoiceDetails {
  /**
   * No description
   * @tags InvoiceDetails
   * @name InvoiceDetailsList
   * @summary List of invoice details belongs to company or user
   * @request GET:/invoice_details
   */
  export namespace InvoiceDetailsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AInvoiceDetailsListData
  }

  /**
   * No description
   * @tags InvoiceDetails
   * @name InvoiceDetailsCreate
   * @summary Creates a new invoice detail
   * @request POST:/invoice_details
   */
  export namespace InvoiceDetailsCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      invoice_detail: AInvoiceDetailAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = AInvoiceDetailsCreateData
  }

  /**
   * No description
   * @tags InvoiceDetails
   * @name InvoiceDetailsUpdate
   * @summary Updates an invoice detail
   * @request PUT:/invoice_details/{id}
   */
  export namespace InvoiceDetailsUpdate {
    export type RequestParams = {
      /** InvoiceDetail ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      invoice_detail: AInvoiceDetailAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = AInvoiceDetailsUpdateData
  }
}

export namespace Languages {
  /**
   * No description
   * @tags Languages
   * @name LanguagesList
   * @summary List of all languages
   * @request GET:/languages
   */
  export namespace LanguagesList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALanguagesListData
  }
}

export namespace Leads {
  /**
   * No description
   * @tags AdvancedSearch/CustomElevatorPitches
   * @name CustomElevatorPitchesDetail
   * @summary Get custom elevator pitch for sales cycle
   * @request GET:/leads/custom_elevator_pitches/{sales_cycle_id}
   */
  export namespace CustomElevatorPitchesDetail {
    export type RequestParams = {
      /** Sales Cycle ID */
      salesCycleId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACustomElevatorPitchesDetailData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsList
   * @summary List of all leads
   * @request GET:/leads
   */
  export namespace LeadsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Search query */
      search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsListData
  }

  /**
   * No description
   * @tags Leads
   * @name AutocompleteValuesList
   * @summary The 10 most similar autocomplete values for specified field and value
   * @request GET:/leads/autocomplete_values
   */
  export namespace AutocompleteValuesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Autocomplete field */
      field: ALeadAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAutocompleteValuesListData
  }

  /**
   * No description
   * @tags Leads
   * @name ImportCreate
   * @summary Imports list of leads
   * @request POST:/leads/import
   */
  export namespace ImportCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      "leads_import[leads_file]": File
      "leads_import[source]": string
      "leads_import[ownership_level]"?: AOwnershipLevels
      "leads_import[owner_id]"?: number | null
    }
    export type RequestHeaders = {}
    export type ResponseBody = AImportCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name SalesPersonImportCreate
   * @summary Imports list of sales person leads
   * @request POST:/leads/sales_person_import
   */
  export namespace SalesPersonImportCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      "leads_import[leads_file]": File
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPersonImportCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsDelete
   * @summary Deletes lead
   * @request DELETE:/leads/{id}
   */
  export namespace LeadsDelete {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {
      delete_strategy: ALeadDeleteStrategies
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsDeleteData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsDetail
   * @summary Lead detail
   * @request GET:/leads/{id}
   */
  export namespace LeadsDetail {
    export type RequestParams = {
      /** Lead ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsDetailData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsPartialUpdate
   * @summary Updates a lead
   * @request PATCH:/leads/{id}
   */
  export namespace LeadsPartialUpdate {
    export type RequestParams = {
      /** Lead ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      lead: ALeadAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsPartialUpdateData
  }

  /**
   * No description
   * @tags Leads
   * @name ImportersList
   * @summary List of leads importers
   * @request GET:/leads/importers
   */
  export namespace ImportersList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AImportersListData
  }

  /**
   * No description
   * @tags Leads
   * @name IndexMetadataList
   * @summary Display metadata for leads index
   * @request GET:/leads/index_metadata
   */
  export namespace IndexMetadataList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AIndexMetadataListData
  }

  /**
   * No description
   * @tags Leads
   * @name RemovalRequestsIndexList
   * @summary List of requested removal leads
   * @request GET:/leads/removal_requests_index
   */
  export namespace RemovalRequestsIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Search query */
      search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARemovalRequestsIndexListData
  }

  /**
   * No description
   * @tags Leads
   * @name AcceptWarningsCreate
   * @summary Approve lead normalization warnings
   * @request POST:/leads/accept_warnings/{id}
   */
  export namespace AcceptWarningsCreate {
    export type RequestParams = {
      /** Lead ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AAcceptWarningsCreateData
  }
}

export namespace MasqueradeSessions {
  /**
   * No description
   * @tags Masquerade
   * @name MasqueradeSessionsCreate
   * @summary Start masquerading as another user
   * @request POST:/masquerade_sessions
   */
  export namespace MasqueradeSessionsCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      /** ID of the user to masquerade as */
      user_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }

  /**
   * No description
   * @tags Masquerade
   * @name MasqueradeSessionsDelete
   * @summary End current masquerade session
   * @request DELETE:/masquerade_sessions
   */
  export namespace MasqueradeSessionsDelete {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace MasqueradeTargets {
  /**
   * No description
   * @tags Masquerade
   * @name MasqueradeTargetsList
   * @summary List of users the current user can masquerade as
   * @request GET:/masquerade_targets
   */
  export namespace MasqueradeTargetsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AMasqueradeTargetsListData
  }
}

export namespace SalesCycleIterations {
  /**
   * No description
   * @tags Sales People for matching
   * @name MatchableSalesPeopleList
   * @summary List of all sales people for matching
   * @request GET:/sales_cycle_iterations/{id}/matchable_sales_people
   */
  export namespace MatchableSalesPeopleList {
    export type RequestParams = {
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {
      /** SalesPerson search on names */
      search?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AMatchableSalesPeopleListData
  }

  /**
   * No description
   * @tags SalesCycleIterations
   * @name SalesCycleIterationsList
   * @summary List of all sales cycle iterations
   * @request GET:/sales_cycle_iterations
   */
  export namespace SalesCycleIterationsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Status filter */
      status?: ASalesCycleIterationsListParamsStatusEnum
      /** Start date filter */
      start_date?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCycleIterationsListData
  }

  /**
   * No description
   * @tags SalesCycleIterations
   * @name SalesCycleIterationsDetail
   * @summary One sales cycle iteration
   * @request GET:/sales_cycle_iterations/{id}
   */
  export namespace SalesCycleIterationsDetail {
    export type RequestParams = {
      /** SalesCycleIteration ID */
      id: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCycleIterationsDetailResult
  }
}

export namespace Packages {
  /**
   * No description
   * @tags Packages
   * @name PackagesList
   * @summary List of all packages for country
   * @request GET:/packages
   */
  export namespace PackagesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Country code (SK, CZ etc., default is SK) */
      country_code?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APackagesListData
  }
}

export namespace PendingConfirmations {
  /**
   * No description
   * @tags Pending Confirmations
   * @name PendingConfirmationsDetail
   * @summary Get confirmation data for a pending confirmation
   * @request GET:/pending_confirmations/{confirmation_token}
   */
  export namespace PendingConfirmationsDetail {
    export type RequestParams = {
      /** The confirmation token of a pending confirmation */
      confirmationToken: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APendingConfirmationsDetailData
  }
}

export namespace Prospects {
  /**
   * No description
   * @tags Prospects
   * @name ImportCreate
   * @summary Imports list of prospects (with leads) for specified sales cycle
   * @request POST:/prospects/import
   */
  export namespace ImportCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      sales_cycle_id: number
      owner_id?: number | null
      ownership_level?: AOwnershipLevels
      /** @format binary */
      prospects_file: File
      source: string
    }
    export type RequestHeaders = {}
    export type ResponseBody = AImportCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name SalesPersonImportCreate
   * @summary Imports list of prospects (with leads) for specified sales cycle assignment
   * @request POST:/prospects/sales_person_import
   */
  export namespace SalesPersonImportCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      prospects_import: {
        sales_cycle_id: number
        assignment_id: number
        file: File
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPersonImportCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ApprovePartialUpdate
   * @summary Approve a prospect of sales cycle
   * @request PATCH:/prospects/{id}/approve
   * @deprecated
   */
  export namespace ApprovePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AApprovePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name RemoveApproveStatusPartialUpdate
   * @summary Remove approve status for a prospect of sales cycle
   * @request PATCH:/prospects/{id}/remove_approve_status
   * @deprecated
   */
  export namespace RemoveApproveStatusPartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARemoveApproveStatusPartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name DisapprovePartialUpdate
   * @summary Disapprove a prospect of sales cycle
   * @request PATCH:/prospects/{id}/disapprove
   * @deprecated
   */
  export namespace DisapprovePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      disapprove_reason: AProspectDisapproveReasons
    }
    export type RequestHeaders = {}
    export type ResponseBody = ADisapprovePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name PrioritizePartialUpdate
   * @summary Prioritize a prospect of sales cycle
   * @request PATCH:/prospects/{id}/prioritize
   */
  export namespace PrioritizePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APrioritizePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name DeprioritizePartialUpdate
   * @summary Deprioritize a prospect of sales cycle
   * @request PATCH:/prospects/{id}/deprioritize
   */
  export namespace DeprioritizePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADeprioritizePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name SaasCreateCreate
   * @summary Creates a prospect and sync it with the CRM for SAAS
   * @request POST:/prospects/saas_create
   */
  export namespace SaasCreateCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      assignment_id: number
    }
    export type RequestBody = {
      prospect: AProspectAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasCreateCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsCreate
   * @summary Creates a prospect for Marketplace
   * @request POST:/prospects
   */
  export namespace ProspectsCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      assignment_id: number
    }
    export type RequestBody = {
      prospect: AProspectAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsCreateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsPartialUpdate
   * @summary Updates a prospect
   * @request PATCH:/prospects/{id}
   */
  export namespace ProspectsPartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      prospect: AProspectAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsPartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsDelete
   * @summary Permanently deletes a prospect
   * @request DELETE:/prospects/{id}
   */
  export namespace ProspectsDelete {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsDeleteResult
  }

  /**
   * No description
   * @tags Prospects
   * @name SaasUpdatePartialUpdate
   * @summary Updates a SAAS prospect
   * @request PATCH:/prospects/{id}/saas_update
   */
  export namespace SaasUpdatePartialUpdate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      prospect: AProspectAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasUpdatePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name RemoveDisapprovePartialUpdate
   * @summary Remove disapprove status for a prospect of sales cycle
   * @request PATCH:/prospects/{id}/remove_disapprove
   */
  export namespace RemoveDisapprovePartialUpdate {
    export type RequestParams = {
      /** Prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARemoveDisapprovePartialUpdateData
  }

  /**
   * No description
   * @tags Prospects
   * @name ActivitiesList
   * @summary All or iteration scoped activities of prospects
   * @request GET:/prospects/{id}/activities
   */
  export namespace ActivitiesList {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AActivitiesListData
  }

  /**
   * No description
   * @tags Prospects
   * @name NotesList
   * @summary all notes for prospect deal
   * @request GET:/prospects/{id}/notes
   */
  export namespace NotesList {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ANotesListData
  }
}

export namespace PrivacyRequest {
  /**
   * No description
   * @tags PrivacyRequests
   * @name PrivacyRequestList
   * @summary Privacy request detail
   * @request GET:/privacy_request
   */
  export namespace PrivacyRequestList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Privacy request token */
      token: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APrivacyRequestListData
  }

  /**
   * No description
   * @tags PrivacyRequests
   * @name RequestRemoveCreate
   * @summary Request remove privacy request for lead data
   * @request POST:/privacy_request/request_remove
   */
  export namespace RequestRemoveCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Privacy request token */
      token: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARequestRemoveCreateData
  }
}

export namespace ReachEngine {
  /**
   * No description
   * @tags ReachEngine/Activities
   * @name ActivitiesList
   * @summary Per-channel activity and response counts
   * @request GET:/reach_engine/activities
   */
  export namespace ActivitiesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * Start of the window applied to occurred_at (inclusive)
       * @format date
       */
      from?: string
      /**
       * End of the window applied to occurred_at (inclusive)
       * @format date
       */
      to?: string
      /** Restrict statistics to a single campaign type */
      campaign_type?: AActivitiesListParams1CampaignTypeEnum
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AActivitiesListResult
  }

  /**
   * No description
   * @tags ReachEngine/Campaigns
   * @name CampaignsList
   * @summary List of reach campaigns with per-campaign metrics
   * @request GET:/reach_engine/campaigns
   */
  export namespace CampaignsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Frontend status buckets to filter by */
      "status[]"?: ACampaignsListParamsStatusEnum[]
      /** Reach campaign ids to filter by */
      "ids[]"?: number[]
      /** Campaign type to filter by */
      campaign_type?: ACampaignsListParamsCampaignTypeEnum
      /**
       * Start of the window applied to meta (inclusive); rows ignore it
       * @format date
       */
      from?: string
      /**
       * End of the window applied to meta (inclusive); rows ignore it
       * @format date
       */
      to?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACampaignsListData
  }

  /**
   * No description
   * @tags ReachEngine/OutreachDepth
   * @name OutreachDepthList
   * @summary MQL and SQL by outbound activities received before the first crossing
   * @request GET:/reach_engine/outreach_depth
   */
  export namespace OutreachDepthList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * Start of the window applied to the MQL/SQL moment (inclusive)
       * @format date
       */
      from?: string
      /**
       * End of the window applied to the MQL/SQL moment (inclusive)
       * @format date
       */
      to?: string
      /** Restrict results to a single campaign type */
      campaign_type?: AOutreachDepthListParamsCampaignTypeEnum
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AOutreachDepthListData
  }

  /**
   * No description
   * @tags ReachEngine/ResultsOverTime
   * @name ResultsOverTimeList
   * @summary Weekly first MQL and SQL crossings
   * @request GET:/reach_engine/results_over_time
   */
  export namespace ResultsOverTimeList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * Start of the window applied to the crossing time (inclusive)
       * @format date
       */
      from?: string
      /**
       * End of the window applied to the crossing time (inclusive)
       * @format date
       */
      to?: string
      /** Restrict results to a single campaign type */
      campaign_type?: AResultsOverTimeListParamsCampaignTypeEnum
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AResultsOverTimeListData
  }
}

export namespace SaasCompanyUsers {
  /**
   * No description
   * @tags SaasCompanyUsers
   * @name ConfirmationList
   * @summary Confirm SaaS company owner email
   * @request GET:/saas_company_users/confirmation
   */
  export namespace ConfirmationList {
    export type RequestParams = {}
    export type RequestQuery = {
      confirmation_token: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }

  /**
   * No description
   * @tags SaasCompanyUsers
   * @name ConfirmationCreate
   * @summary Resend confirmation email
   * @request POST:/saas_company_users/confirmation
   */
  export namespace ConfirmationCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      saas_company_user?: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = AConfirmationCreateResult
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name DashboardList
   * @summary Saas Company User dashboard data
   * @request GET:/saas_company_users/dashboard
   */
  export namespace DashboardList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name DashboardSalesIntelligenceList
   * @summary Saas Company User dashboard with sales intelligence data
   * @request GET:/saas_company_users/dashboard/sales_intelligence
   */
  export namespace DashboardSalesIntelligenceList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Start date for iteration in 2025-06-01 format. Dates are received in dashboard */
      start_date: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardSalesIntelligenceListData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsList
   * @summary List of drafted prospects for advanced search session
   * @request GET:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsListData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
   * @summary List of detailed drafted prospects for advanced search session
   * @request GET:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDetailedList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADetailedDraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADetailedDraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
   * @summary Mark drafted prospect as viewed
   * @request PATCH:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
   * @summary Transfer selected drafted prospects into assignment prospects
   * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate
   * @summary Download selected drafted prospects in the EXCEL
   * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/download_as_excel
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
   * @summary Search for new drafted prospects using AI
   * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
   * @summary Search for contact information of selected drafted prospects
   * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
   * @summary Soft deletes drafted prospect
   * @request DELETE:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDelete {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDeleteData
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasCompanyUsers
   * @name LeadsAdvancedSearchSessionsCreate
   * @summary Create advanced search sessions
   * @request POST:/saas_company_users/leads/advanced_search_sessions
   */
  export namespace LeadsAdvancedSearchSessionsCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      assignment_id?: number
      advanced_search_filter?: AAdvancedSearchFilter
    }
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsCreateData
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsLeadsForAssignmentList
   * @summary List of all assignment leads
   * @request GET:/saas_company_users/leads/assignments/{id}/leads_for_assignment
   */
  export namespace LeadsAssignmentsLeadsForAssignmentList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Contact person name search query */
      contact_person_search?: string
      /** Organization name search query */
      organization_name_search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "cities[]"?: string[]
      phone_number_present?: boolean
      email_present?: boolean
      contacted_already?: boolean
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsLeadsForAssignmentListResult
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add prospect to sales cycle from the leads database
   * @request POST:/saas_company_users/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace LeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      lead_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsAddProspectFromLeadCreateResult
  }

  /**
   * No description
   * @tags SaasCompanyUsers/Onboarding
   * @name OnboardingStatusList
   * @summary Saas Company User onboarding status
   * @request GET:/saas_company_users/onboarding/status
   */
  export namespace OnboardingStatusList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AOnboardingStatusListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsUploadProspectsCreate
   * @summary Assignment upload prospects for SAAS Company Users Prospects
   * @request POST:/saas_company_users/prospects/assignments/{id}/upload_prospects
   */
  export namespace ProspectsAssignmentsUploadProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      /** Attach prospect import file */
      prospects_file: File
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsUploadProspectsCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsFinishedList
   * @summary List of all prospects for assignment already finished
   * @request GET:/saas_company_users/prospects/assignments/{id}/prospects_finished
   */
  export namespace ProspectsAssignmentsProspectsFinishedList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsFinishedListOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsSyncWithCrmCreate
   * @summary Sync approved finished assigned prospects with the CRM
   * @request POST:/saas_company_users/prospects/assignments/{id}/sync_with_crm
   */
  export namespace ProspectsAssignmentsSyncWithCrmCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsSyncWithCrmCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsDownloadProspectsList
   * @summary Download all prospects as Excel for an assignment
   * @request GET:/saas_company_users/prospects/assignments/{id}/download_prospects
   */
  export namespace ProspectsAssignmentsDownloadProspectsList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsDownloadProspectsListData
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsApproveProspectsCreate
   * @summary Approve and finished prospects without notifications
   * @request POST:/saas_company_users/prospects/assignments/{id}/approve_prospects
   */
  export namespace ProspectsAssignmentsApproveProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsApproveProspectsCreateOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesDetail
   * @summary SAAS Sales Cycle detail for Prospects
   * @request GET:/saas_company_users/prospects/sales_cycles/{id}
   */
  export namespace ProspectsSalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesDetailOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers
   * @name SaasCompanyUsersCreate
   * @summary Register a new SaaS company owner
   * @request POST:/saas_company_users
   */
  export namespace SaasCompanyUsersCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      saas_company_user?: {
        email: string
        password: string
        password_confirmation: string
        first_name: string
        last_name: string
        phone_number: string
        company_website: string
        tac_agreement: boolean
        locale?: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASaasCompanyUsersCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantCompanySettingsList
   * @summary Klara company settings
   * @request GET:/saas_company_users/sales_assistant/company_settings
   */
  export namespace SalesAssistantCompanySettingsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantCompanySettingsListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantCompanySettingsPartialUpdate
   * @summary Update Klara company settings
   * @request PATCH:/saas_company_users/sales_assistant/company_settings
   */
  export namespace SalesAssistantCompanySettingsPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      company_settings: AKlaraCompanySettings
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantCompanySettingsPartialUpdateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardDealsDetail
   * @summary Klara dashboard deal detail
   * @request GET:/saas_company_users/sales_assistant/dashboard/deals/{id}
   */
  export namespace SalesAssistantDashboardDealsDetail {
    export type RequestParams = {
      /** Klara deal id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardDealsDetailData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardDealsPartialUpdate
   * @summary Set the Klara dashboard deal priority
   * @request PATCH:/saas_company_users/sales_assistant/dashboard/deals/{id}
   */
  export namespace SalesAssistantDashboardDealsPartialUpdate {
    export type RequestParams = {
      /** Klara deal id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = AKlaraDashboardDealUpdate
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardDealsPartialUpdateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardDealsRemindCreate
   * @summary Remind the Klara dashboard deal owner
   * @request POST:/saas_company_users/sales_assistant/dashboard/deals/{id}/remind
   */
  export namespace SalesAssistantDashboardDealsRemindCreate {
    export type RequestParams = {
      /** Klara deal id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardDealsRemindCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardSalesPeopleList
   * @summary Klara dashboard sales people
   * @request GET:/saas_company_users/sales_assistant/dashboard/sales_people
   */
  export namespace SalesAssistantDashboardSalesPeopleList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
       * @format date
       */
      from?: string
      /**
       * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
       * @format date
       */
      to?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardSalesPeopleListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardSummaryList
   * @summary Klara dashboard summary
   * @request GET:/saas_company_users/sales_assistant/dashboard/summary
   */
  export namespace SalesAssistantDashboardSummaryList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
       * @format date
       */
      from?: string
      /**
       * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
       * @format date
       */
      to?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardSummaryListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant/Dashboard
   * @name SalesAssistantDashboardUpdatesOverTimeList
   * @summary Klara updates over time
   * @request GET:/saas_company_users/sales_assistant/dashboard/updates_over_time
   */
  export namespace SalesAssistantDashboardUpdatesOverTimeList {
    export type RequestParams = {}
    export type RequestQuery = {
      /**
       * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
       * @format date
       */
      from?: string
      /**
       * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
       * @format date
       */
      to?: string
      granularity: AKlaraDashboardGranularityValues
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDashboardUpdatesOverTimeListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantDealsList
   * @summary List of all prospects for assignment waiting to send for approve
   * @request GET:/saas_company_users/sales_assistant/deals
   */
  export namespace SalesAssistantDealsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sales person external_id */
      sales_person_external_id?: string
      "priorities[]"?: string[]
      "planned_task_types[]"?: ASalesAssistantDealPlannedTaskTypes[]
      /** Sort by values (dashboard mode: klara_dashboard_deal_sort_by_values) */
      sort_by?: ASalesAssistantDealSortByValues | AKlaraDashboardDealSortByValues
      /** Sort by direction */
      sort_direction?: ASalesAssistantDealSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Klara dashboard mode; the from/to/view/chip params apply only with dashboard=true */
      dashboard?: ASalesAssistantDealsListParamsDashboardEnum
      /**
       * Dashboard mode: yyyy-MM-dd, inclusive; together with to or neither (lifetime)
       * @format date
       */
      from?: string
      /**
       * Dashboard mode: yyyy-MM-dd, inclusive; together with from or neither (lifetime)
       * @format date
       */
      to?: string
      /** Dashboard mode, default attention */
      view?: AKlaraDashboardDealViewValues
      /** Dashboard mode, replaces view */
      chip?: AKlaraDashboardDealChipValues
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDealsListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantDealsDetail
   * @summary Sales Company Users Sales Assistant Prospect detail
   * @request GET:/saas_company_users/sales_assistant/deals/{external_id}
   */
  export namespace SalesAssistantDealsDetail {
    export type RequestParams = {
      /** Deal external ID */
      externalId: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDealsDetailData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantSalesPeopleList
   * @summary List of sales people info saas company user
   * @request GET:/saas_company_users/sales_assistant/sales_people
   */
  export namespace SalesAssistantSalesPeopleList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Selling External ID */
      selling_external_id?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSalesPeopleListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantSalesPeopleSelectBoxIndexList
   * @summary List of sales people with basic data for saas company user
   * @request GET:/saas_company_users/sales_assistant/sales_people/select_box_index
   */
  export namespace SalesAssistantSalesPeopleSelectBoxIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Selling External ID */
      selling_external_id?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSalesPeopleSelectBoxIndexListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantCreateCallCreate
   * @summary Call command for create AI call
   * @request POST:/saas_company_users/sales_assistant/create_call
   */
  export namespace SalesAssistantCreateCallCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantCreateCallCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantSettingsList
   * @summary Detail of sales assistant sales person settings
   * @request GET:/saas_company_users/sales_assistant/settings
   */
  export namespace SalesAssistantSettingsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSettingsListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantSettingsPartialUpdate
   * @summary Update settings for Sales Assistant Sales Person
   * @request PATCH:/saas_company_users/sales_assistant/settings
   */
  export namespace SalesAssistantSettingsPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      sales_person: ASalesAssistantSalesPersonSettingsAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSettingsPartialUpdateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantTasksPartialUpdate
   * @summary Update task with marked as complete and next step
   * @request PATCH:/saas_company_users/sales_assistant/tasks
   */
  export namespace SalesAssistantTasksPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      task?: ASalesAssistantTaskParams
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantTasksPartialUpdateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantTasksCreate
   * @summary Update task with marked as complete and next step
   * @request POST:/saas_company_users/sales_assistant/tasks
   */
  export namespace SalesAssistantTasksCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      task?: ASalesAssistantTaskCreateParams
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantTasksCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesAssistant
   * @name SalesAssistantUpdateCenterList
   * @summary List of update center entries for sales person company
   * @request GET:/saas_company_users/sales_assistant/update_center
   */
  export namespace SalesAssistantUpdateCenterList {
    export type RequestParams = {}
    export type RequestQuery = {
      search?: string
      /** Single day; cannot be combined with from/to */
      date?: string
      /** Sales person external_id */
      sales_person_external_id?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
      /** Klara dashboard mode; the from/to/deal_id params apply only with dashboard=true */
      dashboard?: ASalesAssistantUpdateCenterListParamsDashboardEnum
      /**
       * Dashboard mode: yyyy-MM-dd, inclusive; requires to
       * @format date
       */
      from?: string
      /**
       * Dashboard mode: yyyy-MM-dd, inclusive; alone means up to this day
       * @format date
       */
      to?: string
      /** Dashboard mode: Klara deal id; events are pruned to this deal */
      deal_id?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantUpdateCenterListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesActivityFeedsList
   * @summary Company activity feed for the current sales cycle
   * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/activity_feeds
   */
  export namespace SalesCyclesActivityFeedsList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityFeedsListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesAssignmentsReportingListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      salesCycleIterationId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsAssignmentsReportingListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesSalesCycleIterationsReportingList
   * @summary Sales cycle iteration reporting data
   * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsReportingListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesList
   * @summary List of all saas sales cycles for saas company
   * @request GET:/saas_company_users/sales_cycles
   */
  export namespace SalesCyclesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
      start_date: string
      /** SalesCycle search on names */
      search?: string
      /** Sort by values */
      sort_by?: ASaasSalesCycleSortByValues
      /** Sort by direction */
      sort_direction?: ASaasSalesCycleSortDirectionValues
      /** Country filter */
      country_id?: number
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesSalesIntelligenceIndexList
   * @summary List of all saas sales cycles for saas company and sales intelligence
   * @request GET:/saas_company_users/sales_cycles/sales_intelligence_index
   */
  export namespace SalesCyclesSalesIntelligenceIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
      start_date: string
      /** SalesCycle search on names */
      search?: string
      /** Sort by values */
      sort_by?: ASaasSalesCycleSortByValues
      /** Sort by direction */
      sort_direction?: ASaasSalesCycleSortDirectionValues
      /** Country filter */
      country_id?: number
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesIntelligenceIndexListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesDetail
   * @summary Saas sales cycle detail
   * @request GET:/saas_company_users/sales_cycles/{id}
   */
  export namespace SalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailResult
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesReportingList
   * @summary SAAS sales cycle reporting data
   * @request GET:/saas_company_users/sales_cycles/{id}/reporting
   */
  export namespace SalesCyclesReportingList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesReportingListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesNewsAndInsightsList
   * @summary Sales cycle / sales cycle iteration news and insights
   * @request GET:/saas_company_users/sales_cycles/{id}/news_and_insights
   */
  export namespace SalesCyclesNewsAndInsightsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesNewsAndInsightsListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesActivitiesChartList
   * @summary Sales cycle activities chart data
   * @request GET:/saas_company_users/sales_cycles/{id}/activities_chart
   */
  export namespace SalesCyclesActivitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivitiesChartListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesClientsReachedChartList
   * @summary Sales cycle clients reached chart data
   * @request GET:/saas_company_users/sales_cycles/{id}/clients_reached_chart
   */
  export namespace SalesCyclesClientsReachedChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesClientsReachedChartListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesActivityOccurrencesChartList
   * @summary Activity occurrences chart data
   * @request GET:/saas_company_users/sales_cycles/{id}/activity_occurrences_chart
   */
  export namespace SalesCyclesActivityOccurrencesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      activity_event: AActivityEvents
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityOccurrencesChartListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesOpportunitiesChartList
   * @summary Opportunities chart data
   * @request GET:/saas_company_users/sales_cycles/{id}/opportunities_chart
   */
  export namespace SalesCyclesOpportunitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesOpportunitiesChartListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesProspectsList
   * @summary Admins list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
   * @request GET:/saas_company_users/sales_cycles/{id}/prospects
   */
  export namespace SalesCyclesProspectsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      /** Search query */
      search?: string
      /** Last changed within */
      last_change?: string
      "statuses[]"?: string[]
      "stages[]"?: string[]
      "segments[]"?: string[]
      /** Sort by values */
      sort_by?: ASalesCyclesProspectValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesProspectsAutocompleteValuesList
   * @summary Returns the 10 most similar autocomplete values for specified field and value
   * @request GET:/saas_company_users/sales_cycles/{id}/prospects_autocomplete_values
   */
  export namespace SalesCyclesProspectsAutocompleteValuesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Autocomplete field */
      field: ASalesCycleProspectAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsAutocompleteValuesListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/SalesCycles
   * @name SalesCyclesSalesNewsList
   * @summary Sales cycle - current iteration sales news
   * @request GET:/saas_company_users/sales_cycles/{id}/sales_news
   */
  export namespace SalesCyclesSalesNewsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesNewsListOutput
  }

  /**
   * No description
   * @tags SaasCompanyUsers/Users
   * @name UsersList
   * @summary List of all users for saas company
   * @request GET:/saas_company_users/users
   */
  export namespace UsersList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** User search on names and email */
      search?: string
      /** Sort by values */
      sort_by?: AUsersListParamsSortByEnum
      /** Sort by direction */
      sort_direction?: AUsersListParamsSortDirectionEnum
      /** Filter by user status */
      status?: AUsersListParamsStatusEnum[]
      /** Filter by user role */
      role?: AUsersListParamsRoleEnum[]
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AUsersListData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/Users
   * @name UsersDeactivateCreate
   * @summary Deactivate user
   * @request POST:/saas_company_users/users/{id}/deactivate
   */
  export namespace UsersDeactivateCreate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AUsersDeactivateCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/Users
   * @name UsersActivateCreate
   * @summary Activate user
   * @request POST:/saas_company_users/users/{id}/activate
   */
  export namespace UsersActivateCreate {
    export type RequestParams = {
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AUsersActivateCreateData
  }

  /**
   * No description
   * @tags SaasCompanyUsers/Users
   * @name UsersStatsList
   * @summary Get user role counts
   * @request GET:/saas_company_users/users/stats
   */
  export namespace UsersStatsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AUsersStatsListData
  }
}

export namespace SaasSalesPeople {
  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name DashboardList
   * @summary Saas Sales Person dashboard data
   * @request GET:/saas_sales_people/dashboard
   */
  export namespace DashboardList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardListResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsList
   * @summary List of drafted prospects for advanced search session
   * @request GET:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsListResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
   * @summary List of detailed drafted prospects for advanced search session
   * @request GET:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDetailedList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADetailedDraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADetailedDraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate
   * @summary Download selected drafted prospects in the EXCEL
   * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/download_as_excel
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
   * @summary Mark drafted prospect as viewed
   * @request PATCH:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
   * @summary Transfer selected drafted prospects into assignment prospects
   * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
   * @summary Search for new drafted prospects using AI
   * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
   * @summary Search for contact information of selected drafted prospects
   * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
   * @summary Soft deletes drafted prospect
   * @request DELETE:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDelete {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDeleteResult
  }

  /**
   * No description
   * @tags AdvancedSearch/SaasSalesPeople
   * @name LeadsAdvancedSearchSessionsCreate
   * @summary Create advanced search sessions
   * @request POST:/saas_sales_people/leads/advanced_search_sessions
   */
  export namespace LeadsAdvancedSearchSessionsCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      assignment_id?: number
      advanced_search_filter?: AAdvancedSearchFilter
    }
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsCreateResult
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsLeadsForAssignmentList
   * @summary List of all assignment leads
   * @request GET:/saas_sales_people/leads/assignments/{id}/leads_for_assignment
   */
  export namespace LeadsAssignmentsLeadsForAssignmentList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Contact person name search query */
      contact_person_search?: string
      /** Organization name search query */
      organization_name_search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "cities[]"?: string[]
      phone_number_present?: boolean
      email_present?: boolean
      contacted_already?: boolean
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsLeadsForAssignmentListOutput
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add prospect to sales cycle from the leads database
   * @request POST:/saas_sales_people/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace LeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      lead_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsAddProspectFromLeadCreateOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsUploadProspectsCreate
   * @summary Assignment upload prospects for SAAS Sales People
   * @request POST:/saas_sales_people/prospects/assignments/{id}/upload_prospects
   */
  export namespace ProspectsAssignmentsUploadProspectsCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      /** Attach prospect import file */
      prospects_file: File
    }
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsUploadProspectsCreateOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsPrepareToApproveList
   * @summary List of all prospects for assignment waiting to send for approve
   * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_prepare_to_approve
   */
  export namespace ProspectsAssignmentsProspectsPrepareToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsPrepareToApproveListResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsWaitingToApproveList
   * @summary List of all prospects for assignment waiting to approve by company / admin
   * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_waiting_to_approve
   */
  export namespace ProspectsAssignmentsProspectsWaitingToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsWaitingToApproveListOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsFinishedList
   * @summary List of all prospects for assignment already finished
   * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_finished
   */
  export namespace ProspectsAssignmentsProspectsFinishedList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsFinishedListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/Prospects
   * @name ProspectsAssignmentsDownloadProspectsList
   * @summary Download all prospects as Excel for an assignment
   * @request GET:/saas_sales_people/prospects/assignments/{id}/download_prospects
   */
  export namespace ProspectsAssignmentsDownloadProspectsList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsDownloadProspectsListResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsSendForApprovalCreate
   * @summary Send assignment prospects in the sales person draft status for approval
   * @request POST:/saas_sales_people/prospects/assignments/{id}/send_for_approval
   */
  export namespace ProspectsAssignmentsSendForApprovalCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsSendForApprovalCreateResult
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesDetail
   * @summary Sales Cycle detail for SAAS Sales Person Prospects
   * @request GET:/saas_sales_people/prospects/sales_cycles/{id}
   */
  export namespace ProspectsSalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesDetailResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantDealsList
   * @summary List of all prospects for assignment waiting to send for approve
   * @request GET:/saas_sales_people/sales_assistant/deals
   */
  export namespace SalesAssistantDealsList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Search query */
      search?: string
      "priorities[]"?: string[]
      "planned_task_types[]"?: ASalesAssistantDealPlannedTaskTypes[]
      /** Sort by values */
      sort_by?: ASalesAssistantDealSortByValues
      /** Sort by direction */
      sort_direction?: ASalesAssistantDealSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDealsListResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantDealsDetail
   * @summary Saas People Sales Assistant Prospect detail
   * @request GET:/saas_sales_people/sales_assistant/deals/{external_id}
   */
  export namespace SalesAssistantDealsDetail {
    export type RequestParams = {
      /** Deal external ID */
      externalId: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantDealsDetailResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantSalesPeopleList
   * @summary List of sales cycles for sales person company
   * @request GET:/saas_sales_people/sales_assistant/sales_people
   */
  export namespace SalesAssistantSalesPeopleList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Selling External ID */
      selling_external_id?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSalesPeopleListResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantCreateCallCreate
   * @summary Call command for create AI call
   * @request POST:/saas_sales_people/sales_assistant/create_call
   */
  export namespace SalesAssistantCreateCallCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantCreateCallCreateResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantSettingsList
   * @summary Detail of sales assistant sales person settings
   * @request GET:/saas_sales_people/sales_assistant/settings
   */
  export namespace SalesAssistantSettingsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSettingsListResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantSettingsPartialUpdate
   * @summary Update settings for Sales Assistant Sales Person
   * @request PATCH:/saas_sales_people/sales_assistant/settings
   */
  export namespace SalesAssistantSettingsPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      sales_person: ASalesAssistantSalesPersonSettingsAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantSettingsPartialUpdateResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantTasksPartialUpdate
   * @summary Update task with marked as complete and next step
   * @request PATCH:/saas_sales_people/sales_assistant/tasks
   */
  export namespace SalesAssistantTasksPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      task?: ASalesAssistantTaskParams
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantTasksPartialUpdateResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantTasksCreate
   * @summary Update task with marked as complete and next step
   * @request POST:/saas_sales_people/sales_assistant/tasks
   */
  export namespace SalesAssistantTasksCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      task?: ASalesAssistantTaskCreateParams
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantTasksCreateResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesAssistant
   * @name SalesAssistantUpdateCenterList
   * @summary List of update center entries for sales person company
   * @request GET:/saas_sales_people/sales_assistant/update_center
   */
  export namespace SalesAssistantUpdateCenterList {
    export type RequestParams = {}
    export type RequestQuery = {
      search?: string
      date?: string
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesAssistantUpdateCenterListResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesActivityFeedsList
   * @summary Saas sales person activity feed for the current sales cycle
   * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/activity_feeds
   */
  export namespace SalesCyclesActivityFeedsList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityFeedsListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesAssignmentsReportingListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      salesCycleIterationId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsAssignmentsReportingListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesSalesCycleIterationsReportingList
   * @summary Sales cycle iteration reporting data
   * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsReportingListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesDetail
   * @summary Saas sales cycle detail
   * @request GET:/saas_sales_people/sales_cycles/{id}
   */
  export namespace SalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailOutput
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesSalesNewsList
   * @summary Sales cycle - current iteration sales news
   * @request GET:/saas_sales_people/sales_cycles/{id}/sales_news
   */
  export namespace SalesCyclesSalesNewsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesNewsListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesSalesIntelligenceIndexList
   * @summary List of all saas sales cycles for saas sales person and sales intelligence
   * @request GET:/saas_sales_people/sales_cycles/sales_intelligence_index
   */
  export namespace SalesCyclesSalesIntelligenceIndexList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
      start_date: string
      /** SalesCycle search on names */
      search?: string
      /** Sort by values */
      sort_by?: ASaasSalesCycleSortByValues
      /** Sort by direction */
      sort_direction?: ASaasSalesCycleSortDirectionValues
      /** Country filter */
      country_id?: number
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesIntelligenceIndexListResult
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesReportingList
   * @summary Sales cycle reporting data
   * @request GET:/saas_sales_people/sales_cycles/{id}/reporting
   */
  export namespace SalesCyclesReportingList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesReportingListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesActivitiesChartList
   * @summary Sales cycle activities chart data
   * @request GET:/saas_sales_people/sales_cycles/{id}/activities_chart
   */
  export namespace SalesCyclesActivitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivitiesChartListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesClientsReachedChartList
   * @summary Sales cycle clients reached chart data
   * @request GET:/saas_sales_people/sales_cycles/{id}/clients_reached_chart
   */
  export namespace SalesCyclesClientsReachedChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesClientsReachedChartListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesActivityOccurrencesChartList
   * @summary Activity occurrences chart data
   * @request GET:/saas_sales_people/sales_cycles/{id}/activity_occurrences_chart
   */
  export namespace SalesCyclesActivityOccurrencesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      activity_event: AActivityEvents
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityOccurrencesChartListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesOpportunitiesChartList
   * @summary Opportunities chart data
   * @request GET:/saas_sales_people/sales_cycles/{id}/opportunities_chart
   */
  export namespace SalesCyclesOpportunitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesOpportunitiesChartListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesProspectsList
   * @summary SalesPeople list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
   * @request GET:/saas_sales_people/sales_cycles/{id}/prospects
   */
  export namespace SalesCyclesProspectsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      /** Search query */
      search?: string
      /** Last changed within */
      last_change?: string
      "statuses[]"?: string[]
      "stages[]"?: string[]
      "segments[]"?: string[]
      /** Sort by values */
      sort_by?: ASalesCyclesProspectValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsListResponse
  }

  /**
   * No description
   * @tags SaasSalesPeople/SalesCycles
   * @name SalesCyclesProspectsAutocompleteValuesList
   * @summary Admins the 10 most similar autocomplete values for specified field and value
   * @request GET:/saas_sales_people/sales_cycles/{id}/prospects_autocomplete_values
   */
  export namespace SalesCyclesProspectsAutocompleteValuesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Autocomplete field */
      field: ASalesCycleProspectAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsAutocompleteValuesListResponse
  }
}

export namespace SalesCycles {
  /**
   * No description
   * @tags SalesCycles
   * @name SalesCyclesList
   * @summary List of all sales cycles
   * @request GET:/sales_cycles
   */
  export namespace SalesCyclesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesListResult
  }

  /**
   * No description
   * @tags SalesCycles
   * @name SalesCyclesCreate
   * @summary Create sales cycle
   * @request POST:/sales_cycles
   */
  export namespace SalesCyclesCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      sales_cycle: {
        country_id: number
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesCreateData
  }

  /**
   * No description
   * @tags SalesCycles
   * @name SalesCyclesDetail
   * @summary Sales cycle detail
   * @request GET:/sales_cycles/{id}
   */
  export namespace SalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailResponse
  }

  /**
   * No description
   * @tags SalesCycles
   * @name SalesCyclesPartialUpdate
   * @summary Update sales cycle
   * @request PATCH:/sales_cycles/{id}
   */
  export namespace SalesCyclesPartialUpdate {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      sales_cycle?: ASalesCycleAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesPartialUpdateData
  }

  /**
   * No description
   * @tags SalesCycles
   * @name FinalizeCreate
   * @summary Finalize sales cycle process
   * @request POST:/sales_cycles/{id}/finalize
   */
  export namespace FinalizeCreate {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AFinalizeCreateData
  }

  /**
   * No description
   * @tags SalesCycles
   * @name FinalizeKeyDetailsCreate
   * @summary Finalize key details for sales cycle
   * @request POST:/sales_cycles/{id}/finalize_key_details
   */
  export namespace FinalizeKeyDetailsCreate {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AFinalizeKeyDetailsCreateData
  }

  /**
   * No description
   * @tags SalesCycles
   * @name PackagesList
   * @summary List of all packages for sales cycle
   * @request GET:/sales_cycles/{id}/packages
   */
  export namespace PackagesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APackagesListResult
  }

  /**
   * No description
   * @tags SalesCycles
   * @name RemoveAttachmentDelete
   * @summary Remove sales cycle attachment
   * @request DELETE:/sales_cycles/{id}/remove_attachment
   */
  export namespace RemoveAttachmentDelete {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      attachment_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ARemoveAttachmentDeleteData
  }
}

export namespace SalesPeople {
  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsList
   * @summary List of drafted prospects for advanced search session
   * @request GET:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsListOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
   * @summary List of detailed drafted prospects for advanced search session
   * @request GET:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDetailedList {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Sort by values */
      sort_by?: ADetailedDraftedProspectSortByValues
      /** Sort by direction */
      sort_direction?: ADetailedDraftedProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
   * @summary Mark drafted prospect as viewed
   * @request PATCH:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
   * @summary Transfer selected drafted prospects into assignment prospects
   * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
   * @summary Search for new drafted prospects using AI
   * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
   * @summary Search for contact information of selected drafted prospects
   * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate {
    export type RequestParams = {
      advancedSearchSessionId: number
    }
    export type RequestQuery = {
      /** Drafted prospects IDs */
      "ids[]": number[]
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
   * @summary Soft deletes drafted prospect
   * @request DELETE:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
   */
  export namespace LeadsAdvancedSearchSessionsDraftedProspectsDelete {
    export type RequestParams = {
      advancedSearchSessionId: number
      /** Drafted prospect ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsDraftedProspectsDeleteOutput
  }

  /**
   * No description
   * @tags AdvancedSearch/SalesPeople
   * @name LeadsAdvancedSearchSessionsCreate
   * @summary Create advanced search sessions
   * @request POST:/sales_people/leads/advanced_search_sessions
   */
  export namespace LeadsAdvancedSearchSessionsCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      assignment_id?: number
      advanced_search_filter?: AAdvancedSearchFilter
    }
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAdvancedSearchSessionsCreateOutput
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsLeadsForAssignmentList
   * @summary List of all assignment leads
   * @request GET:/sales_people/leads/assignments/{id}/leads_for_assignment
   */
  export namespace LeadsAssignmentsLeadsForAssignmentList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Contact person name search query */
      contact_person_search?: string
      /** Organization name search query */
      organization_name_search?: string
      "country_ids[]"?: number[]
      "positions[]"?: string[]
      "segments[]"?: string[]
      "cities[]"?: string[]
      phone_number_present?: boolean
      email_present?: boolean
      contacted_already?: boolean
      "company_sizes[]"?: ACompanySizesFilters[]
      "ids[]"?: number[]
      /** Sort by values */
      sort_by?: ALeadSortByValues
      /** Sort by direction */
      sort_direction?: ALeadSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsLeadsForAssignmentListResponse
  }

  /**
   * No description
   * @tags Leads
   * @name LeadsAssignmentsAddProspectFromLeadCreate
   * @summary Add prospect to sales cycle from the leads database
   * @request POST:/sales_people/leads/assignments/{id}/add_prospect_from_lead
   */
  export namespace LeadsAssignmentsAddProspectFromLeadCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      lead_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ALeadsAssignmentsAddProspectFromLeadCreateResponse
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsPrepareToApproveList
   * @summary List of all prospects for assignment waiting to send for approve
   * @request GET:/sales_people/prospects/assignments/{id}/prospects_prepare_to_approve
   */
  export namespace ProspectsAssignmentsProspectsPrepareToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsPrepareToApproveListOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsWaitingToApproveList
   * @summary List of all prospects for assignment waiting to approve by company / admin
   * @request GET:/sales_people/prospects/assignments/{id}/prospects_waiting_to_approve
   */
  export namespace ProspectsAssignmentsProspectsWaitingToApproveList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsWaitingToApproveListResponse
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsProspectsFinishedList
   * @summary List of all prospects for assignment already finished
   * @request GET:/sales_people/prospects/assignments/{id}/prospects_finished
   */
  export namespace ProspectsAssignmentsProspectsFinishedList {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {
      /** Search query */
      search?: string
      /** Segment substring filter */
      segment?: string
      /** Sort by values */
      sort_by?: AProspectSortByValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Status filter */
      status?: AProspectQueryStatusValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsProspectsFinishedListPayload
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsAssignmentsSendForApprovalCreate
   * @summary Send assignment prospects in the sales person draft status for approval
   * @request POST:/sales_people/prospects/assignments/{id}/send_for_approval
   */
  export namespace ProspectsAssignmentsSendForApprovalCreate {
    export type RequestParams = {
      /** Assignment ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsAssignmentsSendForApprovalCreateOutput
  }

  /**
   * No description
   * @tags Prospects
   * @name ProspectsSalesCyclesDetail
   * @summary Sales Cycle detail for Sales Person Prospects
   * @request GET:/sales_people/prospects/sales_cycles/{id}
   */
  export namespace ProspectsSalesCyclesDetail {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AProspectsSalesCyclesDetailPayload
  }

  /**
   * No description
   * @tags ActivityFeeds
   * @name SalesCyclesActivityFeedsList
   * @summary Sales person activity feed for the current sales cycle
   * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/activity_feeds
   */
  export namespace SalesCyclesActivityFeedsList {
    export type RequestParams = {
      salesCycleId: number
    }
    export type RequestQuery = {
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityFeedsListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesAssignmentsReportingListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
   * @summary Assignment reporting data
   * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsAssignmentsReportingList {
    export type RequestParams = {
      salesCycleId: number
      salesCycleIterationId: number
      /** Base64 assignment ID */
      id: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsAssignmentsReportingListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesSalesCycleIterationsReportingList
   * @summary Sales cycle iteration reporting data
   * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
   */
  export namespace SalesCyclesSalesCycleIterationsReportingList {
    export type RequestParams = {
      salesCycleId: number
      /** Sales cycle iteration ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesCycleIterationsReportingListPayload
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SalesCyclesSalesNewsList
   * @summary Sales cycle - current iteration sales news
   * @request GET:/sales_people/sales_cycles/{id}/sales_news
   */
  export namespace SalesCyclesSalesNewsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesSalesNewsListPayload
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SalesCyclesDetailsList
   * @summary Sales cycle detail
   * @request GET:/sales_people/sales_cycles/{id}/details
   */
  export namespace SalesCyclesDetailsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesDetailsListOutput
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesReportingList
   * @summary Sales cycle reporting data
   * @request GET:/sales_people/sales_cycles/{id}/reporting
   */
  export namespace SalesCyclesReportingList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesReportingListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesActivitiesChartList
   * @summary Sales cycle activities chart data
   * @request GET:/sales_people/sales_cycles/{id}/activities_chart
   */
  export namespace SalesCyclesActivitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivitiesChartListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesClientsReachedChartList
   * @summary Sales cycle clients reached chart data
   * @request GET:/sales_people/sales_cycles/{id}/clients_reached_chart
   */
  export namespace SalesCyclesClientsReachedChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesClientsReachedChartListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesActivityOccurrencesChartList
   * @summary Activity occurrences chart data
   * @request GET:/sales_people/sales_cycles/{id}/activity_occurrences_chart
   */
  export namespace SalesCyclesActivityOccurrencesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      activity_event: AActivityEvents
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesActivityOccurrencesChartListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesOpportunitiesChartList
   * @summary Opportunities chart data
   * @request GET:/sales_people/sales_cycles/{id}/opportunities_chart
   */
  export namespace SalesCyclesOpportunitiesChartList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesOpportunitiesChartListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesProspectsList
   * @summary SalesPeople list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
   * @request GET:/sales_people/sales_cycles/{id}/prospects
   */
  export namespace SalesCyclesProspectsList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      sales_cycle_iteration_id?: number
      assignment_id?: string
      /** Search query */
      search?: string
      /** Last changed within */
      last_change?: string
      "statuses[]"?: string[]
      "stages[]"?: string[]
      "segments[]"?: string[]
      /** Sort by values */
      sort_by?: ASalesCyclesProspectValues
      /** Sort by direction */
      sort_direction?: AProspectSortDirectionValues
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsListPayload
  }

  /**
   * No description
   * @tags SalesPeople/SalesCycles
   * @name SalesCyclesProspectsAutocompleteValuesList
   * @summary Sales People the 10 most similar autocomplete values for specified field and value
   * @request GET:/sales_people/sales_cycles/{id}/prospects_autocomplete_values
   */
  export namespace SalesCyclesProspectsAutocompleteValuesList {
    export type RequestParams = {
      /** Sales cycle ID */
      id: number
    }
    export type RequestQuery = {
      /** Autocomplete field */
      field: ASalesCycleProspectAutocompleteFields
      /** Search value */
      value: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesCyclesProspectsAutocompleteValuesListPayload
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SalesPeopleCreate
   * @summary Registers in sales person
   * @request POST:/sales_people
   */
  export namespace SalesPeopleCreate {
    export type RequestParams = {}
    export type RequestQuery = {
      lang?: string
    }
    export type RequestBody = {
      sales_person: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPeopleCreateData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name ConfirmationCreate
   * @summary Resend confirmation email
   * @request POST:/sales_people/confirmation
   */
  export namespace ConfirmationCreate {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      sales_person: {
        email: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = AConfirmationCreateOutput
  }

  /**
   * No description
   * @tags SalesPeople
   * @name ConfirmationPartialUpdate
   * @summary Confirms email address and saves user details
   * @request PATCH:/sales_people/confirmation
   */
  export namespace ConfirmationPartialUpdate {
    export type RequestParams = {}
    export type RequestQuery = {
      confirmation_token: string
    }
    export type RequestBody = {
      "sales_person[first_name]": string
      "sales_person[last_name]": string
      "sales_person[phone_number]": string
      "sales_person[password]": string
      "sales_person[password_confirmation]": string
      "sales_person[tac_agreement]": boolean
      "sales_person[country_id]": number
      "sales_person[city]": string
      /** Resume file */
      "sales_person[resume]": File
    }
    export type RequestHeaders = {}
    export type ResponseBody = AConfirmationPartialUpdateResult
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SalesPeopleDetail
   * @summary Get sales person profile data
   * @request GET:/sales_people/{id}
   */
  export namespace SalesPeopleDetail {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {
      /** To specify sections returned in response */
      section?: ASalesPeopleDetailParamsSectionEnum
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPeopleDetailData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SalesPeoplePartialUpdate
   * @summary Update sales person
   * @request PATCH:/sales_people/{id}
   */
  export namespace SalesPeoplePartialUpdate {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {
      /** To specify sections returned in response */
      section?: ASalesPeoplePartialUpdateParamsSectionEnum
    }
    export type RequestBody = {
      sales_person?: ASalesPersonAttributes
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPeoplePartialUpdateData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name PublicList
   * @summary Get public sales person data
   * @request GET:/sales_people/{id}/public
   */
  export namespace PublicList {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = APublicListData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name AcceptPartialUpdate
   * @summary Accept sales person
   * @request PATCH:/sales_people/{id}/accept
   */
  export namespace AcceptPartialUpdate {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {
      /** To specify sections returned in response */
      section?: AAcceptPartialUpdateParams1SectionEnum
    }
    export type RequestBody = {
      sales_person?: AAcceptSalesPerson
    }
    export type RequestHeaders = {}
    export type ResponseBody = AAcceptPartialUpdateResult
  }

  /**
   * No description
   * @tags SalesPeople
   * @name BusinessDataList
   * @summary Get business data
   * @request GET:/sales_people/{id}/business_data
   */
  export namespace BusinessDataList {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ABusinessDataListData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name SubmitBusinessDataCreate
   * @summary Submit business data
   * @request POST:/sales_people/{id}/submit_business_data
   */
  export namespace SubmitBusinessDataCreate {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      sales_person: {
        company_name: string
        company_id: string
        street_address: string
        city: string
        postal_code: string
        country_id: number
        state?: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ASubmitBusinessDataCreateData
  }

  /**
   * No description
   * @tags SalesPeople
   * @name DashboardDetail
   * @summary Get sales person dashboard data
   * @request GET:/sales_people/dashboard/{id}
   */
  export namespace DashboardDetail {
    export type RequestParams = {
      /** Sales Person ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ADashboardDetailResult
  }
}

export namespace SalesPlans {
  /**
   * No description
   * @tags Sales Plans
   * @name SalesPlansList
   * @summary List of all sales plans
   * @request GET:/sales_plans
   */
  export namespace SalesPlansList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** SalesPlan search on names */
      search?: string
      /** Sort by values */
      sort_by?: ASalesPlanSortByValues
      /** Sort by direction */
      sort_direction?: ASalesPlanSortDirectionValues
      /** Status filter */
      status?: ASalesPlanQueryStatusValues
      /** Country filter */
      country_id?: number
      /** Page number */
      page?: number
      /** Number of results per page */
      per_page?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASalesPlansListData
  }
}

export namespace Settings {
  /**
   * No description
   * @tags Settings
   * @name SettingsList
   * @summary List of all countries, currencies and other settings
   * @request GET:/settings
   */
  export namespace SettingsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ASettingsListData
  }
}

export namespace Subscriptions {
  /**
   * No description
   * @tags Subscriptions
   * @name CheckoutDetail
   * @summary Show order data
   * @request GET:/subscriptions/checkout/{id}
   */
  export namespace CheckoutDetail {
    export type RequestParams = {
      /** Order ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACheckoutDetailData
  }

  /**
   * No description
   * @tags Subscriptions
   * @name CheckoutCreate
   * @summary Confirm order with customer data
   * @request POST:/subscriptions/checkout/{id}
   */
  export namespace CheckoutCreate {
    export type RequestParams = {
      /** Order ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      order?: {
        country_id: number
        payment_method: APaymentMethods
        /** must be true */
        terms_of_service: boolean
        subscription_billing_type: ASubscriptionBillingTypes
        customer_name: string
        customer_email: string
        city: string
        address: string
        postal_code: string
        state?: string
        company_name: string
        company_number: string
        company_tax_number?: string
        company_vat_number?: string
        invoice_detail_id?: number
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACheckoutCreateData
  }

  /**
   * No description
   * @tags Subscriptions
   * @name CheckoutUpdate
   * @summary Update order with specific params
   * @request PUT:/subscriptions/checkout/{id}
   */
  export namespace CheckoutUpdate {
    export type RequestParams = {
      /** Order ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      /** Update specific parameter Country or billing type, that recalculates prices for order */
      order?: {
        country_id?: number
        subscription_billing_type?: ASubscriptionBillingTypes
        company_vat_number?: string
        voucher_code_input?: string
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACheckoutUpdateData
  }

  /**
   * No description
   * @tags Subscriptions
   * @name CheckoutPreviewList
   * @summary Show preview order data
   * @request GET:/subscriptions/checkout/{id}/preview
   */
  export namespace CheckoutPreviewList {
    export type RequestParams = {
      /** Order ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ACheckoutPreviewListData
  }

  /**
   * No description
   * @tags Subscriptions
   * @name CheckoutCreate2
   * @summary Create order for submitted packages
   * @request POST:/subscriptions/checkout
   * @originalName checkoutCreate
   * @duplicate
   */
  export namespace CheckoutCreate2 {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = {
      checkout?: {
        packages: {
          package_id: number
          sales_person_id?: number | null
        }[]
        sales_cycle_id: number
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACheckoutCreate2Data
  }

  /**
   * No description
   * @tags Subscriptions
   * @name CancelCreate
   * @summary Cancel subscription
   * @request POST:/subscriptions/{id}/cancel
   */
  export namespace CancelCreate {
    export type RequestParams = {
      /** Subscription ID */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = {
      subscription: {
        cancel_reason: string | null
      }
    }
    export type RequestHeaders = {}
    export type ResponseBody = ACancelCreateResult
  }
}

import type {AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType} from "axios"
import axios from "axios"

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"]
  private secure?: boolean
  private format?: ResponseType

  constructor({securityWorker, secure, format, ...axiosConfig}: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "https://api.closerocket.com",
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? {"Content-Type": type} : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title API
 * @version v1
 * @baseUrl https://api.closerocket.com
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  admins = {
    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsLeadsForAssignmentList
     * @summary List of all assignment leads
     * @request GET:/admins/leads/assignments/{id}/leads_for_assignment
     */
    leadsAssignmentsLeadsForAssignmentList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Contact person name search query */
        contact_person_search?: string
        /** Organization name search query */
        organization_name_search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "cities[]"?: string[]
        phone_number_present?: boolean
        email_present?: boolean
        contacted_already?: boolean
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsLeadsForAssignmentListData, void>({
        path: `/admins/leads/assignments/${id}/leads_for_assignment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add prospect to sales cycle from the leads database
     * @request POST:/admins/leads/assignments/{id}/add_prospect_from_lead
     */
    leadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      query: {
        lead_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsAddProspectFromLeadCreateData, void>({
        path: `/admins/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsUploadProspectsCreate
     * @summary Assignment upload prospects for Admin Prospects
     * @request POST:/admins/prospects/assignments/{id}/upload_prospects
     */
    prospectsAssignmentsUploadProspectsCreate: (
      id: number,
      data: {
        "prospect_import[ownership_level]"?: AProspectImportOwnershipLevelEnum | null
        "prospect_import[ownership_id]"?: number | null
        "prospect_import[source]": string
        /** Attach prospect import file */
        "prospect_import[prospects_file]": File
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsUploadProspectsCreateData, void>({
        path: `/admins/prospects/assignments/${id}/upload_prospects`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsPrepareToApproveList
     * @summary List of all prospects for assignment waiting to send for approve
     * @request GET:/admins/prospects/assignments/{id}/prospects_prepare_to_approve
     */
    prospectsAssignmentsProspectsPrepareToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        sales_person_id?: number
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsPrepareToApproveListData, void>({
        path: `/admins/prospects/assignments/${id}/prospects_prepare_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsWaitingToApproveList
     * @summary List of all prospects for assignment waiting to approve by company
     * @request GET:/admins/prospects/assignments/{id}/prospects_waiting_to_approve
     */
    prospectsAssignmentsProspectsWaitingToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        sales_person_id?: number
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsWaitingToApproveListData, void>({
        path: `/admins/prospects/assignments/${id}/prospects_waiting_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsFinishedList
     * @summary List of all prospects for assignment already finished
     * @request GET:/admins/prospects/assignments/{id}/prospects_finished
     */
    prospectsAssignmentsProspectsFinishedList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        sales_person_id?: number
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsFinishedListData, void>({
        path: `/admins/prospects/assignments/${id}/prospects_finished`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsSendForApprovalCreate
     * @summary Send assignment prospects in the draft status for approval
     * @request POST:/admins/prospects/assignments/{id}/send_for_approval
     */
    prospectsAssignmentsSendForApprovalCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsSendForApprovalCreateData, void>({
        path: `/admins/prospects/assignments/${id}/send_for_approval`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsFinishApprovalCreate
     * @summary Finish approval process of ready-to-approve prospects
     * @request POST:/admins/prospects/assignments/{id}/finish_approval
     */
    prospectsAssignmentsFinishApprovalCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsFinishApprovalCreateData, void>({
        path: `/admins/prospects/assignments/${id}/finish_approval`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsSyncWithCrmCreate
     * @summary Sync approved finished assigned prospects with the CRM
     * @request POST:/admins/prospects/assignments/{id}/sync_with_crm
     */
    prospectsAssignmentsSyncWithCrmCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsSyncWithCrmCreateData, void>({
        path: `/admins/prospects/assignments/${id}/sync_with_crm`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsApproveProspectsCreate
     * @summary Approve and finished prospects without notifications
     * @request POST:/admins/prospects/assignments/{id}/approve_prospects
     */
    prospectsAssignmentsApproveProspectsCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsApproveProspectsCreateData, void>({
        path: `/admins/prospects/assignments/${id}/approve_prospects`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsAcceptWarningsCreate
     * @summary Approve prospect normalization warnings
     * @request POST:/admins/prospects/assignments/{id}/accept_warnings/{prospect_id}
     */
    prospectsAssignmentsAcceptWarningsCreate: (id: number, prospectId: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsAcceptWarningsCreateData, void>({
        path: `/admins/prospects/assignments/${id}/accept_warnings/${prospectId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesDetail
     * @summary Sales Cycle detail for Prospects
     * @request GET:/admins/prospects/sales_cycles/{id}
     */
    prospectsSalesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsSalesCyclesDetailData, void>({
        path: `/admins/prospects/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesLifetimeList
     * @summary Sales Cycle detail for Prospects
     * @request GET:/admins/prospects/sales_cycles/{id}/lifetime
     */
    prospectsSalesCyclesLifetimeList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        sales_person_id?: number
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsSalesCyclesLifetimeListData, void>({
        path: `/admins/prospects/sales_cycles/${id}/lifetime`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsList
     * @summary List of all prospects with admin-visible data
     * @request GET:/admins/prospects
     */
    prospectsList: (
      query: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Prospects sales cycle ID */
        sales_cycle_id: number
        /** Search in phone numbers, email and organization name */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsListData, void>({
        path: `/admins/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsExtendedIndexList
     * @summary List of all prospects with admin-visible data and prospects statistics
     * @request GET:/admins/prospects/extended_index
     */
    prospectsExtendedIndexList: (
      query: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Prospects sales cycle ID */
        sales_cycle_id: number
        /** Search in phone numbers, email and organization name */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsExtendedIndexListData, void>({
        path: `/admins/prospects/extended_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/ActivityFeeds
     * @name SalesCyclesActivityFeedsList
     * @summary Admin activity feed for the current sales cycle
     * @request GET:/admins/sales_cycles/{sales_cycle_id}/activity_feeds
     */
    salesCyclesActivityFeedsList: (
      salesCycleId: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityFeedsListData, void>({
        path: `/admins/sales_cycles/${salesCycleId}/activity_feeds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/admins/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
     */
    salesCyclesAssignmentsReportingList: (salesCycleId: number, id: string, params: RequestParams = {}) =>
      this.request<ASalesCyclesAssignmentsReportingListData, void>({
        path: `/admins/sales_cycles/${salesCycleId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
     */
    salesCyclesSalesCycleIterationsAssignmentsReportingList: (
      salesCycleId: number,
      salesCycleIterationId: number,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsAssignmentsReportingListData, void>({
        path: `/admins/sales_cycles/${salesCycleId}/sales_cycle_iterations/${salesCycleIterationId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesSalesCycleIterationsFinalizeReportCreate
     * @summary Admin finalize report for sales cycle iteration reporting data
     * @request POST:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/finalize_report
     */
    salesCyclesSalesCycleIterationsFinalizeReportCreate: (
      salesCycleId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsFinalizeReportCreateData, void>({
        path: `/admins/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/finalize_report`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesSalesCycleIterationsReportingList
     * @summary Sales cycle iteration reporting data
     * @request GET:/admins/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
     */
    salesCyclesSalesCycleIterationsReportingList: (salesCycleId: number, id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesCycleIterationsReportingListData, void>({
        path: `/admins/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesReportingList
     * @summary Sales cycle reporting data
     * @request GET:/admins/sales_cycles/{id}/reporting
     */
    salesCyclesReportingList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesReportingListData, void>({
        path: `/admins/sales_cycles/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesSalesNewsList
     * @summary Sales cycle - current iteration sales news
     * @request GET:/admins/sales_cycles/{id}/sales_news
     */
    salesCyclesSalesNewsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesNewsListData, void>({
        path: `/admins/sales_cycles/${id}/sales_news`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesDetailsList
     * @summary Sales cycle detail
     * @request GET:/admins/sales_cycles/{id}/details
     */
    salesCyclesDetailsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailsListData, void>({
        path: `/admins/sales_cycles/${id}/details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesNewsAndInsightsList
     * @summary Sales cycle / sales cycle iteration news and insights
     * @request GET:/admins/sales_cycles/{id}/news_and_insights
     */
    salesCyclesNewsAndInsightsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesNewsAndInsightsListData, void>({
        path: `/admins/sales_cycles/${id}/news_and_insights`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesActivitiesChartList
     * @summary Sales cycle activities chart data
     * @request GET:/admins/sales_cycles/{id}/activities_chart
     */
    salesCyclesActivitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivitiesChartListData, void>({
        path: `/admins/sales_cycles/${id}/activities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesClientsReachedChartList
     * @summary Sales cycle clients reached chart data
     * @request GET:/admins/sales_cycles/{id}/clients_reached_chart
     */
    salesCyclesClientsReachedChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesClientsReachedChartListData, void>({
        path: `/admins/sales_cycles/${id}/clients_reached_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesActivityOccurrencesChartList
     * @summary Activity occurrences chart data
     * @request GET:/admins/sales_cycles/{id}/activity_occurrences_chart
     */
    salesCyclesActivityOccurrencesChartList: (
      id: number,
      query: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        activity_event: AActivityEvents
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityOccurrencesChartListData, void>({
        path: `/admins/sales_cycles/${id}/activity_occurrences_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesOpportunitiesChartList
     * @summary Opportunities chart data
     * @request GET:/admins/sales_cycles/{id}/opportunities_chart
     */
    salesCyclesOpportunitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesOpportunitiesChartListData, void>({
        path: `/admins/sales_cycles/${id}/opportunities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesProspectsList
     * @summary Admins list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
     * @request GET:/admins/sales_cycles/{id}/prospects
     */
    salesCyclesProspectsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        /** Search query */
        search?: string
        /** Last changed within */
        last_change?: string
        "statuses[]"?: string[]
        "stages[]"?: string[]
        "segments[]"?: string[]
        /** Sort by values */
        sort_by?: ASalesCyclesProspectValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsListData, void>({
        path: `/admins/sales_cycles/${id}/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admins/SalesCycles
     * @name SalesCyclesProspectsAutocompleteValuesList
     * @summary Admins the 10 most similar autocomplete values for specified field and value
     * @request GET:/admins/sales_cycles/{id}/prospects_autocomplete_values
     */
    salesCyclesProspectsAutocompleteValuesList: (
      id: number,
      query: {
        /** Autocomplete field */
        field: ASalesCycleProspectAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsAutocompleteValuesListData, void>({
        path: `/admins/sales_cycles/${id}/prospects_autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  bulkActions = {
    /**
     * No description
     *
     * @tags Leads
     * @name AdminLeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add many prospects to assignment from the leads database
     * @request POST:/bulk_actions/admin/leads/assignments/{id}/add_prospect_from_lead
     */
    adminLeadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AAdminLeadsAssignmentsAddProspectFromLeadCreateData, void>({
        path: `/bulk_actions/admin/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name AdminLeadsAssignmentsDeleteProspectFromLeadDelete
     * @summary Delete assigment prospects created from provided leads
     * @request DELETE:/bulk_actions/admin/leads/assignments/{id}/delete_prospect_from_lead
     */
    adminLeadsAssignmentsDeleteProspectFromLeadDelete: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AAdminLeadsAssignmentsDeleteProspectFromLeadDeleteData, void>({
        path: `/bulk_actions/admin/leads/assignments/${id}/delete_prospect_from_lead`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsDelete
     * @summary Remove a list of leads
     * @request DELETE:/bulk_actions/leads
     */
    leadsDelete: (
      data: {
        ids: number[]
        delete_strategy?: ALeadDeleteStrategies
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsDeleteResult, void>({
        path: `/bulk_actions/leads`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsDisapprovePartialUpdate
     * @summary Disapprove a list of prospects
     * @request PATCH:/bulk_actions/prospects/disapprove
     */
    prospectsDisapprovePartialUpdate: (
      data: {
        ids: number[]
        disapprove_reason: AProspectDisapproveReasons
        disapprove_reason_text?: string | null
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsDisapprovePartialUpdateData, void>({
        path: `/bulk_actions/prospects/disapprove`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsPrioritizePartialUpdate
     * @summary Prioritize a list of prospects
     * @request PATCH:/bulk_actions/prospects/prioritize
     */
    prospectsPrioritizePartialUpdate: (
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsPrioritizePartialUpdateData, void>({
        path: `/bulk_actions/prospects/prioritize`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsDeprioritizePartialUpdate
     * @summary Deprioritize a list of prospects
     * @request PATCH:/bulk_actions/prospects/deprioritize
     */
    prospectsDeprioritizePartialUpdate: (
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsDeprioritizePartialUpdateData, void>({
        path: `/bulk_actions/prospects/deprioritize`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsDelete
     * @summary Remove a list of prospects
     * @request DELETE:/bulk_actions/prospects
     */
    prospectsDelete: (
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsDeleteData, void>({
        path: `/bulk_actions/prospects`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add many prospects to assignment from the leads database
     * @request POST:/bulk_actions/saas_company_users/leads/assignments/{id}/add_prospect_from_lead
     */
    saasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasCompanyUsersLeadsAssignmentsAddProspectFromLeadCreateData, void>({
        path: `/bulk_actions/saas_company_users/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDelete
     * @summary Delete assigment prospects created from provided leads
     * @request DELETE:/bulk_actions/saas_company_users/leads/assignments/{id}/delete_prospect_from_lead
     */
    saasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDelete: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasCompanyUsersLeadsAssignmentsDeleteProspectFromLeadDeleteData, void>({
        path: `/bulk_actions/saas_company_users/leads/assignments/${id}/delete_prospect_from_lead`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add many prospects to assignment from the leads database
     * @request POST:/bulk_actions/saas_sales_people/leads/assignments/{id}/add_prospect_from_lead
     */
    saasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasSalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData, void>({
        path: `/bulk_actions/saas_sales_people/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete
     * @summary Delete assigment prospects created from provided leads
     * @request DELETE:/bulk_actions/saas_sales_people/leads/assignments/{id}/delete_prospect_from_lead
     */
    saasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasSalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData, void>({
        path: `/bulk_actions/saas_sales_people/leads/assignments/${id}/delete_prospect_from_lead`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SalesPeopleLeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add many prospects to assignment from the leads database
     * @request POST:/bulk_actions/sales_people/leads/assignments/{id}/add_prospect_from_lead
     */
    salesPeopleLeadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPeopleLeadsAssignmentsAddProspectFromLeadCreateData, void>({
        path: `/bulk_actions/sales_people/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SalesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete
     * @summary Delete assigment prospects created from provided leads
     * @request DELETE:/bulk_actions/sales_people/leads/assignments/{id}/delete_prospect_from_lead
     */
    salesPeopleLeadsAssignmentsDeleteProspectFromLeadDelete: (
      id: number,
      data: {
        ids: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPeopleLeadsAssignmentsDeleteProspectFromLeadDeleteData, void>({
        path: `/bulk_actions/sales_people/leads/assignments/${id}/delete_prospect_from_lead`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  assignmentOffers = {
    /**
     * No description
     *
     * @tags Assignment Offers
     * @name AssignmentOffersList
     * @summary List of all assignment_offers
     * @request GET:/assignment_offers
     */
    assignmentOffersList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AAssignmentOffersListData, void>({
        path: `/assignment_offers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignment Offers
     * @name AssignmentOffersCreate
     * @summary Create a new assignment_offer
     * @request POST:/assignment_offers
     */
    assignmentOffersCreate: (
      data: {
        assignment_offer: {
          assignment_id: number
          sales_person_id: number
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<AAssignmentOffersCreateData, void>({
        path: `/assignment_offers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignment Offers
     * @name AssignmentOffersDetail
     * @summary Get one assignment offer
     * @request GET:/assignment_offers/{id}
     */
    assignmentOffersDetail: (id: number, params: RequestParams = {}) =>
      this.request<AAssignmentOffersDetailData, void>({
        path: `/assignment_offers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignment Offers
     * @name AssignmentOffersDelete
     * @summary Cancel an assignment offer
     * @request DELETE:/assignment_offers/{id}
     */
    assignmentOffersDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        AAssignmentOffersDeleteData,
        void | {
          errors?: AErrorBaseMessages
        }
      >({
        path: `/assignment_offers/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignment Offers
     * @name AcceptPartialUpdate
     * @summary Accept an assignment offer
     * @request PATCH:/assignment_offers/{id}/accept
     */
    acceptPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<AAcceptPartialUpdateData, void>({
        path: `/assignment_offers/${id}/accept`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignment Offers
     * @name RejectPartialUpdate
     * @summary Accept an assignment offer
     * @request PATCH:/assignment_offers/{id}/reject
     */
    rejectPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ARejectPartialUpdateData, void>({
        path: `/assignment_offers/${id}/reject`,
        method: "PATCH",
        format: "json",
        ...params,
      }),
  }
  assignments = {
    /**
     * No description
     *
     * @tags Assignments
     * @name AssignmentsList
     * @summary List of all assignments
     * @request GET:/assignments
     */
    assignmentsList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AAssignmentsListData, void>({
        path: `/assignments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignments
     * @name AssignmentsDetail
     * @summary Get one assignment
     * @request GET:/assignments/{id}
     */
    assignmentsDetail: (id: number, params: RequestParams = {}) =>
      this.request<AAssignmentsDetailData, void>({
        path: `/assignments/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assignments
     * @name RevokePartialUpdate
     * @summary Clear assignment from current sales person
     * @request PATCH:/assignments/{id}/revoke
     */
    revokePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        ARevokePartialUpdateData,
        void | {
          errors?: AErrorBaseMessages
        }
      >({
        path: `/assignments/${id}/revoke`,
        method: "PATCH",
        format: "json",
        ...params,
      }),
  }
  companies = {
    /**
     * No description
     *
     * @tags Companies
     * @name CompaniesDetail
     * @summary Get company profile data
     * @request GET:/companies/{id}
     */
    companiesDetail: (
      id: number,
      query?: {
        /** To specify sections returned in response */
        section?: ACompaniesDetailParamsSectionEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<ACompaniesDetailData, void>({
        path: `/companies/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name CompaniesPartialUpdate
     * @summary Update company
     * @request PATCH:/companies/{id}
     */
    companiesPartialUpdate: (
      id: number,
      data: {
        company?: ACompanyAttributes
      },
      query?: {
        /** To specify sections returned in response */
        section?: ACompaniesPartialUpdateParamsSectionEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<ACompaniesPartialUpdateData, void>({
        path: `/companies/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  companyUsers = {
    /**
     * No description
     *
     * @tags ActivityFeeds
     * @name ActivityFeedsLikePartialUpdate
     * @summary Activity feed company like
     * @request PATCH:/company_users/activity_feeds/{id}/like
     */
    activityFeedsLikePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<AActivityFeedsLikePartialUpdateData, void>({
        path: `/company_users/activity_feeds/${id}/like`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActivityFeeds
     * @name ActivityFeedsDislikePartialUpdate
     * @summary Activity feed company dislike
     * @request PATCH:/company_users/activity_feeds/{id}/dislike
     */
    activityFeedsDislikePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<AActivityFeedsDislikePartialUpdateData, void>({
        path: `/company_users/activity_feeds/${id}/dislike`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name DashboardDetail
     * @summary Get company user dashboard data
     * @request GET:/company_users/dashboard/{id}
     */
    dashboardDetail: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardDetailData, void>({
        path: `/company_users/dashboard/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name DashboardActiveSalesCyclesList
     * @summary Get active sales cycles for company dashboard
     * @request GET:/company_users/dashboard/{id}/active_sales_cycles
     */
    dashboardActiveSalesCyclesList: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardActiveSalesCyclesListData, void>({
        path: `/company_users/dashboard/${id}/active_sales_cycles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name DashboardDraftedSalesCyclesList
     * @summary Get drafted sales cycles for company dashboard
     * @request GET:/company_users/dashboard/{id}/drafted_sales_cycles
     */
    dashboardDraftedSalesCyclesList: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardDraftedSalesCyclesListData, void>({
        path: `/company_users/dashboard/${id}/drafted_sales_cycles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name DashboardFinishedSalesCyclesList
     * @summary Get finished sales cycles for company dashboard
     * @request GET:/company_users/dashboard/{id}/finished_sales_cycles
     */
    dashboardFinishedSalesCyclesList: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardFinishedSalesCyclesListData, void>({
        path: `/company_users/dashboard/${id}/finished_sales_cycles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name DashboardPausedSalesCyclesList
     * @summary Get paused sales cycles for company dashboard
     * @request GET:/company_users/dashboard/{id}/paused_sales_cycles
     */
    dashboardPausedSalesCyclesList: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardPausedSalesCyclesListData, void>({
        path: `/company_users/dashboard/${id}/paused_sales_cycles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectDisapprovePartialUpdate
     * @summary Disapprove a prospect of assignment
     * @request PATCH:/company_users/prospects/assignments/{id}/prospect_disapprove
     */
    prospectsAssignmentsProspectDisapprovePartialUpdate: (
      id: number,
      data: {
        prospect: {
          /** Prospect ID */
          id: number
          disapprove_reason: AProspectDisapproveReasons
          disapprove_reason_text?: string | null
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectDisapprovePartialUpdateData, void>({
        path: `/company_users/prospects/assignments/${id}/prospect_disapprove`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsWaitingToApproveList
     * @summary Prospects Company list of all prospects for assignment waiting to approve
     * @request GET:/company_users/prospects/assignments/{id}/prospects_waiting_to_approve
     */
    prospectsAssignmentsProspectsWaitingToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: ACompanyProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsWaitingToApproveListResult, void>({
        path: `/company_users/prospects/assignments/${id}/prospects_waiting_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsFinishedList
     * @summary Prospects Company list of all prospects for assignment already finished
     * @request GET:/company_users/prospects/assignments/{id}/prospects_finished
     */
    prospectsAssignmentsProspectsFinishedList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: ACompanyProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsFinishedListResult, void>({
        path: `/company_users/prospects/assignments/${id}/prospects_finished`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsApproveProspectsCreate
     * @summary Company approve ready-to-approved prospects
     * @request POST:/company_users/prospects/assignments/{id}/approve_prospects
     */
    prospectsAssignmentsApproveProspectsCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsApproveProspectsCreateResult, void>({
        path: `/company_users/prospects/assignments/${id}/approve_prospects`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesDetail
     * @summary Sales Cycle detail for Company Prospects
     * @request GET:/company_users/prospects/sales_cycles/{id}
     */
    prospectsSalesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsSalesCyclesDetailResult, void>({
        path: `/company_users/prospects/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsList
     * @summary List of all prospects with company-user-visible data
     * @request GET:/company_users/prospects
     */
    prospectsList: (
      query: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Prospects sales cycle ID */
        sales_cycle_id: number
        /** Search organization name */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsListResult, void>({
        path: `/company_users/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsExtendedIndexList
     * @summary List of all prospects with company-user-visible data and prospects statistics
     * @request GET:/company_users/prospects/extended_index
     */
    prospectsExtendedIndexList: (
      query: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Prospects sales cycle ID */
        sales_cycle_id: number
        /** Search organization name */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsExtendedIndexListResult, void>({
        path: `/company_users/prospects/extended_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCycleIterationsDetail
     * @summary Sales cycle iteration detail
     * @request GET:/company_users/sales_cycle_iterations/{id}
     * @deprecated
     */
    salesCycleIterationsDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCycleIterationsDetailData, void>({
        path: `/company_users/sales_cycle_iterations/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActivityFeeds
     * @name SalesCyclesActivityFeedsList
     * @summary Company activity feed for the current sales cycle
     * @request GET:/company_users/sales_cycles/{sales_cycle_id}/activity_feeds
     */
    salesCyclesActivityFeedsList: (
      salesCycleId: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityFeedsListResult, void>({
        path: `/company_users/sales_cycles/${salesCycleId}/activity_feeds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/company_users/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
     */
    salesCyclesAssignmentsReportingList: (salesCycleId: number, id: string, params: RequestParams = {}) =>
      this.request<ASalesCyclesAssignmentsReportingListResult, void>({
        path: `/company_users/sales_cycles/${salesCycleId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
     */
    salesCyclesSalesCycleIterationsAssignmentsReportingList: (
      salesCycleId: number,
      salesCycleIterationId: number,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsAssignmentsReportingListResult, void>({
        path: `/company_users/sales_cycles/${salesCycleId}/sales_cycle_iterations/${salesCycleIterationId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesSalesCycleIterationsReportingList
     * @summary Sales cycle iteration reporting data
     * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
     */
    salesCyclesSalesCycleIterationsReportingList: (salesCycleId: number, id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesCycleIterationsReportingListResult, void>({
        path: `/company_users/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers/SalesCycles/SalesPeople
     * @name SalesCyclesSalesPeopleList
     * @summary Sales cycle iteration reporting data
     * @request GET:/company_users/sales_cycles/{sales_cycle_id}/sales_people
     */
    salesCyclesSalesPeopleList: (salesCycleId: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesPeopleListData, void>({
        path: `/company_users/sales_cycles/${salesCycleId}/sales_people`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesDetail
     * @summary Sales cycle detail
     * @request GET:/company_users/sales_cycles/{id}
     * @deprecated
     */
    salesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailData, void>({
        path: `/company_users/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesSalesNewsList
     * @summary Sales cycle - current iteration sales news
     * @request GET:/company_users/sales_cycles/{id}/sales_news
     */
    salesCyclesSalesNewsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesNewsListResult, void>({
        path: `/company_users/sales_cycles/${id}/sales_news`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesDetailsList
     * @summary Sales cycle detail
     * @request GET:/company_users/sales_cycles/{id}/details
     */
    salesCyclesDetailsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailsListResult, void>({
        path: `/company_users/sales_cycles/${id}/details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesReportingList
     * @summary Sales cycle reporting data
     * @request GET:/company_users/sales_cycles/{id}/reporting
     */
    salesCyclesReportingList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesReportingListResult, void>({
        path: `/company_users/sales_cycles/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesNewsAndInsightsList
     * @summary Sales cycle / sales cycle iteration news and insights
     * @request GET:/company_users/sales_cycles/{id}/news_and_insights
     */
    salesCyclesNewsAndInsightsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesNewsAndInsightsListResult, void>({
        path: `/company_users/sales_cycles/${id}/news_and_insights`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesActivitiesChartList
     * @summary Sales cycle activities chart data
     * @request GET:/company_users/sales_cycles/{id}/activities_chart
     */
    salesCyclesActivitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivitiesChartListResult, void>({
        path: `/company_users/sales_cycles/${id}/activities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesClientsReachedChartList
     * @summary Sales cycle clients reached chart data
     * @request GET:/company_users/sales_cycles/{id}/clients_reached_chart
     */
    salesCyclesClientsReachedChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesClientsReachedChartListResult, void>({
        path: `/company_users/sales_cycles/${id}/clients_reached_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesActivityOccurrencesChartList
     * @summary Activity occurrences chart data
     * @request GET:/company_users/sales_cycles/{id}/activity_occurrences_chart
     */
    salesCyclesActivityOccurrencesChartList: (
      id: number,
      query: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        activity_event: AActivityEvents
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityOccurrencesChartListResult, void>({
        path: `/company_users/sales_cycles/${id}/activity_occurrences_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesOpportunitiesChartList
     * @summary Opportunities chart data
     * @request GET:/company_users/sales_cycles/{id}/opportunities_chart
     */
    salesCyclesOpportunitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesOpportunitiesChartListResult, void>({
        path: `/company_users/sales_cycles/${id}/opportunities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesProspectsList
     * @summary List of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
     * @request GET:/company_users/sales_cycles/{id}/prospects
     */
    salesCyclesProspectsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        /** Search query */
        search?: string
        /** Last changed within */
        last_change?: string
        "statuses[]"?: ASalesCycleProspectStatuses[]
        "stages[]"?: ASalesCycleFilterStages[]
        "segments[]"?: string[]
        /** Sort by values */
        sort_by?: ASalesCyclesProspectValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsListResult, void>({
        path: `/company_users/sales_cycles/${id}/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name SalesCyclesProspectsAutocompleteValuesList
     * @summary The 10 most similar autocomplete values for specified field and value
     * @request GET:/company_users/sales_cycles/{id}/prospects_autocomplete_values
     */
    salesCyclesProspectsAutocompleteValuesList: (
      id: number,
      query: {
        /** Autocomplete field */
        field: ASalesCycleProspectAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsAutocompleteValuesListResult, void>({
        path: `/company_users/sales_cycles/${id}/prospects_autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name CompanyUsersCreate
     * @summary Registers in company user
     * @request POST:/company_users
     */
    companyUsersCreate: (
      data: {
        company_user: {
          email: string
        }
      },
      query?: {
        lang?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ACompanyUsersCreateData, void>({
        path: `/company_users`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name ConfirmationCreate
     * @summary Resend confirmation email
     * @request POST:/company_users/confirmation
     */
    confirmationCreate: (
      data: {
        company_user: {
          email: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<AConfirmationCreateData, void>({
        path: `/company_users/confirmation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name ConfirmationPartialUpdate
     * @summary Confirms email address and saves user details
     * @request PATCH:/company_users/confirmation
     */
    confirmationPartialUpdate: (
      data: {
        company: {
          name: string
        }
        company_user: {
          phone_number: string
          password: string
          password_confirmation: string
          tac_agreement: boolean
        }
        confirmation_token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        AConfirmationPartialUpdateData,
        void | {
          errors?: AErrors
        }
      >({
        path: `/company_users/confirmation`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompanyUsers
     * @name WelcomeScreenDetail
     * @summary Get company user welcome screen data
     * @request GET:/company_users/welcome_screen/{id}
     */
    welcomeScreenDetail: (id: number, params: RequestParams = {}) =>
      this.request<AWelcomeScreenDetailData, void>({
        path: `/company_users/welcome_screen/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  countries = {
    /**
     * No description
     *
     * @tags Countries
     * @name CountriesList
     * @summary List of all countries
     * @request GET:/countries
     */
    countriesList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ACountriesListData, any>({
        path: `/countries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  currencies = {
    /**
     * No description
     *
     * @tags Currencies
     * @name CurrenciesList
     * @summary List of all currencies
     * @request GET:/currencies
     */
    currenciesList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ACurrenciesListData, void>({
        path: `/currencies`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name SignInCreate
     * @summary Creates a session / logs in user
     * @request POST:/users/sign_in
     */
    signInCreate: (
      data: {
        user?: {
          email: string
          password: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ASignInCreateData, void>({
        path: `/users/sign_in`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name SignOutDelete
     * @summary Deletes a session / logs out user
     * @request DELETE:/users/sign_out
     */
    signOutDelete: (params: RequestParams = {}) =>
      this.request<ASignOutDeleteData, void>({
        path: `/users/sign_out`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PasswordCreate
     * @summary Requests password reset (forgot password flow)
     * @request POST:/users/password
     */
    passwordCreate: (
      data: {
        user?: {
          email: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<APasswordCreateData, void>({
        path: `/users/password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PasswordUpdate
     * @summary Reset password
     * @request PUT:/users/password
     */
    passwordUpdate: (
      data: {
        user?: {
          password: string
          password_confirmation: string
          reset_password_token: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<APasswordUpdateData, void>({
        path: `/users/password`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  importers = {
    /**
     * No description
     *
     * @tags Importers
     * @name RollbackDelete
     * @summary Rollback importer and its imported resources
     * @request DELETE:/importers/{id}/rollback
     */
    rollbackDelete: (id: number, params: RequestParams = {}) =>
      this.request<ARollbackDeleteData, void>({
        path: `/importers/${id}/rollback`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  }
  invitationAcceptances = {
    /**
     * No description
     *
     * @tags Invitations
     * @name InvitationAcceptancesCreate
     * @summary Accept invitation
     * @request POST:/invitation_acceptances
     */
    invitationAcceptancesCreate: (
      data:
        | {
            /** @example "John" */
            first_name: string
            /** @example "Doe" */
            last_name: string
            /** @example "Password123" */
            password: string
            /** @example "token123" */
            invitation_token: string
          }
        | {
            /** @example "John" */
            first_name: string
            /** @example "Doe" */
            last_name: string
            /** @example "Password123" */
            password: string
            /** @example "token123" */
            invitation_token: string
            /** @example 1 */
            country_id: number
          }
        | {
            /** @example "John" */
            first_name: string
            /** @example "Doe" */
            last_name: string
            /** @example "Password123" */
            password: string
            /** @example "token123" */
            invitation_token: string
            /** @example 1 */
            country_id: number
            /** @example "+1234567890" */
            phone_number: string
          },
      params: RequestParams = {}
    ) =>
      this.request<AInvitationAcceptancesCreateData, AErrors | AErrorBaseMessages>({
        path: `/invitation_acceptances`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  invitations = {
    /**
     * No description
     *
     * @tags Invitations
     * @name InvitationsCreate
     * @summary Create bulk invitations
     * @request POST:/invitations
     */
    invitationsCreate: (
      data: {
        users: {
          /** @example "user@example.com" */
          email: string
          type: AUsersTypeEnum
        }[]
      },
      params: RequestParams = {}
    ) =>
      this.request<AInvitationsCreateData, AErrors | void>({
        path: `/invitations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitations
     * @name ResendCreate
     * @summary Resend invitation
     * @request POST:/invitations/{id}/resend
     */
    resendCreate: (id: number, params: RequestParams = {}) =>
      this.request<AResendCreateData, void | AErrorBaseMessages>({
        path: `/invitations/${id}/resend`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitations
     * @name CancelCreate
     * @summary Cancel invitation
     * @request POST:/invitations/{id}/cancel
     */
    cancelCreate: (id: number, params: RequestParams = {}) =>
      this.request<ACancelCreateData, void | AErrorBaseMessages>({
        path: `/invitations/${id}/cancel`,
        method: "POST",
        ...params,
      }),
  }
  invoiceDetails = {
    /**
     * No description
     *
     * @tags InvoiceDetails
     * @name InvoiceDetailsList
     * @summary List of invoice details belongs to company or user
     * @request GET:/invoice_details
     */
    invoiceDetailsList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AInvoiceDetailsListData, void>({
        path: `/invoice_details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InvoiceDetails
     * @name InvoiceDetailsCreate
     * @summary Creates a new invoice detail
     * @request POST:/invoice_details
     */
    invoiceDetailsCreate: (
      data: {
        invoice_detail: AInvoiceDetailAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<AInvoiceDetailsCreateData, void>({
        path: `/invoice_details`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InvoiceDetails
     * @name InvoiceDetailsUpdate
     * @summary Updates an invoice detail
     * @request PUT:/invoice_details/{id}
     */
    invoiceDetailsUpdate: (
      id: number,
      data: {
        invoice_detail: AInvoiceDetailAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<AInvoiceDetailsUpdateData, void>({
        path: `/invoice_details/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
  languages = {
    /**
     * No description
     *
     * @tags Languages
     * @name LanguagesList
     * @summary List of all languages
     * @request GET:/languages
     */
    languagesList: (params: RequestParams = {}) =>
      this.request<ALanguagesListData, void>({
        path: `/languages`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  leads = {
    /**
     * No description
     *
     * @tags AdvancedSearch/CustomElevatorPitches
     * @name CustomElevatorPitchesDetail
     * @summary Get custom elevator pitch for sales cycle
     * @request GET:/leads/custom_elevator_pitches/{sales_cycle_id}
     */
    customElevatorPitchesDetail: (salesCycleId: number, params: RequestParams = {}) =>
      this.request<ACustomElevatorPitchesDetailData, void>({
        path: `/leads/custom_elevator_pitches/${salesCycleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsList
     * @summary List of all leads
     * @request GET:/leads
     */
    leadsList: (
      query?: {
        /** Search query */
        search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsListData, void>({
        path: `/leads`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name AutocompleteValuesList
     * @summary The 10 most similar autocomplete values for specified field and value
     * @request GET:/leads/autocomplete_values
     */
    autocompleteValuesList: (
      query: {
        /** Autocomplete field */
        field: ALeadAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AAutocompleteValuesListData, void>({
        path: `/leads/autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name ImportCreate
     * @summary Imports list of leads
     * @request POST:/leads/import
     */
    importCreate: (
      data: {
        "leads_import[leads_file]": File
        "leads_import[source]": string
        "leads_import[ownership_level]"?: AOwnershipLevels
        "leads_import[owner_id]"?: number | null
      },
      params: RequestParams = {}
    ) =>
      this.request<AImportCreateData, void>({
        path: `/leads/import`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name SalesPersonImportCreate
     * @summary Imports list of sales person leads
     * @request POST:/leads/sales_person_import
     */
    salesPersonImportCreate: (
      data: {
        "leads_import[leads_file]": File
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPersonImportCreateData, void>({
        path: `/leads/sales_person_import`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsDelete
     * @summary Deletes lead
     * @request DELETE:/leads/{id}
     */
    leadsDelete: (
      id: number,
      query: {
        delete_strategy: ALeadDeleteStrategies
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsDeleteData, void>({
        path: `/leads/${id}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsDetail
     * @summary Lead detail
     * @request GET:/leads/{id}
     */
    leadsDetail: (id: number, params: RequestParams = {}) =>
      this.request<ALeadsDetailData, void>({
        path: `/leads/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsPartialUpdate
     * @summary Updates a lead
     * @request PATCH:/leads/{id}
     */
    leadsPartialUpdate: (
      id: number,
      data: {
        lead: ALeadAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsPartialUpdateData, void>({
        path: `/leads/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name ImportersList
     * @summary List of leads importers
     * @request GET:/leads/importers
     */
    importersList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AImportersListData, void>({
        path: `/leads/importers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name IndexMetadataList
     * @summary Display metadata for leads index
     * @request GET:/leads/index_metadata
     */
    indexMetadataList: (params: RequestParams = {}) =>
      this.request<AIndexMetadataListData, void>({
        path: `/leads/index_metadata`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name RemovalRequestsIndexList
     * @summary List of requested removal leads
     * @request GET:/leads/removal_requests_index
     */
    removalRequestsIndexList: (
      query?: {
        /** Search query */
        search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ARemovalRequestsIndexListData, void>({
        path: `/leads/removal_requests_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name AcceptWarningsCreate
     * @summary Approve lead normalization warnings
     * @request POST:/leads/accept_warnings/{id}
     */
    acceptWarningsCreate: (id: number, params: RequestParams = {}) =>
      this.request<AAcceptWarningsCreateData, void>({
        path: `/leads/accept_warnings/${id}`,
        method: "POST",
        ...params,
      }),
  }
  masqueradeSessions = {
    /**
     * No description
     *
     * @tags Masquerade
     * @name MasqueradeSessionsCreate
     * @summary Start masquerading as another user
     * @request POST:/masquerade_sessions
     */
    masqueradeSessionsCreate: (
      query: {
        /** ID of the user to masquerade as */
        user_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        void | {
          error?: string
        }
      >({
        path: `/masquerade_sessions`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Masquerade
     * @name MasqueradeSessionsDelete
     * @summary End current masquerade session
     * @request DELETE:/masquerade_sessions
     */
    masqueradeSessionsDelete: (params: RequestParams = {}) =>
      this.request<
        any,
        void | {
          error?: string
        }
      >({
        path: `/masquerade_sessions`,
        method: "DELETE",
        ...params,
      }),
  }
  masqueradeTargets = {
    /**
     * No description
     *
     * @tags Masquerade
     * @name MasqueradeTargetsList
     * @summary List of users the current user can masquerade as
     * @request GET:/masquerade_targets
     */
    masqueradeTargetsList: (params: RequestParams = {}) =>
      this.request<AMasqueradeTargetsListData, void>({
        path: `/masquerade_targets`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  salesCycleIterations = {
    /**
     * No description
     *
     * @tags Sales People for matching
     * @name MatchableSalesPeopleList
     * @summary List of all sales people for matching
     * @request GET:/sales_cycle_iterations/{id}/matchable_sales_people
     */
    matchableSalesPeopleList: (
      id: number,
      query?: {
        /** SalesPerson search on names */
        search?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AMatchableSalesPeopleListData, void>({
        path: `/sales_cycle_iterations/${id}/matchable_sales_people`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycleIterations
     * @name SalesCycleIterationsList
     * @summary List of all sales cycle iterations
     * @request GET:/sales_cycle_iterations
     */
    salesCycleIterationsList: (
      query?: {
        /** Status filter */
        status?: ASalesCycleIterationsListParamsStatusEnum
        /** Start date filter */
        start_date?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCycleIterationsListData, void>({
        path: `/sales_cycle_iterations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycleIterations
     * @name SalesCycleIterationsDetail
     * @summary One sales cycle iteration
     * @request GET:/sales_cycle_iterations/{id}
     */
    salesCycleIterationsDetail: (
      id: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCycleIterationsDetailResult, void>({
        path: `/sales_cycle_iterations/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  packages = {
    /**
     * No description
     *
     * @tags Packages
     * @name PackagesList
     * @summary List of all packages for country
     * @request GET:/packages
     */
    packagesList: (
      query?: {
        /** Country code (SK, CZ etc., default is SK) */
        country_code?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<APackagesListData, void>({
        path: `/packages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  pendingConfirmations = {
    /**
     * No description
     *
     * @tags Pending Confirmations
     * @name PendingConfirmationsDetail
     * @summary Get confirmation data for a pending confirmation
     * @request GET:/pending_confirmations/{confirmation_token}
     */
    pendingConfirmationsDetail: (confirmationToken: string, params: RequestParams = {}) =>
      this.request<APendingConfirmationsDetailData, any>({
        path: `/pending_confirmations/${confirmationToken}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  prospects = {
    /**
     * No description
     *
     * @tags Prospects
     * @name ImportCreate
     * @summary Imports list of prospects (with leads) for specified sales cycle
     * @request POST:/prospects/import
     */
    importCreate: (
      data: {
        sales_cycle_id: number
        owner_id?: number | null
        ownership_level?: AOwnershipLevels
        /** @format binary */
        prospects_file: File
        source: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AImportCreateResult, void>({
        path: `/prospects/import`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name SalesPersonImportCreate
     * @summary Imports list of prospects (with leads) for specified sales cycle assignment
     * @request POST:/prospects/sales_person_import
     */
    salesPersonImportCreate: (
      data: {
        prospects_import: {
          sales_cycle_id: number
          assignment_id: number
          file: File
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPersonImportCreateResult, void>({
        path: `/prospects/sales_person_import`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ApprovePartialUpdate
     * @summary Approve a prospect of sales cycle
     * @request PATCH:/prospects/{id}/approve
     * @deprecated
     */
    approvePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<AApprovePartialUpdateData, void>({
        path: `/prospects/${id}/approve`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name RemoveApproveStatusPartialUpdate
     * @summary Remove approve status for a prospect of sales cycle
     * @request PATCH:/prospects/{id}/remove_approve_status
     * @deprecated
     */
    removeApproveStatusPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ARemoveApproveStatusPartialUpdateData, void>({
        path: `/prospects/${id}/remove_approve_status`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name DisapprovePartialUpdate
     * @summary Disapprove a prospect of sales cycle
     * @request PATCH:/prospects/{id}/disapprove
     * @deprecated
     */
    disapprovePartialUpdate: (
      id: number,
      data: {
        disapprove_reason: AProspectDisapproveReasons
      },
      params: RequestParams = {}
    ) =>
      this.request<ADisapprovePartialUpdateData, void>({
        path: `/prospects/${id}/disapprove`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name PrioritizePartialUpdate
     * @summary Prioritize a prospect of sales cycle
     * @request PATCH:/prospects/{id}/prioritize
     */
    prioritizePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<APrioritizePartialUpdateData, void>({
        path: `/prospects/${id}/prioritize`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name DeprioritizePartialUpdate
     * @summary Deprioritize a prospect of sales cycle
     * @request PATCH:/prospects/{id}/deprioritize
     */
    deprioritizePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ADeprioritizePartialUpdateData, void>({
        path: `/prospects/${id}/deprioritize`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name SaasCreateCreate
     * @summary Creates a prospect and sync it with the CRM for SAAS
     * @request POST:/prospects/saas_create
     */
    saasCreateCreate: (
      query: {
        assignment_id: number
      },
      data: {
        prospect: AProspectAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasCreateCreateData, void>({
        path: `/prospects/saas_create`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsCreate
     * @summary Creates a prospect for Marketplace
     * @request POST:/prospects
     */
    prospectsCreate: (
      query: {
        assignment_id: number
      },
      data: {
        prospect: AProspectAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsCreateData, void>({
        path: `/prospects`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsPartialUpdate
     * @summary Updates a prospect
     * @request PATCH:/prospects/{id}
     */
    prospectsPartialUpdate: (
      id: number,
      data: {
        prospect: AProspectAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsPartialUpdateData, void>({
        path: `/prospects/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsDelete
     * @summary Permanently deletes a prospect
     * @request DELETE:/prospects/{id}
     */
    prospectsDelete: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsDeleteResult, void>({
        path: `/prospects/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name SaasUpdatePartialUpdate
     * @summary Updates a SAAS prospect
     * @request PATCH:/prospects/{id}/saas_update
     */
    saasUpdatePartialUpdate: (
      id: number,
      data: {
        prospect: AProspectAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasUpdatePartialUpdateData, void>({
        path: `/prospects/${id}/saas_update`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name RemoveDisapprovePartialUpdate
     * @summary Remove disapprove status for a prospect of sales cycle
     * @request PATCH:/prospects/{id}/remove_disapprove
     */
    removeDisapprovePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<ARemoveDisapprovePartialUpdateData, void>({
        path: `/prospects/${id}/remove_disapprove`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ActivitiesList
     * @summary All or iteration scoped activities of prospects
     * @request GET:/prospects/{id}/activities
     */
    activitiesList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AActivitiesListData, void>({
        path: `/prospects/${id}/activities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name NotesList
     * @summary all notes for prospect deal
     * @request GET:/prospects/{id}/notes
     */
    notesList: (id: number, params: RequestParams = {}) =>
      this.request<ANotesListData, void>({
        path: `/prospects/${id}/notes`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  privacyRequest = {
    /**
     * No description
     *
     * @tags PrivacyRequests
     * @name PrivacyRequestList
     * @summary Privacy request detail
     * @request GET:/privacy_request
     */
    privacyRequestList: (
      query: {
        /** Privacy request token */
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<APrivacyRequestListData, void>({
        path: `/privacy_request`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrivacyRequests
     * @name RequestRemoveCreate
     * @summary Request remove privacy request for lead data
     * @request POST:/privacy_request/request_remove
     */
    requestRemoveCreate: (
      query: {
        /** Privacy request token */
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ARequestRemoveCreateData, void>({
        path: `/privacy_request/request_remove`,
        method: "POST",
        query: query,
        ...params,
      }),
  }
  reachEngine = {
    /**
     * No description
     *
     * @tags ReachEngine/Activities
     * @name ActivitiesList
     * @summary Per-channel activity and response counts
     * @request GET:/reach_engine/activities
     */
    activitiesList: (
      query?: {
        /**
         * Start of the window applied to occurred_at (inclusive)
         * @format date
         */
        from?: string
        /**
         * End of the window applied to occurred_at (inclusive)
         * @format date
         */
        to?: string
        /** Restrict statistics to a single campaign type */
        campaign_type?: AActivitiesListParams1CampaignTypeEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<AActivitiesListResult, void>({
        path: `/reach_engine/activities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReachEngine/Campaigns
     * @name CampaignsList
     * @summary List of reach campaigns with per-campaign metrics
     * @request GET:/reach_engine/campaigns
     */
    campaignsList: (
      query?: {
        /** Frontend status buckets to filter by */
        "status[]"?: ACampaignsListParamsStatusEnum[]
        /** Reach campaign ids to filter by */
        "ids[]"?: number[]
        /** Campaign type to filter by */
        campaign_type?: ACampaignsListParamsCampaignTypeEnum
        /**
         * Start of the window applied to meta (inclusive); rows ignore it
         * @format date
         */
        from?: string
        /**
         * End of the window applied to meta (inclusive); rows ignore it
         * @format date
         */
        to?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ACampaignsListData, void>({
        path: `/reach_engine/campaigns`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReachEngine/OutreachDepth
     * @name OutreachDepthList
     * @summary MQL and SQL by outbound activities received before the first crossing
     * @request GET:/reach_engine/outreach_depth
     */
    outreachDepthList: (
      query?: {
        /**
         * Start of the window applied to the MQL/SQL moment (inclusive)
         * @format date
         */
        from?: string
        /**
         * End of the window applied to the MQL/SQL moment (inclusive)
         * @format date
         */
        to?: string
        /** Restrict results to a single campaign type */
        campaign_type?: AOutreachDepthListParamsCampaignTypeEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<AOutreachDepthListData, void>({
        path: `/reach_engine/outreach_depth`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReachEngine/ResultsOverTime
     * @name ResultsOverTimeList
     * @summary Weekly first MQL and SQL crossings
     * @request GET:/reach_engine/results_over_time
     */
    resultsOverTimeList: (
      query?: {
        /**
         * Start of the window applied to the crossing time (inclusive)
         * @format date
         */
        from?: string
        /**
         * End of the window applied to the crossing time (inclusive)
         * @format date
         */
        to?: string
        /** Restrict results to a single campaign type */
        campaign_type?: AResultsOverTimeListParamsCampaignTypeEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<AResultsOverTimeListData, void>({
        path: `/reach_engine/results_over_time`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  saasCompanyUsers = {
    /**
     * No description
     *
     * @tags SaasCompanyUsers
     * @name ConfirmationList
     * @summary Confirm SaaS company owner email
     * @request GET:/saas_company_users/confirmation
     */
    confirmationList: (
      query: {
        confirmation_token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void>({
        path: `/saas_company_users/confirmation`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers
     * @name ConfirmationCreate
     * @summary Resend confirmation email
     * @request POST:/saas_company_users/confirmation
     */
    confirmationCreate: (
      data: {
        saas_company_user?: {
          email: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<AConfirmationCreateResult, void>({
        path: `/saas_company_users/confirmation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name DashboardList
     * @summary Saas Company User dashboard data
     * @request GET:/saas_company_users/dashboard
     */
    dashboardList: (params: RequestParams = {}) =>
      this.request<ADashboardListData, void>({
        path: `/saas_company_users/dashboard`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name DashboardSalesIntelligenceList
     * @summary Saas Company User dashboard with sales intelligence data
     * @request GET:/saas_company_users/dashboard/sales_intelligence
     */
    dashboardSalesIntelligenceList: (
      query: {
        /** Start date for iteration in 2025-06-01 format. Dates are received in dashboard */
        start_date: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ADashboardSalesIntelligenceListData, void>({
        path: `/saas_company_users/dashboard/sales_intelligence`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsList
     * @summary List of drafted prospects for advanced search session
     * @request GET:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsListData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
     * @summary List of detailed drafted prospects for advanced search session
     * @request GET:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
     */
    leadsAdvancedSearchSessionsDraftedProspectsDetailedList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADetailedDraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADetailedDraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/detailed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
     * @summary Mark drafted prospect as viewed
     * @request PATCH:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
     */
    leadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}/viewed`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
     * @summary Transfer selected drafted prospects into assignment prospects
     * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/add_to_prospects`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate
     * @summary Download selected drafted prospects in the EXCEL
     * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/download_as_excel
     */
    leadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/download_as_excel`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
     * @summary Search for new drafted prospects using AI
     * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate: (
      advancedSearchSessionId: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_drafted_prospects`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
     * @summary Search for contact information of selected drafted prospects
     * @request POST:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_contact_information`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
     * @summary Soft deletes drafted prospect
     * @request DELETE:/saas_company_users/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
     */
    leadsAdvancedSearchSessionsDraftedProspectsDelete: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDeleteData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasCompanyUsers
     * @name LeadsAdvancedSearchSessionsCreate
     * @summary Create advanced search sessions
     * @request POST:/saas_company_users/leads/advanced_search_sessions
     */
    leadsAdvancedSearchSessionsCreate: (
      data: {
        assignment_id?: number
        advanced_search_filter?: AAdvancedSearchFilter
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsCreateData, void>({
        path: `/saas_company_users/leads/advanced_search_sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsLeadsForAssignmentList
     * @summary List of all assignment leads
     * @request GET:/saas_company_users/leads/assignments/{id}/leads_for_assignment
     */
    leadsAssignmentsLeadsForAssignmentList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Contact person name search query */
        contact_person_search?: string
        /** Organization name search query */
        organization_name_search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "cities[]"?: string[]
        phone_number_present?: boolean
        email_present?: boolean
        contacted_already?: boolean
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsLeadsForAssignmentListResult, void>({
        path: `/saas_company_users/leads/assignments/${id}/leads_for_assignment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add prospect to sales cycle from the leads database
     * @request POST:/saas_company_users/leads/assignments/{id}/add_prospect_from_lead
     */
    leadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      query: {
        lead_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsAddProspectFromLeadCreateResult, void>({
        path: `/saas_company_users/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/Onboarding
     * @name OnboardingStatusList
     * @summary Saas Company User onboarding status
     * @request GET:/saas_company_users/onboarding/status
     */
    onboardingStatusList: (params: RequestParams = {}) =>
      this.request<AOnboardingStatusListData, void>({
        path: `/saas_company_users/onboarding/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsUploadProspectsCreate
     * @summary Assignment upload prospects for SAAS Company Users Prospects
     * @request POST:/saas_company_users/prospects/assignments/{id}/upload_prospects
     */
    prospectsAssignmentsUploadProspectsCreate: (
      id: number,
      data: {
        /** Attach prospect import file */
        prospects_file: File
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsUploadProspectsCreateResult, any>({
        path: `/saas_company_users/prospects/assignments/${id}/upload_prospects`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsFinishedList
     * @summary List of all prospects for assignment already finished
     * @request GET:/saas_company_users/prospects/assignments/{id}/prospects_finished
     */
    prospectsAssignmentsProspectsFinishedList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsFinishedListOutput, void>({
        path: `/saas_company_users/prospects/assignments/${id}/prospects_finished`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsSyncWithCrmCreate
     * @summary Sync approved finished assigned prospects with the CRM
     * @request POST:/saas_company_users/prospects/assignments/{id}/sync_with_crm
     */
    prospectsAssignmentsSyncWithCrmCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsSyncWithCrmCreateResult, void>({
        path: `/saas_company_users/prospects/assignments/${id}/sync_with_crm`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsDownloadProspectsList
     * @summary Download all prospects as Excel for an assignment
     * @request GET:/saas_company_users/prospects/assignments/{id}/download_prospects
     */
    prospectsAssignmentsDownloadProspectsList: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsDownloadProspectsListData, void>({
        path: `/saas_company_users/prospects/assignments/${id}/download_prospects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsApproveProspectsCreate
     * @summary Approve and finished prospects without notifications
     * @request POST:/saas_company_users/prospects/assignments/{id}/approve_prospects
     */
    prospectsAssignmentsApproveProspectsCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsApproveProspectsCreateOutput, void>({
        path: `/saas_company_users/prospects/assignments/${id}/approve_prospects`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesDetail
     * @summary SAAS Sales Cycle detail for Prospects
     * @request GET:/saas_company_users/prospects/sales_cycles/{id}
     */
    prospectsSalesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsSalesCyclesDetailOutput, void>({
        path: `/saas_company_users/prospects/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers
     * @name SaasCompanyUsersCreate
     * @summary Register a new SaaS company owner
     * @request POST:/saas_company_users
     */
    saasCompanyUsersCreate: (
      data: {
        saas_company_user?: {
          email: string
          password: string
          password_confirmation: string
          first_name: string
          last_name: string
          phone_number: string
          company_website: string
          tac_agreement: boolean
          locale?: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ASaasCompanyUsersCreateData, void>({
        path: `/saas_company_users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantCompanySettingsList
     * @summary Klara company settings
     * @request GET:/saas_company_users/sales_assistant/company_settings
     */
    salesAssistantCompanySettingsList: (params: RequestParams = {}) =>
      this.request<ASalesAssistantCompanySettingsListData, void>({
        path: `/saas_company_users/sales_assistant/company_settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantCompanySettingsPartialUpdate
     * @summary Update Klara company settings
     * @request PATCH:/saas_company_users/sales_assistant/company_settings
     */
    salesAssistantCompanySettingsPartialUpdate: (
      data: {
        company_settings: AKlaraCompanySettings
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantCompanySettingsPartialUpdateData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/company_settings`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardDealsDetail
     * @summary Klara dashboard deal detail
     * @request GET:/saas_company_users/sales_assistant/dashboard/deals/{id}
     */
    salesAssistantDashboardDealsDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesAssistantDashboardDealsDetailData, void>({
        path: `/saas_company_users/sales_assistant/dashboard/deals/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardDealsPartialUpdate
     * @summary Set the Klara dashboard deal priority
     * @request PATCH:/saas_company_users/sales_assistant/dashboard/deals/{id}
     */
    salesAssistantDashboardDealsPartialUpdate: (
      id: number,
      data: AKlaraDashboardDealUpdate,
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDashboardDealsPartialUpdateData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/dashboard/deals/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardDealsRemindCreate
     * @summary Remind the Klara dashboard deal owner
     * @request POST:/saas_company_users/sales_assistant/dashboard/deals/{id}/remind
     */
    salesAssistantDashboardDealsRemindCreate: (id: number, params: RequestParams = {}) =>
      this.request<ASalesAssistantDashboardDealsRemindCreateData, void | AKlaraRemindErrors>({
        path: `/saas_company_users/sales_assistant/dashboard/deals/${id}/remind`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardSalesPeopleList
     * @summary Klara dashboard sales people
     * @request GET:/saas_company_users/sales_assistant/dashboard/sales_people
     */
    salesAssistantDashboardSalesPeopleList: (
      query?: {
        /**
         * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
         * @format date
         */
        from?: string
        /**
         * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
         * @format date
         */
        to?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDashboardSalesPeopleListData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/dashboard/sales_people`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardSummaryList
     * @summary Klara dashboard summary
     * @request GET:/saas_company_users/sales_assistant/dashboard/summary
     */
    salesAssistantDashboardSummaryList: (
      query?: {
        /**
         * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
         * @format date
         */
        from?: string
        /**
         * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
         * @format date
         */
        to?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDashboardSummaryListData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/dashboard/summary`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant/Dashboard
     * @name SalesAssistantDashboardUpdatesOverTimeList
     * @summary Klara updates over time
     * @request GET:/saas_company_users/sales_assistant/dashboard/updates_over_time
     */
    salesAssistantDashboardUpdatesOverTimeList: (
      query: {
        /**
         * yyyy-MM-dd, inclusive; together with to or neither (lifetime)
         * @format date
         */
        from?: string
        /**
         * yyyy-MM-dd, inclusive; together with from or neither (lifetime)
         * @format date
         */
        to?: string
        granularity: AKlaraDashboardGranularityValues
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDashboardUpdatesOverTimeListData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/dashboard/updates_over_time`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantDealsList
     * @summary List of all prospects for assignment waiting to send for approve
     * @request GET:/saas_company_users/sales_assistant/deals
     */
    salesAssistantDealsList: (
      query?: {
        /** Search query */
        search?: string
        /** Sales person external_id */
        sales_person_external_id?: string
        "priorities[]"?: string[]
        "planned_task_types[]"?: ASalesAssistantDealPlannedTaskTypes[]
        /** Sort by values (dashboard mode: klara_dashboard_deal_sort_by_values) */
        sort_by?: ASalesAssistantDealSortByValues | AKlaraDashboardDealSortByValues
        /** Sort by direction */
        sort_direction?: ASalesAssistantDealSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Klara dashboard mode; the from/to/view/chip params apply only with dashboard=true */
        dashboard?: ASalesAssistantDealsListParamsDashboardEnum
        /**
         * Dashboard mode: yyyy-MM-dd, inclusive; together with to or neither (lifetime)
         * @format date
         */
        from?: string
        /**
         * Dashboard mode: yyyy-MM-dd, inclusive; together with from or neither (lifetime)
         * @format date
         */
        to?: string
        /** Dashboard mode, default attention */
        view?: AKlaraDashboardDealViewValues
        /** Dashboard mode, replaces view */
        chip?: AKlaraDashboardDealChipValues
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDealsListData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/deals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantDealsDetail
     * @summary Sales Company Users Sales Assistant Prospect detail
     * @request GET:/saas_company_users/sales_assistant/deals/{external_id}
     */
    salesAssistantDealsDetail: (externalId: string, params: RequestParams = {}) =>
      this.request<ASalesAssistantDealsDetailData, void>({
        path: `/saas_company_users/sales_assistant/deals/${externalId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantSalesPeopleList
     * @summary List of sales people info saas company user
     * @request GET:/saas_company_users/sales_assistant/sales_people
     */
    salesAssistantSalesPeopleList: (
      query?: {
        /** Selling External ID */
        selling_external_id?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantSalesPeopleListData, void>({
        path: `/saas_company_users/sales_assistant/sales_people`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantSalesPeopleSelectBoxIndexList
     * @summary List of sales people with basic data for saas company user
     * @request GET:/saas_company_users/sales_assistant/sales_people/select_box_index
     */
    salesAssistantSalesPeopleSelectBoxIndexList: (
      query?: {
        /** Selling External ID */
        selling_external_id?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantSalesPeopleSelectBoxIndexListData, void>({
        path: `/saas_company_users/sales_assistant/sales_people/select_box_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantCreateCallCreate
     * @summary Call command for create AI call
     * @request POST:/saas_company_users/sales_assistant/create_call
     */
    salesAssistantCreateCallCreate: (params: RequestParams = {}) =>
      this.request<ASalesAssistantCreateCallCreateData, void>({
        path: `/saas_company_users/sales_assistant/create_call`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantSettingsList
     * @summary Detail of sales assistant sales person settings
     * @request GET:/saas_company_users/sales_assistant/settings
     */
    salesAssistantSettingsList: (params: RequestParams = {}) =>
      this.request<ASalesAssistantSettingsListData, void>({
        path: `/saas_company_users/sales_assistant/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantSettingsPartialUpdate
     * @summary Update settings for Sales Assistant Sales Person
     * @request PATCH:/saas_company_users/sales_assistant/settings
     */
    salesAssistantSettingsPartialUpdate: (
      data: {
        sales_person: ASalesAssistantSalesPersonSettingsAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantSettingsPartialUpdateData, void>({
        path: `/saas_company_users/sales_assistant/settings`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantTasksPartialUpdate
     * @summary Update task with marked as complete and next step
     * @request PATCH:/saas_company_users/sales_assistant/tasks
     */
    salesAssistantTasksPartialUpdate: (
      data: {
        task?: ASalesAssistantTaskParams
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantTasksPartialUpdateData, void>({
        path: `/saas_company_users/sales_assistant/tasks`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantTasksCreate
     * @summary Update task with marked as complete and next step
     * @request POST:/saas_company_users/sales_assistant/tasks
     */
    salesAssistantTasksCreate: (
      data: {
        task?: ASalesAssistantTaskCreateParams
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantTasksCreateData, void>({
        path: `/saas_company_users/sales_assistant/tasks`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesAssistant
     * @name SalesAssistantUpdateCenterList
     * @summary List of update center entries for sales person company
     * @request GET:/saas_company_users/sales_assistant/update_center
     */
    salesAssistantUpdateCenterList: (
      query?: {
        search?: string
        /** Single day; cannot be combined with from/to */
        date?: string
        /** Sales person external_id */
        sales_person_external_id?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
        /** Klara dashboard mode; the from/to/deal_id params apply only with dashboard=true */
        dashboard?: ASalesAssistantUpdateCenterListParamsDashboardEnum
        /**
         * Dashboard mode: yyyy-MM-dd, inclusive; requires to
         * @format date
         */
        from?: string
        /**
         * Dashboard mode: yyyy-MM-dd, inclusive; alone means up to this day
         * @format date
         */
        to?: string
        /** Dashboard mode: Klara deal id; events are pruned to this deal */
        deal_id?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantUpdateCenterListData, void | AKlaraValidationErrors>({
        path: `/saas_company_users/sales_assistant/update_center`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesActivityFeedsList
     * @summary Company activity feed for the current sales cycle
     * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/activity_feeds
     */
    salesCyclesActivityFeedsList: (
      salesCycleId: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityFeedsListOutput, void>({
        path: `/saas_company_users/sales_cycles/${salesCycleId}/activity_feeds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
     */
    salesCyclesAssignmentsReportingList: (salesCycleId: number, id: string, params: RequestParams = {}) =>
      this.request<ASalesCyclesAssignmentsReportingListOutput, void>({
        path: `/saas_company_users/sales_cycles/${salesCycleId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
     */
    salesCyclesSalesCycleIterationsAssignmentsReportingList: (
      salesCycleId: number,
      salesCycleIterationId: number,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsAssignmentsReportingListOutput, void>({
        path: `/saas_company_users/sales_cycles/${salesCycleId}/sales_cycle_iterations/${salesCycleIterationId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesSalesCycleIterationsReportingList
     * @summary Sales cycle iteration reporting data
     * @request GET:/saas_company_users/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
     */
    salesCyclesSalesCycleIterationsReportingList: (salesCycleId: number, id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesCycleIterationsReportingListOutput, void>({
        path: `/saas_company_users/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesList
     * @summary List of all saas sales cycles for saas company
     * @request GET:/saas_company_users/sales_cycles
     */
    salesCyclesList: (
      query: {
        /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
        start_date: string
        /** SalesCycle search on names */
        search?: string
        /** Sort by values */
        sort_by?: ASaasSalesCycleSortByValues
        /** Sort by direction */
        sort_direction?: ASaasSalesCycleSortDirectionValues
        /** Country filter */
        country_id?: number
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesListData, void>({
        path: `/saas_company_users/sales_cycles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesSalesIntelligenceIndexList
     * @summary List of all saas sales cycles for saas company and sales intelligence
     * @request GET:/saas_company_users/sales_cycles/sales_intelligence_index
     */
    salesCyclesSalesIntelligenceIndexList: (
      query: {
        /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
        start_date: string
        /** SalesCycle search on names */
        search?: string
        /** Sort by values */
        sort_by?: ASaasSalesCycleSortByValues
        /** Sort by direction */
        sort_direction?: ASaasSalesCycleSortDirectionValues
        /** Country filter */
        country_id?: number
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesIntelligenceIndexListData, void>({
        path: `/saas_company_users/sales_cycles/sales_intelligence_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesDetail
     * @summary Saas sales cycle detail
     * @request GET:/saas_company_users/sales_cycles/{id}
     */
    salesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailResult, void>({
        path: `/saas_company_users/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesReportingList
     * @summary SAAS sales cycle reporting data
     * @request GET:/saas_company_users/sales_cycles/{id}/reporting
     */
    salesCyclesReportingList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesReportingListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesNewsAndInsightsList
     * @summary Sales cycle / sales cycle iteration news and insights
     * @request GET:/saas_company_users/sales_cycles/{id}/news_and_insights
     */
    salesCyclesNewsAndInsightsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesNewsAndInsightsListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/news_and_insights`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesActivitiesChartList
     * @summary Sales cycle activities chart data
     * @request GET:/saas_company_users/sales_cycles/{id}/activities_chart
     */
    salesCyclesActivitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivitiesChartListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/activities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesClientsReachedChartList
     * @summary Sales cycle clients reached chart data
     * @request GET:/saas_company_users/sales_cycles/{id}/clients_reached_chart
     */
    salesCyclesClientsReachedChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesClientsReachedChartListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/clients_reached_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesActivityOccurrencesChartList
     * @summary Activity occurrences chart data
     * @request GET:/saas_company_users/sales_cycles/{id}/activity_occurrences_chart
     */
    salesCyclesActivityOccurrencesChartList: (
      id: number,
      query: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        activity_event: AActivityEvents
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityOccurrencesChartListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/activity_occurrences_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesOpportunitiesChartList
     * @summary Opportunities chart data
     * @request GET:/saas_company_users/sales_cycles/{id}/opportunities_chart
     */
    salesCyclesOpportunitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesOpportunitiesChartListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/opportunities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesProspectsList
     * @summary Admins list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
     * @request GET:/saas_company_users/sales_cycles/{id}/prospects
     */
    salesCyclesProspectsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        /** Search query */
        search?: string
        /** Last changed within */
        last_change?: string
        "statuses[]"?: string[]
        "stages[]"?: string[]
        "segments[]"?: string[]
        /** Sort by values */
        sort_by?: ASalesCyclesProspectValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesProspectsAutocompleteValuesList
     * @summary Returns the 10 most similar autocomplete values for specified field and value
     * @request GET:/saas_company_users/sales_cycles/{id}/prospects_autocomplete_values
     */
    salesCyclesProspectsAutocompleteValuesList: (
      id: number,
      query: {
        /** Autocomplete field */
        field: ASalesCycleProspectAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsAutocompleteValuesListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/prospects_autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/SalesCycles
     * @name SalesCyclesSalesNewsList
     * @summary Sales cycle - current iteration sales news
     * @request GET:/saas_company_users/sales_cycles/{id}/sales_news
     */
    salesCyclesSalesNewsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesNewsListOutput, void>({
        path: `/saas_company_users/sales_cycles/${id}/sales_news`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/Users
     * @name UsersList
     * @summary List of all users for saas company
     * @request GET:/saas_company_users/users
     */
    usersList: (
      query?: {
        /** User search on names and email */
        search?: string
        /** Sort by values */
        sort_by?: AUsersListParamsSortByEnum
        /** Sort by direction */
        sort_direction?: AUsersListParamsSortDirectionEnum
        /** Filter by user status */
        status?: AUsersListParamsStatusEnum[]
        /** Filter by user role */
        role?: AUsersListParamsRoleEnum[]
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AUsersListData, void>({
        path: `/saas_company_users/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/Users
     * @name UsersDeactivateCreate
     * @summary Deactivate user
     * @request POST:/saas_company_users/users/{id}/deactivate
     */
    usersDeactivateCreate: (id: number, params: RequestParams = {}) =>
      this.request<AUsersDeactivateCreateData, void>({
        path: `/saas_company_users/users/${id}/deactivate`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/Users
     * @name UsersActivateCreate
     * @summary Activate user
     * @request POST:/saas_company_users/users/{id}/activate
     */
    usersActivateCreate: (id: number, params: RequestParams = {}) =>
      this.request<AUsersActivateCreateData, void>({
        path: `/saas_company_users/users/${id}/activate`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasCompanyUsers/Users
     * @name UsersStatsList
     * @summary Get user role counts
     * @request GET:/saas_company_users/users/stats
     */
    usersStatsList: (params: RequestParams = {}) =>
      this.request<AUsersStatsListData, void>({
        path: `/saas_company_users/users/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  saasSalesPeople = {
    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name DashboardList
     * @summary Saas Sales Person dashboard data
     * @request GET:/saas_sales_people/dashboard
     */
    dashboardList: (params: RequestParams = {}) =>
      this.request<ADashboardListResult, void>({
        path: `/saas_sales_people/dashboard`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsList
     * @summary List of drafted prospects for advanced search session
     * @request GET:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsListResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
     * @summary List of detailed drafted prospects for advanced search session
     * @request GET:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
     */
    leadsAdvancedSearchSessionsDraftedProspectsDetailedList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADetailedDraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADetailedDraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/detailed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate
     * @summary Download selected drafted prospects in the EXCEL
     * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/download_as_excel
     */
    leadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDownloadAsExcelCreateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/download_as_excel`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
     * @summary Mark drafted prospect as viewed
     * @request PATCH:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
     */
    leadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}/viewed`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
     * @summary Transfer selected drafted prospects into assignment prospects
     * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/add_to_prospects`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
     * @summary Search for new drafted prospects using AI
     * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate: (
      advancedSearchSessionId: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_drafted_prospects`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
     * @summary Search for contact information of selected drafted prospects
     * @request POST:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_contact_information`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
     * @summary Soft deletes drafted prospect
     * @request DELETE:/saas_sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
     */
    leadsAdvancedSearchSessionsDraftedProspectsDelete: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDeleteResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SaasSalesPeople
     * @name LeadsAdvancedSearchSessionsCreate
     * @summary Create advanced search sessions
     * @request POST:/saas_sales_people/leads/advanced_search_sessions
     */
    leadsAdvancedSearchSessionsCreate: (
      data: {
        assignment_id?: number
        advanced_search_filter?: AAdvancedSearchFilter
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsCreateResult, void>({
        path: `/saas_sales_people/leads/advanced_search_sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsLeadsForAssignmentList
     * @summary List of all assignment leads
     * @request GET:/saas_sales_people/leads/assignments/{id}/leads_for_assignment
     */
    leadsAssignmentsLeadsForAssignmentList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Contact person name search query */
        contact_person_search?: string
        /** Organization name search query */
        organization_name_search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "cities[]"?: string[]
        phone_number_present?: boolean
        email_present?: boolean
        contacted_already?: boolean
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsLeadsForAssignmentListOutput, void>({
        path: `/saas_sales_people/leads/assignments/${id}/leads_for_assignment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add prospect to sales cycle from the leads database
     * @request POST:/saas_sales_people/leads/assignments/{id}/add_prospect_from_lead
     */
    leadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      query: {
        lead_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsAddProspectFromLeadCreateOutput, void>({
        path: `/saas_sales_people/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsUploadProspectsCreate
     * @summary Assignment upload prospects for SAAS Sales People
     * @request POST:/saas_sales_people/prospects/assignments/{id}/upload_prospects
     */
    prospectsAssignmentsUploadProspectsCreate: (
      id: number,
      data: {
        /** Attach prospect import file */
        prospects_file: File
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsUploadProspectsCreateOutput, any>({
        path: `/saas_sales_people/prospects/assignments/${id}/upload_prospects`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsPrepareToApproveList
     * @summary List of all prospects for assignment waiting to send for approve
     * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_prepare_to_approve
     */
    prospectsAssignmentsProspectsPrepareToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsPrepareToApproveListResult, void>({
        path: `/saas_sales_people/prospects/assignments/${id}/prospects_prepare_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsWaitingToApproveList
     * @summary List of all prospects for assignment waiting to approve by company / admin
     * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_waiting_to_approve
     */
    prospectsAssignmentsProspectsWaitingToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsWaitingToApproveListOutput, void>({
        path: `/saas_sales_people/prospects/assignments/${id}/prospects_waiting_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsFinishedList
     * @summary List of all prospects for assignment already finished
     * @request GET:/saas_sales_people/prospects/assignments/{id}/prospects_finished
     */
    prospectsAssignmentsProspectsFinishedList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsFinishedListResponse, void>({
        path: `/saas_sales_people/prospects/assignments/${id}/prospects_finished`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/Prospects
     * @name ProspectsAssignmentsDownloadProspectsList
     * @summary Download all prospects as Excel for an assignment
     * @request GET:/saas_sales_people/prospects/assignments/{id}/download_prospects
     */
    prospectsAssignmentsDownloadProspectsList: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsDownloadProspectsListResult, void>({
        path: `/saas_sales_people/prospects/assignments/${id}/download_prospects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsSendForApprovalCreate
     * @summary Send assignment prospects in the sales person draft status for approval
     * @request POST:/saas_sales_people/prospects/assignments/{id}/send_for_approval
     */
    prospectsAssignmentsSendForApprovalCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsSendForApprovalCreateResult, void>({
        path: `/saas_sales_people/prospects/assignments/${id}/send_for_approval`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesDetail
     * @summary Sales Cycle detail for SAAS Sales Person Prospects
     * @request GET:/saas_sales_people/prospects/sales_cycles/{id}
     */
    prospectsSalesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsSalesCyclesDetailResponse, void>({
        path: `/saas_sales_people/prospects/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantDealsList
     * @summary List of all prospects for assignment waiting to send for approve
     * @request GET:/saas_sales_people/sales_assistant/deals
     */
    salesAssistantDealsList: (
      query?: {
        /** Search query */
        search?: string
        "priorities[]"?: string[]
        "planned_task_types[]"?: ASalesAssistantDealPlannedTaskTypes[]
        /** Sort by values */
        sort_by?: ASalesAssistantDealSortByValues
        /** Sort by direction */
        sort_direction?: ASalesAssistantDealSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantDealsListResult, void>({
        path: `/saas_sales_people/sales_assistant/deals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantDealsDetail
     * @summary Saas People Sales Assistant Prospect detail
     * @request GET:/saas_sales_people/sales_assistant/deals/{external_id}
     */
    salesAssistantDealsDetail: (externalId: string, params: RequestParams = {}) =>
      this.request<ASalesAssistantDealsDetailResult, void>({
        path: `/saas_sales_people/sales_assistant/deals/${externalId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantSalesPeopleList
     * @summary List of sales cycles for sales person company
     * @request GET:/saas_sales_people/sales_assistant/sales_people
     */
    salesAssistantSalesPeopleList: (
      query?: {
        /** Selling External ID */
        selling_external_id?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantSalesPeopleListResult, void>({
        path: `/saas_sales_people/sales_assistant/sales_people`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantCreateCallCreate
     * @summary Call command for create AI call
     * @request POST:/saas_sales_people/sales_assistant/create_call
     */
    salesAssistantCreateCallCreate: (params: RequestParams = {}) =>
      this.request<ASalesAssistantCreateCallCreateResult, void>({
        path: `/saas_sales_people/sales_assistant/create_call`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantSettingsList
     * @summary Detail of sales assistant sales person settings
     * @request GET:/saas_sales_people/sales_assistant/settings
     */
    salesAssistantSettingsList: (params: RequestParams = {}) =>
      this.request<ASalesAssistantSettingsListResult, void>({
        path: `/saas_sales_people/sales_assistant/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantSettingsPartialUpdate
     * @summary Update settings for Sales Assistant Sales Person
     * @request PATCH:/saas_sales_people/sales_assistant/settings
     */
    salesAssistantSettingsPartialUpdate: (
      data: {
        sales_person: ASalesAssistantSalesPersonSettingsAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantSettingsPartialUpdateResult, void>({
        path: `/saas_sales_people/sales_assistant/settings`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantTasksPartialUpdate
     * @summary Update task with marked as complete and next step
     * @request PATCH:/saas_sales_people/sales_assistant/tasks
     */
    salesAssistantTasksPartialUpdate: (
      data: {
        task?: ASalesAssistantTaskParams
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantTasksPartialUpdateResult, void>({
        path: `/saas_sales_people/sales_assistant/tasks`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantTasksCreate
     * @summary Update task with marked as complete and next step
     * @request POST:/saas_sales_people/sales_assistant/tasks
     */
    salesAssistantTasksCreate: (
      data: {
        task?: ASalesAssistantTaskCreateParams
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantTasksCreateResult, void>({
        path: `/saas_sales_people/sales_assistant/tasks`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesAssistant
     * @name SalesAssistantUpdateCenterList
     * @summary List of update center entries for sales person company
     * @request GET:/saas_sales_people/sales_assistant/update_center
     */
    salesAssistantUpdateCenterList: (
      query?: {
        search?: string
        date?: string
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesAssistantUpdateCenterListResult, void>({
        path: `/saas_sales_people/sales_assistant/update_center`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesActivityFeedsList
     * @summary Saas sales person activity feed for the current sales cycle
     * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/activity_feeds
     */
    salesCyclesActivityFeedsList: (
      salesCycleId: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityFeedsListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${salesCycleId}/activity_feeds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
     */
    salesCyclesAssignmentsReportingList: (salesCycleId: number, id: string, params: RequestParams = {}) =>
      this.request<ASalesCyclesAssignmentsReportingListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${salesCycleId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
     */
    salesCyclesSalesCycleIterationsAssignmentsReportingList: (
      salesCycleId: number,
      salesCycleIterationId: number,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsAssignmentsReportingListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${salesCycleId}/sales_cycle_iterations/${salesCycleIterationId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesSalesCycleIterationsReportingList
     * @summary Sales cycle iteration reporting data
     * @request GET:/saas_sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
     */
    salesCyclesSalesCycleIterationsReportingList: (salesCycleId: number, id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesCycleIterationsReportingListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesDetail
     * @summary Saas sales cycle detail
     * @request GET:/saas_sales_people/sales_cycles/{id}
     */
    salesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailOutput, void>({
        path: `/saas_sales_people/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesSalesNewsList
     * @summary Sales cycle - current iteration sales news
     * @request GET:/saas_sales_people/sales_cycles/{id}/sales_news
     */
    salesCyclesSalesNewsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesNewsListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/sales_news`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesSalesIntelligenceIndexList
     * @summary List of all saas sales cycles for saas sales person and sales intelligence
     * @request GET:/saas_sales_people/sales_cycles/sales_intelligence_index
     */
    salesCyclesSalesIntelligenceIndexList: (
      query: {
        /** Start date for iteration in 2024-08-01 format. Dates are received in dashboard */
        start_date: string
        /** SalesCycle search on names */
        search?: string
        /** Sort by values */
        sort_by?: ASaasSalesCycleSortByValues
        /** Sort by direction */
        sort_direction?: ASaasSalesCycleSortDirectionValues
        /** Country filter */
        country_id?: number
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesIntelligenceIndexListResult, void>({
        path: `/saas_sales_people/sales_cycles/sales_intelligence_index`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesReportingList
     * @summary Sales cycle reporting data
     * @request GET:/saas_sales_people/sales_cycles/{id}/reporting
     */
    salesCyclesReportingList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesReportingListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesActivitiesChartList
     * @summary Sales cycle activities chart data
     * @request GET:/saas_sales_people/sales_cycles/{id}/activities_chart
     */
    salesCyclesActivitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivitiesChartListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/activities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesClientsReachedChartList
     * @summary Sales cycle clients reached chart data
     * @request GET:/saas_sales_people/sales_cycles/{id}/clients_reached_chart
     */
    salesCyclesClientsReachedChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesClientsReachedChartListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/clients_reached_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesActivityOccurrencesChartList
     * @summary Activity occurrences chart data
     * @request GET:/saas_sales_people/sales_cycles/{id}/activity_occurrences_chart
     */
    salesCyclesActivityOccurrencesChartList: (
      id: number,
      query: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        activity_event: AActivityEvents
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityOccurrencesChartListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/activity_occurrences_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesOpportunitiesChartList
     * @summary Opportunities chart data
     * @request GET:/saas_sales_people/sales_cycles/{id}/opportunities_chart
     */
    salesCyclesOpportunitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesOpportunitiesChartListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/opportunities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesProspectsList
     * @summary SalesPeople list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
     * @request GET:/saas_sales_people/sales_cycles/{id}/prospects
     */
    salesCyclesProspectsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        /** Search query */
        search?: string
        /** Last changed within */
        last_change?: string
        "statuses[]"?: string[]
        "stages[]"?: string[]
        "segments[]"?: string[]
        /** Sort by values */
        sort_by?: ASalesCyclesProspectValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SaasSalesPeople/SalesCycles
     * @name SalesCyclesProspectsAutocompleteValuesList
     * @summary Admins the 10 most similar autocomplete values for specified field and value
     * @request GET:/saas_sales_people/sales_cycles/{id}/prospects_autocomplete_values
     */
    salesCyclesProspectsAutocompleteValuesList: (
      id: number,
      query: {
        /** Autocomplete field */
        field: ASalesCycleProspectAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsAutocompleteValuesListResponse, void>({
        path: `/saas_sales_people/sales_cycles/${id}/prospects_autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  salesCycles = {
    /**
     * No description
     *
     * @tags SalesCycles
     * @name SalesCyclesList
     * @summary List of all sales cycles
     * @request GET:/sales_cycles
     */
    salesCyclesList: (
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesListResult, void>({
        path: `/sales_cycles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name SalesCyclesCreate
     * @summary Create sales cycle
     * @request POST:/sales_cycles
     */
    salesCyclesCreate: (
      data: {
        sales_cycle: {
          country_id: number
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesCreateData, void>({
        path: `/sales_cycles`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name SalesCyclesDetail
     * @summary Sales cycle detail
     * @request GET:/sales_cycles/{id}
     */
    salesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailResponse, void>({
        path: `/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name SalesCyclesPartialUpdate
     * @summary Update sales cycle
     * @request PATCH:/sales_cycles/{id}
     */
    salesCyclesPartialUpdate: (
      id: number,
      data: {
        sales_cycle?: ASalesCycleAttributes
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesPartialUpdateData, void>({
        path: `/sales_cycles/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name FinalizeCreate
     * @summary Finalize sales cycle process
     * @request POST:/sales_cycles/{id}/finalize
     */
    finalizeCreate: (id: number, params: RequestParams = {}) =>
      this.request<AFinalizeCreateData, void | AErrors>({
        path: `/sales_cycles/${id}/finalize`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name FinalizeKeyDetailsCreate
     * @summary Finalize key details for sales cycle
     * @request POST:/sales_cycles/{id}/finalize_key_details
     */
    finalizeKeyDetailsCreate: (id: number, params: RequestParams = {}) =>
      this.request<AFinalizeKeyDetailsCreateData, void | AErrors>({
        path: `/sales_cycles/${id}/finalize_key_details`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name PackagesList
     * @summary List of all packages for sales cycle
     * @request GET:/sales_cycles/{id}/packages
     */
    packagesList: (id: number, params: RequestParams = {}) =>
      this.request<APackagesListResult, void>({
        path: `/sales_cycles/${id}/packages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesCycles
     * @name RemoveAttachmentDelete
     * @summary Remove sales cycle attachment
     * @request DELETE:/sales_cycles/{id}/remove_attachment
     */
    removeAttachmentDelete: (
      id: number,
      query: {
        attachment_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ARemoveAttachmentDeleteData, void>({
        path: `/sales_cycles/${id}/remove_attachment`,
        method: "DELETE",
        query: query,
        ...params,
      }),
  }
  salesPeople = {
    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsList
     * @summary List of drafted prospects for advanced search session
     * @request GET:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsListOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDetailedList
     * @summary List of detailed drafted prospects for advanced search session
     * @request GET:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/detailed
     */
    leadsAdvancedSearchSessionsDraftedProspectsDetailedList: (
      advancedSearchSessionId: number,
      query?: {
        /** Search query */
        search?: string
        /** Sort by values */
        sort_by?: ADetailedDraftedProspectSortByValues
        /** Sort by direction */
        sort_direction?: ADetailedDraftedProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDetailedListOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/detailed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate
     * @summary Mark drafted prospect as viewed
     * @request PATCH:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}/viewed
     */
    leadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdate: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsViewedPartialUpdateOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}/viewed`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate
     * @summary Transfer selected drafted prospects into assignment prospects
     * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/add_to_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsAddToProspectsCreateOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/add_to_prospects`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate
     * @summary Search for new drafted prospects using AI
     * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_drafted_prospects
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreate: (
      advancedSearchSessionId: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForDraftedProspectsCreateOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_drafted_prospects`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate
     * @summary Search for contact information of selected drafted prospects
     * @request POST:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/search_for_contact_information
     */
    leadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreate: (
      advancedSearchSessionId: number,
      query: {
        /** Drafted prospects IDs */
        "ids[]": number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsSearchForContactInformationCreateOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/search_for_contact_information`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsDraftedProspectsDelete
     * @summary Soft deletes drafted prospect
     * @request DELETE:/sales_people/leads/advanced_search_sessions/{advanced_search_session_id}/drafted_prospects/{id}
     */
    leadsAdvancedSearchSessionsDraftedProspectsDelete: (
      advancedSearchSessionId: number,
      id: number,
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsDraftedProspectsDeleteOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions/${advancedSearchSessionId}/drafted_prospects/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdvancedSearch/SalesPeople
     * @name LeadsAdvancedSearchSessionsCreate
     * @summary Create advanced search sessions
     * @request POST:/sales_people/leads/advanced_search_sessions
     */
    leadsAdvancedSearchSessionsCreate: (
      data: {
        assignment_id?: number
        advanced_search_filter?: AAdvancedSearchFilter
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAdvancedSearchSessionsCreateOutput, void>({
        path: `/sales_people/leads/advanced_search_sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsLeadsForAssignmentList
     * @summary List of all assignment leads
     * @request GET:/sales_people/leads/assignments/{id}/leads_for_assignment
     */
    leadsAssignmentsLeadsForAssignmentList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Contact person name search query */
        contact_person_search?: string
        /** Organization name search query */
        organization_name_search?: string
        "country_ids[]"?: number[]
        "positions[]"?: string[]
        "segments[]"?: string[]
        "cities[]"?: string[]
        phone_number_present?: boolean
        email_present?: boolean
        contacted_already?: boolean
        "company_sizes[]"?: ACompanySizesFilters[]
        "ids[]"?: number[]
        /** Sort by values */
        sort_by?: ALeadSortByValues
        /** Sort by direction */
        sort_direction?: ALeadSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsLeadsForAssignmentListResponse, void>({
        path: `/sales_people/leads/assignments/${id}/leads_for_assignment`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name LeadsAssignmentsAddProspectFromLeadCreate
     * @summary Add prospect to sales cycle from the leads database
     * @request POST:/sales_people/leads/assignments/{id}/add_prospect_from_lead
     */
    leadsAssignmentsAddProspectFromLeadCreate: (
      id: number,
      query: {
        lead_id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ALeadsAssignmentsAddProspectFromLeadCreateResponse, void>({
        path: `/sales_people/leads/assignments/${id}/add_prospect_from_lead`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsPrepareToApproveList
     * @summary List of all prospects for assignment waiting to send for approve
     * @request GET:/sales_people/prospects/assignments/{id}/prospects_prepare_to_approve
     */
    prospectsAssignmentsProspectsPrepareToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsPrepareToApproveListOutput, void>({
        path: `/sales_people/prospects/assignments/${id}/prospects_prepare_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsWaitingToApproveList
     * @summary List of all prospects for assignment waiting to approve by company / admin
     * @request GET:/sales_people/prospects/assignments/{id}/prospects_waiting_to_approve
     */
    prospectsAssignmentsProspectsWaitingToApproveList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsWaitingToApproveListResponse, void>({
        path: `/sales_people/prospects/assignments/${id}/prospects_waiting_to_approve`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsProspectsFinishedList
     * @summary List of all prospects for assignment already finished
     * @request GET:/sales_people/prospects/assignments/{id}/prospects_finished
     */
    prospectsAssignmentsProspectsFinishedList: (
      id: number,
      query?: {
        /** Search query */
        search?: string
        /** Segment substring filter */
        segment?: string
        /** Sort by values */
        sort_by?: AProspectSortByValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Status filter */
        status?: AProspectQueryStatusValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<AProspectsAssignmentsProspectsFinishedListPayload, void>({
        path: `/sales_people/prospects/assignments/${id}/prospects_finished`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsAssignmentsSendForApprovalCreate
     * @summary Send assignment prospects in the sales person draft status for approval
     * @request POST:/sales_people/prospects/assignments/{id}/send_for_approval
     */
    prospectsAssignmentsSendForApprovalCreate: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsAssignmentsSendForApprovalCreateOutput, void>({
        path: `/sales_people/prospects/assignments/${id}/send_for_approval`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prospects
     * @name ProspectsSalesCyclesDetail
     * @summary Sales Cycle detail for Sales Person Prospects
     * @request GET:/sales_people/prospects/sales_cycles/{id}
     */
    prospectsSalesCyclesDetail: (id: number, params: RequestParams = {}) =>
      this.request<AProspectsSalesCyclesDetailPayload, void>({
        path: `/sales_people/prospects/sales_cycles/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActivityFeeds
     * @name SalesCyclesActivityFeedsList
     * @summary Sales person activity feed for the current sales cycle
     * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/activity_feeds
     */
    salesCyclesActivityFeedsList: (
      salesCycleId: number,
      query?: {
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityFeedsListPayload, void>({
        path: `/sales_people/sales_cycles/${salesCycleId}/activity_feeds`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/assignments/{id}/reporting
     */
    salesCyclesAssignmentsReportingList: (salesCycleId: number, id: string, params: RequestParams = {}) =>
      this.request<ASalesCyclesAssignmentsReportingListPayload, void>({
        path: `/sales_people/sales_cycles/${salesCycleId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesSalesCycleIterationsAssignmentsReportingList
     * @summary Assignment reporting data
     * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{sales_cycle_iteration_id}/assignments/{id}/reporting
     */
    salesCyclesSalesCycleIterationsAssignmentsReportingList: (
      salesCycleId: number,
      salesCycleIterationId: number,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesSalesCycleIterationsAssignmentsReportingListPayload, void>({
        path: `/sales_people/sales_cycles/${salesCycleId}/sales_cycle_iterations/${salesCycleIterationId}/assignments/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesSalesCycleIterationsReportingList
     * @summary Sales cycle iteration reporting data
     * @request GET:/sales_people/sales_cycles/{sales_cycle_id}/sales_cycle_iterations/{id}/reporting
     */
    salesCyclesSalesCycleIterationsReportingList: (salesCycleId: number, id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesCycleIterationsReportingListPayload, void>({
        path: `/sales_people/sales_cycles/${salesCycleId}/sales_cycle_iterations/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SalesCyclesSalesNewsList
     * @summary Sales cycle - current iteration sales news
     * @request GET:/sales_people/sales_cycles/{id}/sales_news
     */
    salesCyclesSalesNewsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesSalesNewsListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/sales_news`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SalesCyclesDetailsList
     * @summary Sales cycle detail
     * @request GET:/sales_people/sales_cycles/{id}/details
     */
    salesCyclesDetailsList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesDetailsListOutput, void>({
        path: `/sales_people/sales_cycles/${id}/details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesReportingList
     * @summary Sales cycle reporting data
     * @request GET:/sales_people/sales_cycles/{id}/reporting
     */
    salesCyclesReportingList: (id: number, params: RequestParams = {}) =>
      this.request<ASalesCyclesReportingListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/reporting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesActivitiesChartList
     * @summary Sales cycle activities chart data
     * @request GET:/sales_people/sales_cycles/{id}/activities_chart
     */
    salesCyclesActivitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivitiesChartListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/activities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesClientsReachedChartList
     * @summary Sales cycle clients reached chart data
     * @request GET:/sales_people/sales_cycles/{id}/clients_reached_chart
     */
    salesCyclesClientsReachedChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesClientsReachedChartListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/clients_reached_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesActivityOccurrencesChartList
     * @summary Activity occurrences chart data
     * @request GET:/sales_people/sales_cycles/{id}/activity_occurrences_chart
     */
    salesCyclesActivityOccurrencesChartList: (
      id: number,
      query: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        activity_event: AActivityEvents
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesActivityOccurrencesChartListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/activity_occurrences_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesOpportunitiesChartList
     * @summary Opportunities chart data
     * @request GET:/sales_people/sales_cycles/{id}/opportunities_chart
     */
    salesCyclesOpportunitiesChartList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesOpportunitiesChartListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/opportunities_chart`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesProspectsList
     * @summary SalesPeople list of prospects for Sales Cycle, Sales Cycle Iteration or Assignment
     * @request GET:/sales_people/sales_cycles/{id}/prospects
     */
    salesCyclesProspectsList: (
      id: number,
      query?: {
        sales_cycle_iteration_id?: number
        assignment_id?: string
        /** Search query */
        search?: string
        /** Last changed within */
        last_change?: string
        "statuses[]"?: string[]
        "stages[]"?: string[]
        "segments[]"?: string[]
        /** Sort by values */
        sort_by?: ASalesCyclesProspectValues
        /** Sort by direction */
        sort_direction?: AProspectSortDirectionValues
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/prospects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople/SalesCycles
     * @name SalesCyclesProspectsAutocompleteValuesList
     * @summary Sales People the 10 most similar autocomplete values for specified field and value
     * @request GET:/sales_people/sales_cycles/{id}/prospects_autocomplete_values
     */
    salesCyclesProspectsAutocompleteValuesList: (
      id: number,
      query: {
        /** Autocomplete field */
        field: ASalesCycleProspectAutocompleteFields
        /** Search value */
        value: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesCyclesProspectsAutocompleteValuesListPayload, void>({
        path: `/sales_people/sales_cycles/${id}/prospects_autocomplete_values`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SalesPeopleCreate
     * @summary Registers in sales person
     * @request POST:/sales_people
     */
    salesPeopleCreate: (
      data: {
        sales_person: {
          email: string
        }
      },
      query?: {
        lang?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPeopleCreateData, void>({
        path: `/sales_people`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name ConfirmationCreate
     * @summary Resend confirmation email
     * @request POST:/sales_people/confirmation
     */
    confirmationCreate: (
      data: {
        sales_person: {
          email: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<AConfirmationCreateOutput, void>({
        path: `/sales_people/confirmation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name ConfirmationPartialUpdate
     * @summary Confirms email address and saves user details
     * @request PATCH:/sales_people/confirmation
     */
    confirmationPartialUpdate: (
      query: {
        confirmation_token: string
      },
      data: {
        "sales_person[first_name]": string
        "sales_person[last_name]": string
        "sales_person[phone_number]": string
        "sales_person[password]": string
        "sales_person[password_confirmation]": string
        "sales_person[tac_agreement]": boolean
        "sales_person[country_id]": number
        "sales_person[city]": string
        /** Resume file */
        "sales_person[resume]": File
      },
      params: RequestParams = {}
    ) =>
      this.request<
        AConfirmationPartialUpdateResult,
        void | {
          errors: AErrors
        }
      >({
        path: `/sales_people/confirmation`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SalesPeopleDetail
     * @summary Get sales person profile data
     * @request GET:/sales_people/{id}
     */
    salesPeopleDetail: (
      id: number,
      query?: {
        /** To specify sections returned in response */
        section?: ASalesPeopleDetailParamsSectionEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPeopleDetailData, void>({
        path: `/sales_people/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SalesPeoplePartialUpdate
     * @summary Update sales person
     * @request PATCH:/sales_people/{id}
     */
    salesPeoplePartialUpdate: (
      id: number,
      data: {
        sales_person?: ASalesPersonAttributes
      },
      query?: {
        /** To specify sections returned in response */
        section?: ASalesPeoplePartialUpdateParamsSectionEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPeoplePartialUpdateData, void>({
        path: `/sales_people/${id}`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name PublicList
     * @summary Get public sales person data
     * @request GET:/sales_people/{id}/public
     */
    publicList: (id: number, params: RequestParams = {}) =>
      this.request<APublicListData, void>({
        path: `/sales_people/${id}/public`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name AcceptPartialUpdate
     * @summary Accept sales person
     * @request PATCH:/sales_people/{id}/accept
     */
    acceptPartialUpdate: (
      id: number,
      data: {
        sales_person?: AAcceptSalesPerson
      },
      query?: {
        /** To specify sections returned in response */
        section?: AAcceptPartialUpdateParams1SectionEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<AAcceptPartialUpdateResult, void>({
        path: `/sales_people/${id}/accept`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name BusinessDataList
     * @summary Get business data
     * @request GET:/sales_people/{id}/business_data
     */
    businessDataList: (id: number, params: RequestParams = {}) =>
      this.request<ABusinessDataListData, void>({
        path: `/sales_people/${id}/business_data`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name SubmitBusinessDataCreate
     * @summary Submit business data
     * @request POST:/sales_people/{id}/submit_business_data
     */
    submitBusinessDataCreate: (
      id: number,
      data: {
        sales_person: {
          company_name: string
          company_id: string
          street_address: string
          city: string
          postal_code: string
          country_id: number
          state?: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ASubmitBusinessDataCreateData, void>({
        path: `/sales_people/${id}/submit_business_data`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPeople
     * @name DashboardDetail
     * @summary Get sales person dashboard data
     * @request GET:/sales_people/dashboard/{id}
     */
    dashboardDetail: (id: number, params: RequestParams = {}) =>
      this.request<ADashboardDetailResult, void>({
        path: `/sales_people/dashboard/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  salesPlans = {
    /**
     * No description
     *
     * @tags Sales Plans
     * @name SalesPlansList
     * @summary List of all sales plans
     * @request GET:/sales_plans
     */
    salesPlansList: (
      query?: {
        /** SalesPlan search on names */
        search?: string
        /** Sort by values */
        sort_by?: ASalesPlanSortByValues
        /** Sort by direction */
        sort_direction?: ASalesPlanSortDirectionValues
        /** Status filter */
        status?: ASalesPlanQueryStatusValues
        /** Country filter */
        country_id?: number
        /** Page number */
        page?: number
        /** Number of results per page */
        per_page?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ASalesPlansListData, void>({
        path: `/sales_plans`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  }
  settings = {
    /**
     * No description
     *
     * @tags Settings
     * @name SettingsList
     * @summary List of all countries, currencies and other settings
     * @request GET:/settings
     */
    settingsList: (params: RequestParams = {}) =>
      this.request<ASettingsListData, void>({
        path: `/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),
  }
  subscriptions = {
    /**
     * No description
     *
     * @tags Subscriptions
     * @name CheckoutDetail
     * @summary Show order data
     * @request GET:/subscriptions/checkout/{id}
     */
    checkoutDetail: (id: number, params: RequestParams = {}) =>
      this.request<ACheckoutDetailData, void>({
        path: `/subscriptions/checkout/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CheckoutCreate
     * @summary Confirm order with customer data
     * @request POST:/subscriptions/checkout/{id}
     */
    checkoutCreate: (
      id: number,
      data: {
        order?: {
          country_id: number
          payment_method: APaymentMethods
          /** must be true */
          terms_of_service: boolean
          subscription_billing_type: ASubscriptionBillingTypes
          customer_name: string
          customer_email: string
          city: string
          address: string
          postal_code: string
          state?: string
          company_name: string
          company_number: string
          company_tax_number?: string
          company_vat_number?: string
          invoice_detail_id?: number
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ACheckoutCreateData, void>({
        path: `/subscriptions/checkout/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CheckoutUpdate
     * @summary Update order with specific params
     * @request PUT:/subscriptions/checkout/{id}
     */
    checkoutUpdate: (
      id: number,
      data: {
        /** Update specific parameter Country or billing type, that recalculates prices for order */
        order?: {
          country_id?: number
          subscription_billing_type?: ASubscriptionBillingTypes
          company_vat_number?: string
          voucher_code_input?: string
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ACheckoutUpdateData, void>({
        path: `/subscriptions/checkout/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CheckoutPreviewList
     * @summary Show preview order data
     * @request GET:/subscriptions/checkout/{id}/preview
     */
    checkoutPreviewList: (id: number, params: RequestParams = {}) =>
      this.request<ACheckoutPreviewListData, void>({
        path: `/subscriptions/checkout/${id}/preview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CheckoutCreate2
     * @summary Create order for submitted packages
     * @request POST:/subscriptions/checkout
     * @originalName checkoutCreate
     * @duplicate
     */
    checkoutCreate2: (
      data: {
        checkout?: {
          packages: {
            package_id: number
            sales_person_id?: number | null
          }[]
          sales_cycle_id: number
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ACheckoutCreate2Data, void>({
        path: `/subscriptions/checkout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CancelCreate
     * @summary Cancel subscription
     * @request POST:/subscriptions/{id}/cancel
     */
    cancelCreate: (
      id: number,
      data: {
        subscription: {
          cancel_reason: string | null
        }
      },
      params: RequestParams = {}
    ) =>
      this.request<ACancelCreateResult, void>({
        path: `/subscriptions/${id}/cancel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  }
}
